import React, { useState, useEffect, useContext, useRef } from "react";
import PopColorPicker from "./PopColorPicker";
import axios from "axios";
import AuthContext from "../../context/userAuth.context";
import GenderSelect from "./GenderSelction";
import Lottie from "lottie-web";
import CharacterContext from "../../context/CharacterContext";

import Swal from "sweetalert";

var PartsName, skinparts, get;

var GenderSelection = [
  {
    id: 1,
    name: "Male",
    status: "available",
    ColorSvg: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 150 345" enable-background="new 0 0 150 345" xml:space="preserve">
   <g>
       <path fill="#FDDBBA" d="M102.5,68c0,0,27.1,37.7,21.1,52.9c-6.9,17.6-21.1,10.5-21.1,10.5V68z"/>
       <path fill="#244A80" d="M115.9,345h-36c-2.6-1.7,0.7-18.8,0.7-18.8s9.8-3.7,11.5,3.8c1.7,7.6,12.5,10,18.2,10.9
           C114.2,341.6,115.5,343.7,115.9,345z"/>
       <path fill="#244A80" d="M62.5,345h-36c-2.6-1.7,0.7-18.8,0.7-18.8s9.8-3.7,11.5,3.8c1.7,7.6,12.5,10,18.2,10.9
           C60.9,341.6,62.2,343.7,62.5,345z"/>
       <path fill="#A8CCFF" d="M106.2,170.8c0,0-1.6,20.2-3.5,44.4c-2.6,32.9-9.5,114.6-9.5,114.6s-4.6,3.9-14.7,1.8
           c0,0-8.6-28.2-11.2-60.3c0-0.5-0.1-1.1-0.1-1.6C64.8,236.9,61,168,61,168L106.2,170.8z"/>
       <path fill="#8EB2F3" d="M106.8,163.8c0,0-2.2,27.1-4.1,51.4l-35.4,56c0-0.5-0.1-1.1-0.1-1.6C64.8,236.9,61,168,61,168L106.8,163.8z
           "/>
       <path fill="#A8CCFF" d="M96.4,163.8c0,0-25.7,63.9-33.9,88.1c-5.8,17.3-22.3,77.8-22.3,77.8s-7.2,2.2-13.2-2c0,0-6.1-61.8,6.3-79.3
           c6.6-9.3,1.6-96.2,28.3-96.9C88.2,150.7,96.4,163.8,96.4,163.8z"/>
       <path fill="#FFAE73" d="M85,69.6c-3.9,2.1-7.7,2.2-11.1,1.5c-3-0.6-5.6-2-7.5-3.2c-1.9-1.2-3-2.3-3-2.3s0.1-0.2,0.4-0.6
           c1.2-2,4.7-9.1,3.1-20.5c0-0.2,1.1,0.1,2.8,0.5c5.1,1.2,15.3,4.1,15.8,4.2c0,0,0,0,0,0s0.1,2.4,0.5,6.7c0,0.4,0.1,0.8,0.1,1.2
           c0.1,0.5,0.1,1,0.2,1.6C86.8,63.2,85,69.6,85,69.6z"/>
       <path fill="#F9924F" d="M86,55.9c-7.6,1.7-19-9.5-19-9.5c0.8-0.6,1.7-1.1,2.6-1.5c5.1,1.2,15.3,4.1,15.8,4.2c0,0,0,0,0,0
           S85.6,51.6,86,55.9z"/>
       <path fill="#FDDBBA" d="M110.2,153c-0.6,7.3-2.1,12.6-5.5,12.6c0,0-15.1,5.3-33.1,5.5c-3.5,0-8.5-0.7-12.7-1.4
           c-4.2-0.7-7.6-1.4-7.6-1.4c-3.6-0.8-7.6-3.1-7.1-7.2c0.3-2.2,0.5-5,0.6-8.3c0-0.2,0-0.4,0-0.6c0.4-9.6,0.3-22.8,0.4-35.4
           c0-7.8,0.1-15.3,0.4-21.7c0,0-3.6-25,0.4-29.1c4.6-4.8,19.6-6.2,19.8-6.2c0,0,11.8,6.4,20.4,1.6c0,0,12.5,2.9,16.2,6.7
           c1.2,1.3,6.2,9.4,6.4,18.2c0.1,8.9-0.1,18.6-0.2,23.4c-0.1,2.2,0,4.3,0.2,6.5c0.1,1.2,0.2,2.6,0.3,4c0.3,3.1,0.5,6.7,0.8,10.4
           c0.1,1.9,0.2,3.8,0.3,5.7C110.5,142.2,110.6,148.1,110.2,153z"/>
       <g>
           <path fill="#FFAE73" d="M88.6,48.6c0,0-3.1,1.1-7.1,1.7c-5.8,0.8-13.5,0.3-15.9-6.7c-4.1-11.9-9.2-19,2.7-23.8
               c6.4-2.6,10.5-2.7,13.3-1.7c2.4,0.9,3.8,2.6,4.9,4.3C88.8,25.8,93.4,46.5,88.6,48.6z"/>
           <path fill="#0B3563" d="M87.4,15c2.7,0.7,3.9,4.9,1.3,6.7c-4.6,3.2-10.2,1.9-12.3,2.8c-3,1.3-3.5,6.3-3.6,7.9
               c-0.1,1.6-0.3,2.9-4.3,2c-0.7-0.2-1.1-0.1-1.5,0.1c-1.7,1,0.5,5.8,1.1,6.8c0,0,0.9,3.4-1.1,5.1c-0.2,0.2-4.3,2-14-12.9
               c-1.5-2.3-3-7.6-0.6-12.7c2.4-5.1,9.7-11.4,18.4-11.4C77.8,9.5,81.7,13.7,87.4,15z"/>
       </g>
       <path fill="#F8CAA4" d="M80,138.7c1.3,2.4-4.2,5.6-4.2,5.6s-15.2,7.2-30.8,8.5c0-0.2,0-0.4,0-0.6c0.4-9.6,0.3-22.8,0.4-35.4
           C45.3,116.7,77.9,134.7,80,138.7z"/>
       <path fill="#F9924F" d="M108.6,127c-0.4-1.6-1.5-2.8-3-3.5c-1.9-0.9-4.5-2-5.7-2.2c-2-0.4-6-2.7-6.3-1.5c-0.3,1.2,2.8,2.6,2.8,4
           c0,1.4-8.9,4.7-8.6,6.1c0.2,1.4,2.8,4.5,6.2,3.7c3.4-0.8,12-2.8,14-3.4C109.1,129.8,109,128.4,108.6,127z"/>
       <path fill="#FFAE73" d="M101.7,130.6c-0.5,0.8-2.8,3.5-4.4,3.8c-3.7,0.7-14.7,3-14.7,3s-0.9-7,0.9-7.5c1.8-0.5,4.2-4.6,5.4-5.3
           c0.9-0.5,4.6-1.7,7-1.9c0.3,0.4,0.6,0.7,0.6,1.1c0,0.3-0.6,0.8-1.5,1.4c-0.4,0.2-0.9,0.5-1.2,0.7c-0.4,0.2-0.6,0.4-0.5,0.5
           c0.4,0.5,1.9,0.3,3.6-0.2c1.7-0.5,5.5-2.8,6.6-1.4C104.2,125.5,104,126.9,101.7,130.6z"/>
       <path fill="#F8CAA4" d="M60.4,100.4c0,0-0.2,23.8,23.1,29.4c0,0-30.4,1.6-31.1,1.2c-0.8-0.4-5.8-11.2-5.8-11.2L60.4,100.4z"/>
       <path fill="#FDDBBA" d="M46.8,65.4c0,0-7.4,5.1-10.8,21.4c-3.4,16.3-1.8,48.1,2.6,52.1c4.5,4,26.1,7.5,47.6-2c0,0-1-5.3-2.7-7
           c0,0-24.5-5.8-24.6-9.6c-0.2-5.1,2.7-19.5,1.1-27.6C58.5,84.7,46.8,65.4,46.8,65.4z"/>
       <path fill="#F8CAA4" d="M106.1,120.3c0,0,1.1-4.6,1.8-6.3c2.2-5.3-6.6-26.5-5.5-25.9c1.1,0.6,11.5,22.1,11.1,24
           C113.1,114,109.6,115.4,106.1,120.3z"/>
   </g>
   </svg>`,
  },
  {
    id: 2,
    name: "Female",
    status: "available",
    ColorSvg: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 150 345" enable-background="new 0 0 150 345" xml:space="preserve">
   <g>
       <path fill="#0B3563" d="M43.8,99.5c-1.2-2.2,25.3-10.3,25.7,11.8c0,0,49.6-1.2,25.9-28.9c-8.2-9.6-7.4-17.5-7.1-24.8
           c0.2-7.4-5.1-28.8-23.5-26.6c0,0-4.8-2-10.8,1.2C40.5,39.3,9.9,107.7,43.8,99.5z"/>
       <path fill="#FFAE73" d="M124.9,121c0,0,3.2-4.9,5.8-5c2.6-0.1,7.4-1.4,7-0.5c-0.4,1-3.4,1.1-3.7,1.6c-0.3,0.6,4.4,1.4,5.8,1.5
           c1.3,0.1,4.5,0,4.4,0.7c-0.1,0.7-5.7,3.5-9.7,3.1c-4-0.4-8.9,1.2-8.9,1.2L124.9,121z"/>
       <path fill="#FDDBBA" d="M78.2,122.5c0,0,1.8,3.5,4.9,7.5c3.8,4.8,9.7,10.4,17.2,11.4c3.5,0.5,7-0.2,10.2-1.7c0,0,0,0,0,0
           c9-4,15.8-13.2,15.8-13.2c1.6-4.3-1-7.3-1-7.3s-18.2,4.1-19.9,3.2c-1.7-0.9-11.9-30-14.3-33.7c-2.4-3.7-10.6-5.6-10.6-5.6
           L78.2,122.5z"/>
       <path fill="#F8CAA4" d="M83.2,130c3.8,4.8,9.7,10.4,17.2,11.4c3.5,0.5,7-0.2,10.2-1.7c-0.4,0-9.4,1.2-12.9-5.3
           c-3.7-6.6-7.6-17-13.1-13.5C82.2,122.5,82.3,126.3,83.2,130z"/>
       <path fill="#244A80" d="M10.3,319.1c0,0-5.6,5.1-4.5,8.7c1.1,3.6,6.1,6,6.8,10.4c0.7,4.4,3.4,6.8,5.8,6.8c2.4,0,11.6,0,11.6,0
           s1.8-3.1-2.5-4c-4.3-0.9-6-6.1-5.7-10.9c0.3-4.8-0.4-11.2-0.4-11.2l-9.2-2.1L10.3,319.1z"/>
       <path fill="#244A80" d="M57.3,321.3c0,0-2,21.5,0.4,22.7l31.2-0.1c0,0,0-3.6-5-4.4c-5-0.8-13.8-3.7-15.3-10.3
           C67.2,322.7,57.3,321.3,57.3,321.3z"/>
       <path fill="#E8F2FA" d="M70.4,62.9c0,0,1.3,1.7,3.8,1.5c2-0.1,2.8-1.9,2.8-1.9S73.3,61.7,70.4,62.9z"/>
       <path fill="#FDDBBA" d="M37.6,108.1c0,0,0.1,8.7,0.5,16.6c0.3,5.2,0.8,10.1,1.5,11.8c1.9,4.3,4,5,4,5l16.4,4l5.8,1.4l18.2-5.4
           c0,0,8.3-23.1,5-36.1c-3.3-13-8.4-22-8.4-22s-11-3.7-34.1-1.2L37.6,108.1z"/>
       <path fill="#F8CAA4" d="M38.1,119.3c0.3,5.2,0.8,15.4,1.5,17.1c1.9,4.3,4,5,4,5l16.4,4l7.1-2.1c0,0-24.5-10.5-21.9-30.9L38.1,119.3
           z"/>
       <path fill="#FC7600" d="M82.8,145c0,0,9,28,9.6,37.6C93,192.1,75.2,318,74.5,322.4c-0.7,4.1-5.8,6.8-5.8,6.8s-2.4,1.4-5.7,0.4
           c-4.7-1.3-6.2-2.9-6.2-2.9s-7-89.8-2.7-121.9c4.3-32.1,4.4-59.8,4.4-59.8H82.8z"/>
       <path fill="#FF912B" d="M44.7,144.1c0,0-13.7,18.4-15,30.9c-1.3,12.5-2,56.2-4.7,68.3c-2.7,12.1-12.7,35.5-12.7,73.4
           c0,0,1,2.2,4.3,3.3c1,0.4,2.4,0.7,3.7,1c2.7,0.6,5.4-0.7,6.6-3.1c6.8-13.6,28.4-57.6,29.5-66.8c0.8-6.5,7.6-49.2,22.5-74.3
           c3.6-6-2.2-30-2.2-30L44.7,144.1z"/>
       <path fill="#1E3865" d="M84.2,140.6c0,0-3.6,2.9-10.8,3c-8.6,0.2-29.8-2.2-29.8-2.2s-0.9,2.6-0.9,5.4c0,0,25.9,6.5,41,1
           C83.7,147.8,85.7,144.2,84.2,140.6z"/>
       <g>
           <path fill="#FFFFFF" d="M71.6,146.6c0-2.4,1.8-4.4,3.9-4.4c2.2,0,3.9,2,3.9,4.4c0,2.4-1.8,4.4-3.9,4.4
               C73.4,151,71.6,149,71.6,146.6z M72.9,146.6c0,1.7,1.2,3.1,2.6,3.1c1.4,0,2.6-1.4,2.6-3.1c0-1.7-1.2-3.1-2.6-3.1
               C74.1,143.5,72.9,144.9,72.9,146.6z"/>
       </g>
       <path fill="#FFAE73" d="M49.5,162.2c0,0,1.6,3.7,3.6,4.2c2,0.5,3.5,2.4,4.2,2.9c0.7,0.5,2,0.7,1.7,1.3c-0.4,0.6-4-0.5-4.4-0.6
           c-0.5-0.2,2.9,3.4,4,4.5c1.1,1.1,3.6,2.7,3,3.4c-0.6,0.7-7.6-0.1-10.5-2c-1.4-0.9-2.1-4-3.1-6.1c-1-2.1-2.4-3.4-2.4-3.4L49.5,162.2
           z"/>
       <path fill="#FDDBBA" d="M46.4,82.1c0,0-9,0.6-13.7,6.3c-4.8,5.7-13.5,39-11.5,48.3c2,9.3,16.6,29.8,24.9,31.1c0,0,2.4,0,3.8-1.8
           c0.8-1,1.1-2.4,1.1-2.4S48,149,43.6,141.5c-6.1-10.5,0.1-24.3,4.2-28C51.9,109.7,46.4,82.1,46.4,82.1z"/>
       <g>
           <path fill="#FFAE73" d="M57.7,83.5c-3.2-1.5-2.4-0.9-1.5-6.3c0.6-3.6,1-5.8,1-10.7l0.8,0.1L71.8,69c0,0-0.3,3.8-0.3,7.4
               c0,0,0,0.1,0,0.1c0,3.1,0.9,6.2-0.7,7.6C68.7,85.9,61.9,85.5,57.7,83.5z"/>
           <path fill="#F48F4E" d="M71.8,69c0,0-0.3,3.8-0.3,7.4c-7.7-0.2-11.8-6.4-13.5-9.8L71.8,69z"/>
           <path fill="#FFAE73" d="M74.4,73.3c0,0-18.3,0.3-18.3-11.1s-2.4-19.1,9.3-19.7c11.7-0.7,14,3.7,14.9,7.5
               C81.2,53.7,79.2,72.9,74.4,73.3z"/>
           <path fill="#0B3563" d="M73.7,42.2c0,0-5,13.4-12.7,15.4c-7.7,2-11-0.1-11-0.1s5.9-4.7,7.1-12.9C57.1,44.6,70,35.8,73.7,42.2z"/>
           <path fill="#0B3563" d="M72.5,43.2c0,0,3.7,1.4,5.3,4.1c1.5,2.7,2.8,6.2,2.5,10.5c0,0,3.8-9.1-0.5-14.2
               C75.2,38.1,72.5,43.2,72.5,43.2z"/>
       </g>
   </g>
   </svg>`,
  },
  //     {
  //         id: 3,
  //         name: 'Coming Soon',
  //         status: 'ComingSoon',
  //         ColorSvg: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  //         viewBox="0 0 150 345" enable-background="new 0 0 150 345" xml:space="preserve">
  //    <g>
  //        <g>
  //            <path fill="#FFAE73" d="M21,177c0,0-6.4,0.4-9,2.1c-2.6,1.6-5,2.2-4.5,3c0.5,0.7,5.1-0.8,5.1,0c0.1,0.8-4,3.4-5.2,3.6
  //                c-1.2,0.2-3.8,0.6-3.3,2.1c0.5,1.5,4.9,2,8.4,2.1c3.5,0.1,12.1-5.6,12.1-5.6L21,177z"/>
  //            <path fill="#FDDBBA" d="M25.7,185.1c6.5,0,28-14.3,35.2-20.1c0.8-0.6,1.4-1.2,1.8-1.6c2.7-2.7,12-16.3,18.5-28.3
  //                c3.8-6.9,6.7-13.4,6.9-17c0.8-12.9-6-30.9-6-30.9c-20.1,7-22.2,23-22.2,23l-10.3,38.2c-0.5,2-1.7,3.8-3.3,5.2l-27.2,22.6
  //                C18.3,180.1,23.6,185.1,25.7,185.1z"/>
  //            <path fill="#F8CAA4" d="M60.9,164.9c0.8-0.6,1.4-1.2,1.8-1.6c2.7-2.7,12-16.3,18.5-28.3c0.9-7.3,0.3-14.1-2.7-18.9
  //                C78.5,116.2,61.4,146.2,60.9,164.9z"/>
  //            <path fill="#FFAE73" d="M72.5,284.1l3.4,14.2l2.1,8.8l7,29.3c0,0,6,1.9,12.3,0c0,0,2.3-9.7,2.4-21.8c0-6.3-0.5-13.3-2.4-19.9
  //                c-0.7-2.7-1.7-5.3-2.9-7.8C84.4,266.7,72.5,284.1,72.5,284.1z"/>
  //            <path fill="#25468F" d="M66.6,345h33c0,0,0.5-5-0.9-9.8c-0.2-0.7-0.5-1.4-0.8-2.1c0,0-7.4,1.7-13.7,0c0,0-6,5.1-9.6,6.6
  //                C71,341.3,67,340.5,66.6,345z"/>
  //            <path fill="#F48F4E" d="M75.9,298.4l2.1,8.8c3.6,2.3,11.3,6.4,21.7,7.5c0-6.3-0.5-13.3-2.4-19.9c-3-1.5-6.1-2.3-8.8-1.9
  //                C81.9,294,78,296.4,75.9,298.4z"/>
  //            <path fill="#193871" d="M83.8,345h15.9c0,0,0.5-5-0.9-9.8C94.7,336.5,86.6,339.6,83.8,345z"/>
  //            <path fill="#FFAE73" d="M98.8,284.1l3.4,14.2l2.1,8.8l7,29.3c0,0,6,1.9,12.3,0c0,0,2.3-9.7,2.4-21.8c0-6.3-0.5-13.3-2.4-19.9
  //                c-0.7-2.7-1.7-5.3-2.9-7.8C110.7,266.7,98.8,284.1,98.8,284.1z"/>
  //            <path fill="#25468F" d="M124.2,333.1c0,0-7.4,1.7-13.7,0c0,0-6,5.1-9.6,6.6c-3.6,1.6-7.6,0.7-8,5.2h33
  //                C126,345,126.6,338.4,124.2,333.1z"/>
  //            <path fill="#F48F4E" d="M102.2,298.4l2.1,8.8c3.6,2.3,11.3,6.4,21.7,7.5c0-6.3-0.5-13.3-2.4-19.9c-3-1.5-6.1-2.3-8.8-1.9
  //                C108.2,294,104.4,296.4,102.2,298.4z"/>
  //            <path fill="#FF912B" d="M67.7,300.4c12.3,7.8,63.7,2.2,64.1-5.3c0,0-2.5-19-3.4-26.9c-0.4-3.3-0.5-5.9-0.3-7.3
  //                c5.3-35.3,9.8-77,9.3-84.9c-0.1-1.1-0.1-1.7-0.1-1.7s-3.9-0.3-9.7-0.6c-17-0.7-51.1-0.6-56.7,10.6c-5.8,11.4-5.9,77.3-5.9,77.3
  //                C64.9,279.6,67.7,300.4,67.7,300.4z"/>
  //            <path fill="#FC7600" d="M128.4,268.1c-0.4-3.3-0.5-5.9-0.3-7.3c5.3-35.3,9.8-77,9.3-84.9c-0.1-1.1-0.1-1.7-0.1-1.7
  //                s-3.9-0.3-9.7-0.6c-8.8,5.2-14.6,14-14.6,14S114.7,253.8,128.4,268.1z"/>
  //            <path fill="#B5D1F1" d="M104.8,36c0-4.6-2.6-7.9-7.7-8.2c-3.7-0.2-8.9,2-8.9,6.6c0,4.6,3.7,9.9,8.3,9.9S104.8,40.6,104.8,36z"/>
  //            <path fill="#D1E4FC" d="M97.7,69.2c0,0,20-18,4.6-31.9c-1.5-1.3-3.3-2.3-5.3-2.7c-5.4-1.2-17.4-2.8-23.4,3.9
  //                c-6.5,7.2-9.1,12.7-3.7,19.3C75.4,64.3,97.7,69.2,97.7,69.2z"/>
  //            <path fill="#FFAE73" d="M123.8,188.6c0,0-0.9,3.5-0.5,7.6c0.5,5.8,1.6,9,5.3,10.9c0,0,4.3,3,5-0.9c0.7-3.9-0.7-4,0.4-9.4
  //                c1-5.4,0.3-9.5-2.9-12L123.8,188.6z"/>
  //            <path fill="#FFAE73" d="M79.7,69c0,0,0.3,3,0.8,7c0.2,2,0.5,4.2,0.9,6.4c0.3,1.6,0.5,3.2,0.8,4.8l6.8,23l16-25.9
  //                c0,0-3.8-3.1-8.9-20c0-0.2-0.1-0.3-0.1-0.3L79.7,69z"/>
  //            <path fill="#FDDBBA" d="M70.3,182.6c-0.2,2.6,0.4,3.1,0.4,3.1s9.8,3.6,34.6,2.3c2.7-0.1,5.2-0.3,7.6-0.4c16-0.9,24.5-1.9,24.5-1.9
  //                s13.1-30.2-11.5-67.3c-2.8-4.2-6-8.5-9.8-12.8c-4-4.5-4.9-10.6-6.4-16.4c-0.4-1.7,0.8-2,0.2-3.6c0,0-4.5-1.3-4.9-1.3
  //                c-2.5,2.2-5.9,6.6-14.2,7.5c-5.6,0.6-7.8-2.6-8.6-4.5c-2.1,0.8-4.4,2.1-6.2,3c-15.1,7.2-16.5,21.3-16.5,21.3s13.9,45.6,14.7,51.3
  //                C74.6,165.4,71.4,169.3,70.3,182.6z"/>
  //            <path fill="#F48F4E" d="M80.5,76c0.2,2,0.5,4.2,0.9,6.4c17.5-6.8,15.3-16.3,14.8-18.1c0-0.2-0.1-0.3-0.1-0.3S87.1,70.4,80.5,76z"
  //                />
  //            <g>
  //                <path fill="#FFAE73" d="M76.8,78.3c0,0,19.6,0.6,19.8-11.6c0.2-12.2,2.9-20.3-9.6-21.3c-12.5-0.9-15,3.7-16.1,7.8
  //                    S71.7,77.8,76.8,78.3z"/>
  //            </g>
  //            <path fill="#D1E4FC" d="M75.1,43.6c0,0,1.2,23.2,25.1,21.1C100.2,64.7,99.7,33.6,75.1,43.6z"/>
  //            <path fill="#D1E4FC" d="M79.7,45.6c0,0-7.1,4.3-9.3,11.2C70.4,56.9,62.5,45.9,79.7,45.6z"/>
  //            <path fill="#F8CAA4" d="M113,187.6c16-0.9,24.5-1.9,24.5-1.9s13.1-30.2-11.5-67.3C121,129.9,109.3,160.9,113,187.6z"/>
  //            <path fill="#FDDBBA" d="M105,84.3c0,0,18.9,3.9,27.4,13.7c6.5,7.5,13.5,44.1,13.5,50.2c0,5.8-6.6,36.5-10.8,42.4
  //                c-0.3,0.4-0.8,0.6-1.3,0.6l-10.7-1.1c-0.9-0.1-1.5-0.9-1.4-1.8l6-38.9l-21-37.3C106.8,112,94.4,97.3,105,84.3z"/>
  //            <path fill="#FFAE73" d="M123.8,191.1c0,0-2.8,8.1-2.1,8.8c0.7,0.7,2.7-2.5,2.7-2.5L123.8,191.1z"/>
  //        </g>
  //    </g>
  //    </svg>`,
  //     },
  //     {
  //         id: 4,
  //         name: 'Coming Soon',
  //         status: 'ComingSoon',
  //         ColorSvg: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  //         viewBox="0 0 150 345" enable-background="new 0 0 150 345" xml:space="preserve">
  //    <g>
  //        <g>
  //            <path fill="#1E3865" d="M44.8,344.6l-0.5-157.9c0,0-1.2-11.4-11.1-11.4c-10.6-0.1-11.3,11.3-11.3,11.3s0.1,1,1.2,1
  //                c1.1,0,1.3-1,1.3-1s0.5-8.8,8.7-8.7c7.6,0,8.6,8.8,8.6,8.8l-0.9,157.9L44.8,344.6z"/>
  //            <path fill="#1E3865" d="M39.4,344.5l6.6,0l-0.5-6.9c0,0,0.1-1-1.3-1c-1.2-0.1-3.7-0.2-3.9,0.5C40.1,337.8,39.4,344.5,39.4,344.5z"
  //                />
  //        </g>
  //        <path fill="#FFAE73" d="M33.1,166.8l-0.5,2.3c0,0-11.2-0.1-13.8,11.8c0,0-0.7,5,2.9,3.9c3.6-1,3.1-3.6,8.1-4.9
  //            c5.1-1.4,8.4-2.4,9.2-6.1l0.9-4.1L33.1,166.8z"/>
  //        <path fill="#FF912B" d="M73.2,69.2c0,0-3,11.6-5.6,22.2c-1.1,4.3-2,8.4-2.7,11.5c-0.7,3.2-1.1,5.4-1,5.6c2.2,3.6-2,25.5-5.2,33.4
  //            c-0.3,0.7-0.7,1.5-1.2,2.4c-4.5,8.7-16.5,25.9-16.5,25.9s-3.4,0.3-5.6-0.5c-1.8-0.7-3.1-3-3.1-3c0.6-2.2,5.5-21.9,11.1-33.3
  //            c2.4-4.8,6.2-49.9,10.8-56C58.1,72.6,73.2,69.2,73.2,69.2z"/>
  //        <path fill="#FC7600" d="M63.9,108.5c2.2,3.6-2,25.5-5.2,33.4c-0.3,0.7-0.7,1.5-1.2,2.4c-4.2-18.9,3.1-45.7,3.1-45.7
  //            c1.8,0.7,3.2,2.2,4.3,4.2C64.1,106.1,63.7,108.3,63.9,108.5z"/>
  //        <path fill="#06294C" d="M93.6,327.5c0,0,1,17.1-2.2,17.4c-0.4,0-16.4-0.1-16.4-0.1l-20.6-0.1c0,0,0.4-5,6.3-6c6-1,16-5.1,19.6-13
  //            C84.2,317.3,93.6,327.5,93.6,327.5z"/>
  //        <path fill="#0B3563" d="M124.5,327.6c0,0,1,17.1-2.2,17.4c-0.4,0-16.4-0.1-16.4-0.1l-20.6-0.1c0,0,0.4-5,6.3-6c6-1,16-5.1,19.6-13
  //            C115.2,317.5,124.5,327.6,124.5,327.6z"/>
  //        <path fill="#25468F" d="M94.8,286.2c0.5,7.2,1.4,16.6,1,25c-0.6,11.7-1,21.6-1,21.6c-7.8,2.6-21.9-0.7-21.9-0.7S68,302.4,64,278.7
  //            c-1.8-10.6-3.3-19.8-3.8-24.1c-1.8-14,2.5-88.5,2.5-88.5s21-13.3,29.6-6.3c8.6,7,13.9,13.8-0.5,89.5C90.7,255,93.7,270,94.8,286.2z
  //            "/>
  //        <path fill="#1E3865" d="M94.8,286.2c0.5,7.2,1.3,18.8,0.9,27.2c-7.2-7.7-21.5-24.1-31.7-34.7c-1.8-10.6-3.3-19.8-3.8-24.1
  //            c-1.8-14,2.5-88.5,2.5-88.5s21-13.3,29.6-6.3c8.6,7,13.9,13.8-0.5,89.5C90.7,255,93.7,270,94.8,286.2z"/>
  //        <path fill="#25468F" d="M81.6,167.7c0,0,1.4,74.6,4.3,88.4c2.9,13.8,17.8,77.2,17.8,77.2s14.4,1.4,21.9-1.8c0,0-0.3-29.3-2.8-46.5
  //            c-2.3-16.1-6.5-30.8-5.8-36.6c8.5-76.6,2.7-82.9-6.4-89.2C101.5,152.8,81.6,167.7,81.6,167.7z"/>
  //        <path fill="#FFAE73" d="M110.3,174.4c0,0-5,10,4.5,17.7c0,0,4.1,2.9,4.8-0.8c0.7-3.7-0.1-2.4,0.9-7.6c1-5.2-0.2-10.5-3.2-12.9
  //            L110.3,174.4z"/>
  //        <path fill="#FFAE73" d="M68.7,52.2c0,0,5.6,9.2,4.4,17.3l8.5,20.1l15.2-23.1c0,0-7.8-9.2-10.7-21.2L68.7,52.2z"/>
  //        <path fill="#FFAE73" d="M66.1,59.7c0,0,20.9,1,21.4-11.5C88,35.6,93.7,27.3,78,26.1c-12.9-1-17.2,4.4-18.4,8.5
  //            C58.5,38.7,58.4,59,66.1,59.7z"/>
  //        <path fill="#FF912B" d="M116.7,171.5c-4.5,0.4-10.7,0.9-18.2,1.3c-1.5,0.1-3.1,0.2-4.7,0.2c-22.7,1.1-31.7-2.6-31.7-2.6
  //            s-0.6-0.5-0.4-3.2c1.1-13.7,4-17.7,3.7-20.4c-0.8-5.9-14.7-53.8-14.7-53.8s-0.2-15.1,16.7-22.1c1.7-0.7,3.6-1.4,5.8-1.9
  //            c0.7,2,2.7,5.2,7.9,4.7c7.6-0.8,13.1-5.3,15.4-7.6c0.4,0,0.6,0,0.6,0c0.6,1.6,1,3.3,1.4,5c1.3,5.9,2.1,12.2,5.7,16.9
  //            c3.6,4.6,6.6,9.2,9.2,13.7c2.2,3.7,4,7.4,5.6,10.9C133.7,145.7,122,171.1,116.7,171.5z"/>
  //        <path fill="#FC7600" d="M116.7,171.5c-4.5,0.4-10.7,0.9-18.2,1.3c-2-36.9,13.3-72.3,13.3-72.3c0.6,0.4,1.1,0.8,1.6,1.3
  //            c2.6,2.6,4.4,6.3,5.6,10.9C123.4,129.5,119.5,156.7,116.7,171.5z"/>
  //        <path fill="#D1E4FC" d="M59.5,47.7c0,0-4.2,16.1,2.7,18.5c6.9,2.3,25.3,0.6,25.4-19.2c0,0-9.7,5.7-14.3,5.5s-7.6-2.8-11.8-0.8
  //            C61.5,51.6,59.9,51.5,59.5,47.7z"/>
  //        <path fill="#D1E4FC" d="M86.6,30c-0.3-1.3-1.9-2-1.9-2c-11.8-5.2-20.4,0.4-20.4,0.4c7.3-9.7,24.7-7.5,28.3,1.3
  //            c5.9,14.3-5.1,17.2-5.1,17.2S76.6,42.2,83,36.5c2.1-1.9,3.1-3.6,3.5-5.1l0,0l0,0C86.6,30.9,86.7,30.5,86.6,30z"/>
  //        <path fill="#FFAE73" d="M110.6,173.6c0,0-3.3,5.6-3.7,6.9c-0.4,1.3,1.2,1.4,2.2,0C110,179.1,110.6,173.6,110.6,173.6z"/>
  //        <path fill="#FF912B" d="M97.1,66.3c0,0,14.6,0.4,22.3,10.5c5.9,7.7,11.9,49.1,11.9,55.4c0,6.2-6.9,40.6-10.7,44.3
  //            c0,0-2.4,0.6-5.6,0c-3.4-0.7-5.4-2.7-5.4-2.7s2.1-38.2,2.1-41.8c0-5.2-16-37.1-16-37.1S87.2,79.7,97.1,66.3z"/>
  //    </g>
  //    </svg>`,
  //     },
  //     {
  //         id: 5,
  //         name: 'Coming Soon',
  //         status: 'ComingSoon',
  //         ColorSvg: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  //         viewBox="0 0 150 345" enable-background="new 0 0 150 345" xml:space="preserve">
  //    <g>
  //        <path fill="#FFB27D" d="M104.7,250.4l-0.9-3.3c0,0-4.2-0.4-4.2-0.4l0.4,10c0,0,2.2-0.5,2.9-1.4l1.5-2.7
  //            C104.9,251.9,104.7,250.4,104.7,250.4z"/>
  //        <path fill="#FDDBBA" d="M93.9,165.1c0,0,5.1-0.3,8,6.8c5.9,14.6,3.4,46.2,3,50.7c0,0,2,9-1,24.5l-3.8-0.2c0,0-6.2-58.7-5.5-64.7
  //            C95.3,176.1,93.9,165.1,93.9,165.1z"/>
  //        <path fill="#233862" d="M51.3,337.7l1.9,7.3h16.3C69.6,345,74.4,335.7,51.3,337.7z"/>
  //        <path fill="#233862" d="M86.3,337.7l1.9,7.3h16.3C104.6,345,109.4,335.7,86.3,337.7z"/>
  //        <path fill="#FFB27D" d="M87,164.6l-15.3,8.2l-2-10.6c0,0,1.4-4.1,2-10.5c0.2-2.7,0.3-5.9,0.1-9.3l12.5,6.7c0,0-0.3,1.2-0.5,2.9
  //            c-0.2,1.4-0.3,3.2-0.1,5.1C84,159.8,84.8,162.7,87,164.6z"/>
  //        <path fill="#233862" d="M99.6,230.1l-30.9,2.6c0,0-3.8,56.9,16.5,107.2l18.3-1.3L99.6,230.1z"/>
  //        <path fill="#2B478B" d="M51.6,233.2c0,0-6.1,32.6-1.8,105.8h19.1l12-88.9c0.4-2.6,5.3-6.2,5.3-6.2l0.2-10L51.6,233.2z"/>
  //        <path fill="#FDDBBA" d="M51.7,190.4l1.8,13.2l-4.9,26.5c-0.4,2.3,1.2,4.6,3.5,4.7c9.3,0.7,31.8,1.6,47.1-2.9c2-0.6,3.4-2.6,3.2-4.8
  //            l-2.7-35.4l-0.9-12.5l-1-12.8c0,0-4.7-3-12.8-4.2c0.1,2-0.5,3.8-4.4,4.2c-4.5,0.5-8-1.6-10.5-3.6c-0.1-0.1-0.4-0.5-0.5-0.6
  //            c-2.8,0.3-5.9,0.8-8.7,1.4c-0.4,0.1-10.2,20.4-10.2,20.4L51.7,190.4z"/>
  //        <path fill="#ED975D" d="M83.8,158.2c-4.7,0.6-11.9-6.4-12.1-6.5c0,0,8.7,0.1,12.1,0.2C83.6,153.3,83.6,156.3,83.8,158.2z"/>
  //        <path fill="#FFB27D" d="M88.7,155.2c0,0-21.3,2.7-21.8-13c-0.5-15.7,8.4-25.9,14.3-25.8c11.8,0.2,13.8,5.2,15.1,10.5
  //            C97.8,132,98.5,154,88.7,155.2z"/>
  //        <g>
  //            <path fill="#2C3A64" d="M71.6,151.7c0,0-1.8-5.6-1.6-8.7c0,0-4.3-5.7-1.8-7.1c2.5-1.4,3.8,2,4.4,1.3c0.6-0.7,1.5-11.9,4.5-11.5
  //                c3,0.4,16.7,4.4,21.5,0c4.9-4.4-9.5-22.1-29.6-15.5C48.9,116.8,53,140,71.6,151.7z"/>
  //            <path fill="#2C3A64" d="M59.1,119.4c0,0-0.9-2.8,0.1-4.9c0,0,0,2.8,1.1,4C61.3,119.8,59.1,119.4,59.1,119.4z"/>
  //            <path fill="#2C3A64" d="M59.5,117.4c0,0-2.5-0.3-3.7,1.7c0,0,1.8-1.2,3.5,0.1L59.5,117.4z"/>
  //        </g>
  //        <polygon fill="#F8CAA4" points="60,184.5 68.5,222.5 77.5,235.4 57.4,235.4 	"/>
  //        <path fill="#FFB27D" d="M49.9,250.8l0.8-3.4c0,0,5.2-0.9,5.3-0.8l0.3,10c0,0-2.7-0.3-3.8-1.1l-2.1-2.5
  //            C49.8,252.3,49.9,250.8,49.9,250.8z"/>
  //        <path fill="#FDDBBA" d="M60.9,163.4c0,0-10.3,1.4-13.3,8.8c-6.3,15.2-1.8,34.8-1,39.2c0,0-0.9,20.8,4.1,35.9l4.7-0.6
  //            c0,0,4.8-17.6,3.6-35.3c-1-14,2.3-26.5,2.9-29C63.8,173.4,60.9,163.4,60.9,163.4z"/>
  //    </g>
  //    </svg>`,
  //     },
];

var FemaleReducerArray = {
  Hip_Comp: { data: ["Bottom"] },
  L_Thigh_Comp: { data: ["Bottom"] },
  R_Thigh_Comp: { data: ["Bottom"] },
  L_Calf_Comp: { data: ["Bottom"] },
  R_Calf_Comp: { data: ["Bottom"] },
  MiddleBody_Comp: { data: ["MiddleTop"] },
  L_Arm_Comp: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
  R_Arm_Comp: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
  L_ForeArm_Comp: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
  R_ForeArm_Comp: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
  OuterBody_Comp: { data: ["OuterTop"] },
  Face_Comp: { data: ["Face"] },
  Mouth_Comp: { data: ["Mouth"] },
  SideHair_Comp: { data: ["Hair"] },
  FrontHair_Comp: { data: ["Hair"] },
  BackHair_Comp: { data: ["Hair"] },
  Ear_Comp: { data: ["Ear"] },
  EyeBrow_Comp: { data: ["EyeBrow"] },
  Nose_Comp: { data: ["Nose"] },
  Eye_Comp: { data: ["Eye"] },
  L_Foot_Comp: { data: ["Shoe"] },
  R_Foot_Comp: { data: ["Shoe"] },
  BaseBody_Comp: { data: ["LowerTop", "BaseBody"] },
  Cap_Comp: { data: ["Cap"] },
  Mask_Comp: { data: ["Mask"] },
  Glasses_Comp: { data: ["Glasses"] },
  EarWear_Comp: { data: ["EarWear"] },
  L_Wing_Comp: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
  R_Wing_Comp: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
  Right_Shoulder: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
  Left_Shoulder: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
  CoatSide_Comp: { data: ["OuterTop"] },
};

var FemaleBodyParts = [
  {
    name: "Bottom",
    parts: [
      "Hip_Comp",
      "L_Thigh_Comp",
      "R_Thigh_Comp",
      "L_Calf_Comp",
      "R_Calf_Comp",
    ],
  },

  {
    name: "LowerTop",
    parts: [
      "BaseBody_Comp",
      "L_Arm_Comp",
      "R_Arm_Comp",
      "L_ForeArm_Comp",
      "R_ForeArm_Comp",
      "Left_Shoulder",
      "Right_Shoulder",
      "L_Wing_Comp",
      "R_Wing_Comp",
    ],
  },
  {
    name: "MiddleTop",
    parts: [
      "MiddleBody_Comp",
      "L_Arm_Comp",
      "R_Arm_Comp",
      "L_ForeArm_Comp",
      "R_ForeArm_Comp",
      "Left_Shoulder",
      "Right_Shoulder",
      "L_Wing_Comp",
      "R_Wing_Comp",
    ],
  },
  {
    name: "OuterTop",
    parts: [
      "OuterBody_Comp",
      "L_Arm_Comp",
      "R_Arm_Comp",
      "L_ForeArm_Comp",
      "R_ForeArm_Comp",
      "Left_Shoulder",
      "Right_Shoulder",
      "L_Wing_Comp",
      "R_Wing_Comp",
      "CoatSide_Comp",
    ],
  },

  { name: "Shoe", parts: ["L_Foot_Comp", "R_Foot_Comp"] },

  { name: "Eye", parts: ["Eye_Comp"] },

  { name: "Nose", parts: ["Nose_Comp"] },

  { name: "EyeBrow", parts: ["EyeBrow_Comp"] },

  { name: "Ear", parts: ["Ear_Comp"] },

  { name: "Hair", parts: ["SideHair_Comp", "FrontHair_Comp", "BackHair_Comp"] },

  { name: "Mouth", parts: ["Mouth_Comp"] },

  { name: "Face", parts: ["Face_Comp"] },

  { name: "BaseBody", parts: ["BaseBody_Comp"] },

  { name: "Cap", parts: ["Cap_Comp"] },

  { name: "Mask", parts: ["Mask_Comp"] },

  { name: "Glasses", parts: ["Glasses_Comp"] },

  { name: "EarWear", parts: ["EarWear_Comp"] },
];

var MaleReducerArray = {
  Hip_Comp: { data: ["Bottom"] },
  L_Thigh_Comp: { data: ["Bottom"] },
  R_Thigh_Comp: { data: ["Bottom"] },
  L_Calf_Comp: { data: ["Bottom"] },
  R_Calf_Comp: { data: ["Bottom"] },
  MiddleBody_Comp: { data: ["MiddleTop"] },
  L_Arm_Comp: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
  R_Arm_Comp: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
  L_ForeArm_Comp: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
  R_ForeArm_Comp: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
  OuterBody_Comp: { data: ["OuterTop"] },
  Face_Comp: { data: ["Face"] },
  Mouth_Comp: { data: ["Mouth"] },
  SideHair_Comp: { data: ["Hair"] },
  FrontHair_Comp: { data: ["Hair"] },
  BackHair_Comp: { data: ["Hair"] },
  Ear_Comp: { data: ["Ear"] },
  EyeBrow_Comp: { data: ["EyeBrow"] },
  Nose_Comp: { data: ["Nose"] },
  Eye_Comp: { data: ["Eye"] },
  L_Foot_Comp: { data: ["Shoe"] },
  R_Foot_Comp: { data: ["Shoe"] },
  BaseBody_Comp: { data: ["LowerTop", "BaseBody"] },
  Cap_Comp: { data: ["Cap"] },
  Mask_Comp: { data: ["Mask"] },
  Glasses_Comp: { data: ["Glasses"] },
  EarWear_Comp: { data: ["EarWear"] },
  L_Wing_Comp: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
  R_Wing_Comp: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
  Right_Shoulder: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
  Left_Shoulder: { data: ["LowerTop", "MiddleTop", "OuterTop"] },
};

var MaleBodyParts = [
  {
    name: "Bottom",
    parts: [
      "Hip_Comp",
      "L_Thigh_Comp",
      "R_Thigh_Comp",
      "L_Calf_Comp",
      "R_Calf_Comp",
    ],
  },

  {
    name: "LowerTop",
    parts: [
      "BaseBody_Comp",
      "L_Arm_Comp",
      "R_Arm_Comp",
      "L_ForeArm_Comp",
      "R_ForeArm_Comp",
      "Left_Shoulder",
      "Right_Shoulder",
      "L_Wing_Comp",
      "R_Wing_Comp",
    ],
  },

  {
    name: "MiddleTop",
    parts: [
      "MiddleBody_Comp",
      "L_Arm_Comp",
      "R_Arm_Comp",
      "L_ForeArm_Comp",
      "R_ForeArm_Comp",
      "Left_Shoulder",
      "Right_Shoulder",
      "L_Wing_Comp",
      "R_Wing_Comp",
    ],
  },

  {
    name: "OuterTop",
    parts: [
      "OuterBody_Comp",
      "L_Arm_Comp",
      "R_Arm_Comp",
      "L_ForeArm_Comp",
      "R_ForeArm_Comp",
      "Left_Shoulder",
      "Right_Shoulder",
      "L_Wing_Comp",
      "R_Wing_Comp",
    ],
  },

  { name: "Shoe", parts: ["L_Foot_Comp", "R_Foot_Comp"] },

  { name: "Eye", parts: ["Eye_Comp"] },

  { name: "Nose", parts: ["Nose_Comp"] },

  { name: "EyeBrow", parts: ["EyeBrow_Comp"] },

  { name: "Ear", parts: ["Ear_Comp"] },

  { name: "Hair", parts: ["SideHair_Comp", "FrontHair_Comp", "BackHair_Comp"] },

  { name: "Mouth", parts: ["Mouth_Comp"] },

  { name: "Face", parts: ["Face_Comp"] },

  { name: "BaseBody", parts: ["BaseBody_Comp"] },

  { name: "Cap", parts: ["Cap_Comp"] },

  { name: "Mask", parts: ["Mask_Comp"] },

  { name: "Glasses", parts: ["Glasses_Comp"] },

  { name: "EarWear", parts: ["EarWear_Comp"] },
];

var ObjectHere = {
  Face: {
    data: null,
    colorShades: { ShadeName: [], Shades: [] },
  },
  Hair: {
    data: null,
    colorShades: { ShadeName: [], Shades: [] },
  },
  Mouth: {
    data: null,
    colorShades: { ShadeName: [], Shades: [] },
  },
  OuterTop: {
    data: null,
    colorShades: { ShadeName: [], Shades: [] },
  },
  LowerTop: {
    data: null,
    colorShades: { ShadeName: [], Shades: [] },
  },
  MiddleTop: {
    data: null,
    colorShades: { ShadeName: [], Shades: [] },
  },
  Eye: {
    data: null,
    colorShades: { ShadeName: [], Shades: [] },
  },
  EyeBrow: {
    data: null,
    colorShades: { ShadeName: [], Shades: [] },
  },
  Bottom: {
    data: null,
    colorShades: { ShadeName: [], Shades: [] },
  },
  Shoe: {
    data: null,
    colorShades: { ShadeName: [], Shades: [] },
  },
  Nose: {
    data: null,
    colorShades: { ShadeName: [], Shades: [] },
  },
  Cap: {
    data: null,
    colorShades: { ShadeName: [], Shades: [] },
  },
  Glasses: {
    data: null,
    colorShades: { ShadeName: [], Shades: [] },
  },
  Mask: {
    data: null,
    colorShades: { ShadeName: [], Shades: [] },
  },
  EarWear: {
    data: null,
    colorShades: { ShadeName: [], Shades: [] },
  },
};

var ActivePartName = [
  "Face",
  "Hair",
  "Mouth",
  "OuterTop",
  "MiddleTop",
  "Eye",
  "EyeBrow",
  "Bottom",
  "Shoe",
  "LowerTop",
  "Nose",
  "Cap",
  "Mask",
  "Glasses",
  "EarWear",
];

const PopRightArea = (props) => {
  const clone = (obj) => {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = clone(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
      }
      return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
  };

  const MainCanvas = useRef();

  const {
    CharacterAssets,
    setCharacterAssets,
    DefaultCharacter,
    setDefaultCharacter,
  } = useContext(CharacterContext);

  const [NewJson, setNewJson] = useState();

  const [ActiveParts, setActiveParts] = useState({
    Face: {
      data: null,
      colorShades: { ShadeName: [], Shades: [] },
    },
    Hair: {
      data: null,
      colorShades: { ShadeName: [], Shades: [] },
    },
    Mouth: {
      data: null,
      colorShades: { ShadeName: [], Shades: [] },
    },
    OuterTop: {
      data: null,
      colorShades: { ShadeName: [], Shades: [] },
    },
    LowerTop: {
      data: null,
      colorShades: { ShadeName: [], Shades: [] },
    },
    MiddleTop: {
      data: null,
      colorShades: { ShadeName: [], Shades: [] },
    },
    Eye: {
      data: null,
      colorShades: { ShadeName: [], Shades: [] },
    },
    EyeBrow: {
      data: null,
      colorShades: { ShadeName: [], Shades: [] },
    },
    Bottom: {
      data: null,
      colorShades: { ShadeName: [], Shades: [] },
    },
    Shoe: {
      data: null,
      colorShades: { ShadeName: [], Shades: [] },
    },
    Nose: {
      data: null,
      colorShades: { ShadeName: [], Shades: [] },
    },
    Cap: {
      data: null,
      colorShades: { ShadeName: [], Shades: [] },
    },
    Glasses: {
      data: null,
      colorShades: { ShadeName: [], Shades: [] },
    },
    Mask: {
      data: null,
      colorShades: { ShadeName: [], Shades: [] },
    },
    EarWear: {
      data: null,
      colorShades: { ShadeName: [], Shades: [] },
    },
  });

  const [Play, setPlay] = useState();

  const [SelectedGender, setSelectedGender] = useState("Male");

  const [ActiveGender, setActiveGender] = useState("Male");

  const [AssetData, setAssetData] = useState();

  const [selection, setselection] = useState(false);

  const { authenticationData, UserData } = useContext(AuthContext);

  //const { history } = useContext(changeComponent)

  const ClotheClick = (path) => {
    try {
      var pName = path.substring(path.lastIndexOf("/") + 1);
      pName = pName.split(".")[0];
      PartsName = [];
      let json = NewJson;
      var NewName = pName.split("_")[0];
      if (props.Gender === "Female") {
        for (let a = 0; a < FemaleBodyParts.length; a++) {
          if (FemaleBodyParts[a].name === NewName) {
            PartsName = FemaleBodyParts[a].parts;
          }
        }
      } else if (props.Gender === "Male") {
        for (let a = 0; a < MaleBodyParts.length; a++) {
          if (MaleBodyParts[a].name === NewName) {
            PartsName = MaleBodyParts[a].parts;
          }
        }
      }

      let arrayName = [];
      let arrayShade = [];

      for (let b = 0; b < json.assets.length; b++) {
        if (json.assets[b].id === "comp_0") {
          for (let c = 0; c < json.assets[b].layers.length; c++) {
            // if (json.assets[b].layers[c].nm == 'L_Wing_Comp') {
            // }
            for (let d = 0; d < PartsName.length; d++) {
              if (json.assets[b].layers[c].nm === PartsName[d]) {
                for (
                  let e = 0;
                  e < json.assets[b].layers[c].layers.length;
                  e++
                ) {
                  if (
                    json.assets[b].layers[c].layers[e].nm.split("_")[0] ===
                    NewName
                  ) {
                    json.assets[b].layers[c].layers[e].hd = true;
                    if (NewName === "Eye") {
                      if (props.Gender === "Male") {
                        if (json.assets[b].layers[c].layers[e].nm === pName) {
                          json.assets[b].layers[c].layers[e].hd = false;

                          for (
                            let clry = 0;
                            clry <
                            json.assets[b].layers[c].layers[e].shapes.length;
                            clry++
                          ) {
                            if (
                              json.assets[b].layers[c].layers[e].shapes[
                                clry
                              ].nm.split("_")[0] === "Changeable"
                            ) {
                              for (
                                let clrz = 0;
                                clrz <
                                json.assets[b].layers[c].layers[e].shapes[clry]
                                  .it.length;
                                clrz++
                              ) {
                                if (
                                  json.assets[b].layers[c].layers[e].shapes[
                                    clry
                                  ].it[clrz].ty === "fl"
                                ) {
                                  if (arrayName.length === 0) {
                                    let arr = [];

                                    for (let clra = 0; clra < 3; clra++) {
                                      arr.push(
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].it[clrz].c.k[clra] *
                                        25 *
                                        10
                                      );
                                    }
                                    arrayName.push(
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].nm
                                    );
                                    arrayShade.push(arr);
                                  } else {
                                    let nameCheck = false;
                                    for (
                                      let name = 0;
                                      name < arrayName.length;
                                      name++
                                    ) {
                                      if (
                                        arrayName[name] ===
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].nm
                                      ) {
                                        nameCheck = true;
                                      }
                                    }
                                    if (!nameCheck) {
                                      let arr = [];
                                      for (let clra = 0; clra < 3; clra++) {
                                        arr.push(
                                          json.assets[b].layers[c].layers[e]
                                            .shapes[clry].it[clrz].c.k[clra] *
                                          25 *
                                          10
                                        );
                                      }
                                      arrayName.push(
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].nm
                                      );
                                      arrayShade.push(arr);
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else if (props.Gender === "Female") {
                        if (json.assets[b].layers[c].layers[e].nm == pName) {
                          json.assets[b].layers[c].layers[e].hd = false;

                          for (
                            let ind = 0;
                            ind <
                            json.assets[b].layers[c].layers[e].layers.length;
                            ind++
                          ) {
                            if (
                              json.assets[b].layers[c].layers[e].layers[ind]
                                .nm === "EyeBall"
                            ) {
                              for (
                                let clry = 0;
                                clry <
                                json.assets[b].layers[c].layers[e].layers[ind]
                                  .shapes.length;
                                clry++
                              ) {
                                if (
                                  json.assets[b].layers[c].layers[e].layers[
                                    ind
                                  ].shapes[clry].nm.split("_")[0] ===
                                  "Changeable"
                                ) {
                                  for (
                                    let clrz = 0;
                                    clrz <
                                    json.assets[b].layers[c].layers[e].layers[
                                      ind
                                    ].shapes[clry].it.length;
                                    clrz++
                                  ) {
                                    if (
                                      json.assets[b].layers[c].layers[e].layers[
                                        ind
                                      ].shapes[clry].it[clrz].ty === "fl"
                                    ) {
                                      if (arrayName.length === 0) {
                                        let arr = [];

                                        for (let clra = 0; clra < 3; clra++) {
                                          arr.push(
                                            json.assets[b].layers[c].layers[e]
                                              .layers[ind].shapes[clry].it[clrz]
                                              .c.k[clra] *
                                            25 *
                                            10
                                          );
                                        }

                                        arrayName.push(
                                          json.assets[b].layers[c].layers[e]
                                            .layers[ind].shapes[clry].nm
                                        );
                                        arrayShade.push(arr);
                                      } else {
                                        let nameCheck = false;

                                        for (
                                          let name = 0;
                                          name < arrayName.length;
                                          name++
                                        ) {
                                          if (
                                            arrayName[name] ===
                                            json.assets[b].layers[c].layers[e]
                                              .layers[ind].shapes[clry].nm
                                          ) {
                                            nameCheck = true;
                                          }
                                        }
                                        if (!nameCheck) {
                                          let arr = [];

                                          for (let clra = 0; clra < 3; clra++) {
                                            arr.push(
                                              json.assets[b].layers[c].layers[e]
                                                .layers[ind].shapes[clry].it[
                                                clrz
                                              ].c.k[clra] *
                                              25 *
                                              10
                                            );
                                          }

                                          arrayName.push(
                                            json.assets[b].layers[c].layers[e]
                                              .layers[ind].shapes[clry].nm
                                          );
                                          arrayShade.push(arr);
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }

                      setActiveParts({
                        ...ActiveParts,
                        ...(ActiveParts[NewName].data = pName),
                        ...(ActiveParts[NewName].colorShades.ShadeName =
                          arrayName),
                        ...(ActiveParts[NewName].colorShades.Shades =
                          arrayShade),
                      });
                    } else if (NewName === "Mouth") {
                      let split =
                        json.assets[b].layers[c].layers[e].nm.split("-");

                      if (split.length == 1) {
                        if (split[0] == pName) {
                          json.assets[b].layers[c].layers[e].hd = false;

                          for (
                            let clry = 0;
                            clry <
                            json.assets[b].layers[c].layers[e].shapes.length;
                            clry++
                          ) {
                            if (
                              json.assets[b].layers[c].layers[e].shapes[
                                clry
                              ].nm.split("_")[0] === "Changeable"
                            ) {
                              for (
                                let clrz = 0;
                                clrz <
                                json.assets[b].layers[c].layers[e].shapes[clry]
                                  .it.length;
                                clrz++
                              ) {
                                if (
                                  json.assets[b].layers[c].layers[e].shapes[
                                    clry
                                  ].it[clrz].ty === "fl"
                                ) {
                                  if (arrayName.length === 0) {
                                    let arr = [];

                                    for (let clra = 0; clra < 3; clra++) {
                                      arr.push(
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].it[clrz].c.k[clra] *
                                        25 *
                                        10
                                      );
                                    }

                                    arrayName.push(
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].nm
                                    );
                                    arrayShade.push(arr);
                                  } else {
                                    let nameCheck = false;
                                    for (
                                      let name = 0;
                                      name < arrayName.length;
                                      name++
                                    ) {
                                      if (
                                        arrayName[name] ===
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].nm
                                      ) {
                                        nameCheck = true;
                                      }
                                    }
                                    if (!nameCheck) {
                                      let arr = [];
                                      for (let clra = 0; clra < 3; clra++) {
                                        arr.push(
                                          json.assets[b].layers[c].layers[e]
                                            .shapes[clry].it[clrz].c.k[clra] *
                                          25 *
                                          10
                                        );
                                      }

                                      arrayName.push(
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].nm
                                      );
                                      arrayShade.push(arr);
                                    }
                                  }
                                }
                              }
                            }
                          }

                          setActiveParts({
                            ...ActiveParts,
                            ...(ActiveParts[NewName].data = pName),
                            ...(ActiveParts[NewName].colorShades.ShadeName =
                              arrayName),
                            ...(ActiveParts[NewName].colorShades.Shades =
                              arrayShade),
                          });
                        }
                      } else {
                        if (split[0] == pName) {
                          json.assets[b].layers[c].layers[e].hd = false;
                        }
                      }
                    } else if (NewName === "Face") {
                      if (json.assets[b].layers[c].layers[e].nm === pName) {
                        json.assets[b].layers[c].layers[e].hd = false;

                        for (
                          let clry = 0;
                          clry <
                          json.assets[b].layers[c].layers[e].shapes.length;
                          clry++
                        ) {
                          for (
                            let clrz = 0;
                            clrz <
                            json.assets[b].layers[c].layers[e].shapes[clry].it
                              .length;
                            clrz++
                          ) {
                            if (
                              json.assets[b].layers[c].layers[e].shapes[clry]
                                .it[clrz].ty === "fl"
                            ) {
                              if (arrayName.length === 0) {
                                let arr = [];

                                for (let clra = 0; clra < 3; clra++) {
                                  arr.push(
                                    json.assets[b].layers[c].layers[e].shapes[
                                      clry
                                    ].it[clrz].c.k[clra] *
                                    25 *
                                    10
                                  );
                                }
                                arrayName.push(
                                  json.assets[b].layers[c].layers[e].shapes[
                                    clry
                                  ].nm
                                );
                                arrayShade.push(arr);
                              } else {
                                let nameCheck = false;
                                for (
                                  let name = 0;
                                  name < arrayName.length;
                                  name++
                                ) {
                                  if (
                                    arrayName[name] ===
                                    json.assets[b].layers[c].layers[e].shapes[
                                      clry
                                    ].nm
                                  ) {
                                    nameCheck = true;
                                  }
                                }
                                if (!nameCheck) {
                                  let arr = [];
                                  for (let clra = 0; clra < 3; clra++) {
                                    arr.push(
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].it[clrz].c.k[clra] *
                                      25 *
                                      10
                                    );
                                  }
                                  arrayName.push(
                                    json.assets[b].layers[c].layers[e].shapes[
                                      clry
                                    ].nm
                                  );
                                  arrayShade.push(arr);
                                }
                              }
                            }
                          }
                        }
                        setActiveParts({
                          ...ActiveParts,
                          ...(ActiveParts[NewName].data = pName),
                          ...(ActiveParts[NewName].colorShades.ShadeName =
                            arrayName),
                          ...(ActiveParts[NewName].colorShades.Shades =
                            arrayShade),
                        });
                      }
                    } else if (NewName === "Cap") {
                      if (json.assets[b].layers[c].layers[e].nm === pName) {
                        json.assets[b].layers[c].layers[e].hd = false;

                        let part = [
                          "SideHair_Comp",
                          "FrontHair_Comp",
                          "BackHair_Comp",
                        ];

                        for (let c = 0; c < json.assets[b].layers.length; c++) {
                          for (let d = 0; d < part.length; d++) {
                            if (json.assets[b].layers[c].nm === part[d]) {
                              for (
                                let e = 0;
                                e < json.assets[b].layers[c].layers.length;
                                e++
                              ) {
                                json.assets[b].layers[c].layers[e].hd = true;

                                if (
                                  json.assets[b].layers[c].layers[e].nm ===
                                  ActiveParts["Hair"].data + "-" + pName
                                ) {
                                  json.assets[b].layers[c].layers[e].hd = false;
                                }
                              }
                            }
                          }
                        }

                        setActiveParts({
                          ...ActiveParts,
                          ...(ActiveParts[NewName].data = pName),
                        });
                      }
                    } else {
                      if (json.assets[b].layers[c].layers[e].nm === pName) {
                        //L_Wing_Comp
                        if (
                          NewName !== "Face" &&
                          NewName !== "Cap" &&
                          NewName !== "Mouth" &&
                          NewName !== "Eye"
                        ) {
                          json.assets[b].layers[c].layers[e].hd = false;

                          for (
                            let clry = 0;
                            clry <
                            json.assets[b].layers[c].layers[e].shapes.length;
                            clry++
                          ) {
                            if (
                              json.assets[b].layers[c].layers[e].shapes[
                                clry
                              ].nm.split("_")[0] === "Changeable"
                            ) {
                              for (
                                let clrz = 0;
                                clrz <
                                json.assets[b].layers[c].layers[e].shapes[clry]
                                  .it.length;
                                clrz++
                              ) {
                                if (
                                  json.assets[b].layers[c].layers[e].shapes[
                                    clry
                                  ].it[clrz].ty === "fl"
                                ) {
                                  if (arrayName.length === 0) {
                                    let arr = [];

                                    for (let clra = 0; clra < 3; clra++) {
                                      arr.push(
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].it[clrz].c.k[clra] *
                                        25 *
                                        10
                                      );
                                    }

                                    arrayName.push(
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].nm
                                    );
                                    arrayShade.push(arr);
                                  } else {
                                    let nameCheck = false;
                                    for (
                                      let name = 0;
                                      name < arrayName.length;
                                      name++
                                    ) {
                                      if (
                                        arrayName[name] ===
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].nm
                                      ) {
                                        nameCheck = true;
                                      }
                                    }
                                    if (!nameCheck) {
                                      let arr = [];
                                      for (let clra = 0; clra < 3; clra++) {
                                        arr.push(
                                          json.assets[b].layers[c].layers[e]
                                            .shapes[clry].it[clrz].c.k[clra] *
                                          25 *
                                          10
                                        );
                                      }

                                      arrayName.push(
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].nm
                                      );
                                      arrayShade.push(arr);
                                    }
                                  }
                                }
                              }
                            }
                          }
                          setActiveParts({
                            ...ActiveParts,
                            ...(ActiveParts[NewName].data = pName),
                            ...(ActiveParts[NewName].colorShades.ShadeName =
                              arrayName),
                            ...(ActiveParts[NewName].colorShades.Shades =
                              arrayShade),
                          });
                        }
                      }
                    }
                  } else {
                    if (
                      PartsName[d].split("_Comp")[0] ==
                      json.assets[b].layers[c].layers[e].nm
                    ) {
                      if (
                        PartsName[d] != "L_Foot_Comp" &&
                        PartsName[d] != "R_Foot_Comp"
                      ) {
                        json.assets[b].layers[c].layers[e].hd = false;
                      }
                    } else if (
                      json.assets[b].layers[c].layers[e].nm == "BaseBody"
                    ) {
                      if (
                        PartsName[d] != "L_Foot_Comp" &&
                        PartsName[d] != "R_Foot_Comp"
                      ) {
                        json.assets[b].layers[c].layers[e].hd = false;
                      }
                    }
                  }
                }
                break;
              }
            }
          }
          break;
        }
      }
      var currFrame = Play.currentFrame;
      Lottie.destroy("alex");
      const ctx = document
        .getElementsByClassName("ChrClass")[0]
        .getContext("2d");
      get = Lottie.loadAnimation({
        name: "alex",
        renderer: "canvas",
        loop: true,
        autoplay: true,
        animationData: NewJson,

        rendererSettings: {
          context: ctx,
          scaleMode: "noScale",
          clearCanvas: true,
          //className: 'CharCanv',
        },
      });
      get.goToAndPlay(currFrame, true, "alex");
      setPlay(get);
    } catch (ex) { }
  };

  const RemoveAsset = (NewName) => {
    var json = NewJson;
    PartsName = [];
    if (props.Gender === "Female") {
      for (let a = 0; a < FemaleBodyParts.length; a++) {
        if (FemaleBodyParts[a].name === NewName) {
          PartsName = FemaleBodyParts[a].parts;
        }
      }
    } else if (props.Gender === "Male") {
      for (let a = 0; a < MaleBodyParts.length; a++) {
        if (MaleBodyParts[a].name === NewName) {
          PartsName = MaleBodyParts[a].parts;
        }
      }
    }
    for (let b = 0; b < json.assets.length; b++) {
      if (json.assets[b].id === "comp_0") {
        for (let c = 0; c < json.assets[b].layers.length; c++) {
          for (let d = 0; d < PartsName.length; d++) {
            if (json.assets[b].layers[c].nm === PartsName[d]) {
              for (let e = 0; e < json.assets[b].layers[c].layers.length; e++) {
                if (
                  json.assets[b].layers[c].layers[e].nm.split("_")[0] ===
                  NewName
                ) {
                  if (
                    json.assets[b].layers[c].layers[e].hd === false ||
                    json.assets[b].layers[c].layers[e].hd === undefined
                  ) {
                    json.assets[b].layers[c].layers[e].hd = true;
                    setActiveParts({
                      ...ActiveParts,
                      ...(ActiveParts[NewName].data = null),
                      ...(ActiveParts[NewName].colorShades.ShadeName = []),
                      ...(ActiveParts[NewName].colorShades.Shades = []),
                    });
                  }
                }
                if (
                  PartsName[d].split("_Comp")[0] ==
                  json.assets[b].layers[c].layers[e].nm
                ) {
                  json.assets[b].layers[c].layers[e].hd = false;
                } else if (
                  json.assets[b].layers[c].layers[e].nm == "BaseBody"
                ) {
                  json.assets[b].layers[c].layers[e].hd = false;
                }
              }
            }
          }
        }
      }
    }

    var currFrame = Play.currentFrame;
    Lottie.destroy("alex");

    const ctx = document.getElementsByClassName("ChrClass")[0].getContext("2d");
    get = Lottie.loadAnimation({
      name: "alex",
      renderer: "canvas",
      loop: true,
      autoplay: true,
      animationData: NewJson,
      rendererSettings: {
        context: ctx,
        scaleMode: "noScale",
        clearCanvas: true,
        //className: 'CharCanv',
      },
    });
    get.goToAndPlay(currFrame, true, "alex");

    setPlay(get);
  };

  const getAssets = (gender) => {
    if (gender === "Male") {
      if (CharacterAssets.Male.head.length === 0) {
        let authData = JSON.parse(
          localStorage.getItem("animation_studio_2.0_access_token")
        );

        axios
          .get(
            authenticationData.ApiBaseURL +
            "/api/Character/GetAssets?gender=" +
            gender,
            {
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
          .then((response) => {
            let allAssets = response.data.allAssets;

            let Data = response.data.characters;

            for (const itr of Data) {
              try {
                let svgJson = JSON.parse(itr.svg)
                for (const it of JSON.parse(itr.svg)) {
                  if (it.name == "Default") {
                    itr.svg = it.largeImgPath;
                    break;
                  }
                }
              }
              catch (ex) {

              }

            }

            setDefaultCharacter({ ...DefaultCharacter, Male: Data });

            let obj = {
              head: [],
              hair: [],
              Mouth: [],
              Nose: [],
              Eyes: {
                eye: [],
                EyeBrows: [],
              },
              Shirts: {
                Shirt: [],
                Sweaters: [],
                Jackets: [],
              },
              Bottoms: [],
              Shoes: [],
              Cap: [],
              Glasses: [],
              Mask: [],
              EarWear: [],
            };

            for (let i = 0; i < allAssets.length; i++) {
              if (allAssets[i].category === "head") {
                obj.head.push(allAssets[i]);
              } else if (allAssets[i].category === "hair") {
                obj.hair.push(allAssets[i]);
              } else if (allAssets[i].category === "Mouth") {
                obj.Mouth.push(allAssets[i]);
              } else if (allAssets[i].category === "Nose") {
                obj.Nose.push(allAssets[i]);
              } else if (allAssets[i].category === "Eyes") {
                if (allAssets[i].subCategory === "eye") {
                  obj.Eyes.eye.push(allAssets[i]);
                } else if (allAssets[i].subCategory === "EyeBrows") {
                  obj.Eyes.EyeBrows.push(allAssets[i]);
                }
              } else if (allAssets[i].category === "Shirts") {
                if (allAssets[i].subCategory === "Shirt") {
                  obj.Shirts.Shirt.push(allAssets[i]);
                } else if (allAssets[i].subCategory === "Sweaters") {
                  obj.Shirts.Sweaters.push(allAssets[i]);
                } else if (allAssets[i].subCategory === "Jackets") {
                  obj.Shirts.Jackets.push(allAssets[i]);
                }
              } else if (allAssets[i].category === "Bottoms") {
                obj.Bottoms.push(allAssets[i]);
              } else if (allAssets[i].category === "Shoes") {
                obj.Shoes.push(allAssets[i]);
              } else if (allAssets[i].category === "Cap") {
                obj.Cap.push(allAssets[i]);
              } else if (allAssets[i].category === "Glasses") {
                obj.Glasses.push(allAssets[i]);
              } else if (allAssets[i].category === "EarWear") {
                obj.EarWear.push(allAssets[i]);
              } else if (allAssets[i].category === "Mask") {
                obj.Mask.push(allAssets[i]);
              }
            }

            let data = {
              Male: obj,
              Female: CharacterAssets.Female,
            };
            setCharacterAssets(data);
          })
          .catch((error) => { });
      } else {
        setAssetData(CharacterAssets.Male);
      }
    } else {
      if (CharacterAssets.Female.head.length === 0) {
        let authData = JSON.parse(
          localStorage.getItem("animation_studio_2.0_access_token")
        );
        axios
          .get(
            authenticationData.ApiBaseURL +
            "/api/Character/GetAssets?gender=" +
            gender,
            {
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
          .then((response) => {
            let allAssets = response.data.allAssets;

            let Data = response.data.characters;

            for (const itr of Data) {
              for (const it of JSON.parse(itr.svg)) {
                if (it.name == "Default") {
                  itr.svg = it.largeImgPath;
                  break;
                }
              }
            }

            setDefaultCharacter({ ...DefaultCharacter, Female: Data });

            let obj = {
              head: [],
              hair: [],
              Mouth: [],
              Nose: [],
              Eyes: {
                eye: [],
                EyeBrows: [],
              },
              Shirts: {
                Shirt: [],
                Sweaters: [],
                Jackets: [],
              },
              Bottoms: [],
              Shoes: [],
              Cap: [],
              Glasses: [],
              Mask: [],
              EarWear: [],
            };
            for (let i = 0; i < allAssets.length; i++) {
              if (allAssets[i].category === "head") {
                obj.head.push(allAssets[i]);
              } else if (allAssets[i].category === "hair") {
                obj.hair.push(allAssets[i]);
              } else if (allAssets[i].category === "Mouth") {
                obj.Mouth.push(allAssets[i]);
              } else if (allAssets[i].category === "Nose") {
                obj.Nose.push(allAssets[i]);
              } else if (allAssets[i].category === "Eyes") {
                if (allAssets[i].subCategory === "eye") {
                  obj.Eyes.eye.push(allAssets[i]);
                } else if (allAssets[i].subCategory === "EyeBrows") {
                  obj.Eyes.EyeBrows.push(allAssets[i]);
                }
              } else if (allAssets[i].category === "Shirts") {
                if (allAssets[i].subCategory === "Shirt") {
                  obj.Shirts.Shirt.push(allAssets[i]);
                } else if (allAssets[i].subCategory === "Sweaters") {
                  obj.Shirts.Sweaters.push(allAssets[i]);
                } else if (allAssets[i].subCategory === "Jackets") {
                  obj.Shirts.Jackets.push(allAssets[i]);
                }
              } else if (allAssets[i].category === "Bottoms") {
                obj.Bottoms.push(allAssets[i]);
              } else if (allAssets[i].category === "Shoes") {
                obj.Shoes.push(allAssets[i]);
              } else if (allAssets[i].category === "Cap") {
                obj.Cap.push(allAssets[i]);
              } else if (allAssets[i].category === "Glasses") {
                obj.Glasses.push(allAssets[i]);
              } else if (allAssets[i].category === "EarWear") {
                obj.EarWear.push(allAssets[i]);
              } else if (allAssets[i].category === "Mask") {
                obj.Mask.push(allAssets[i]);
              }
            }
            let data = {
              Male: CharacterAssets.Male,
              Female: obj,
            };
            setCharacterAssets(data);
          })
          .catch((error) => { });
      } else {
        setAssetData(CharacterAssets.Female);
      }
    }
  };

  useEffect(() => {
    if (ActiveGender === "Male") {
      setAssetData(CharacterAssets.Male);
    } else {
      setAssetData(CharacterAssets.Female);
    }
  }, [CharacterAssets]);

  const fullBodyColor = (params, ChrSettings) => {
    return new Promise((resolve, reject) => {
      let json = NewJson;

      var colors = params.split("(");
      var changeColor = colors[1].split(")");
      var rgbArray = changeColor[0].split(",");
      var rgbConverted = [],
        DarkRgbConverted = [],
        LiteRgbConverted = [],
        NoseShades = [],
        NeckShades = [],
        NoseDiff = [40, 60, 80],
        NeckDiff = [15, 17, 16];

      for (var z = 0; z < rgbArray.length; z++) {
        //convert rbg into the json rgb
        rgbConverted.push(rgbArray[z] / 25 / 10);
      }

      for (let Ns = 0; Ns < rgbArray.length; Ns++) {
        NoseShades.push(rgbArray[Ns] - NoseDiff[Ns]);
      }

      for (let Neck = 0; Neck < rgbArray.length; Neck++) {
        NeckShades.push(rgbArray[Neck] - NeckDiff[Neck]);
      }

      for (var Dshd = 0; Dshd < NoseShades.length; Dshd++) {
        //convert rbg into the json rgb
        DarkRgbConverted.push(NoseShades[Dshd] / 25 / 10);
      }

      for (var Lshd = 0; Lshd < NeckShades.length; Lshd++) {
        //convert rbg into the json rgb
        LiteRgbConverted.push(NeckShades[Lshd] / 25 / 10);
      }

      for (let diff = 0; diff < json.assets.length; diff++) {
        if (json.assets[diff].id === "comp_0") {
          for (var Layr = 0; Layr < json.assets[diff].layers.length; Layr++) {
            for (var x = 0; x < skinparts.length; x++) {
              if (json.assets[diff].layers[Layr].nm === skinparts[x]) {
                if (json.assets[diff].layers[Layr].nm === "Nose_Comp") {
                  for (
                    let a = 0;
                    a < json.assets[diff].layers[Layr].layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers[Layr].layers[a].shapes.length;
                      b++
                    ) {
                      if (
                        json.assets[diff].layers[Layr].layers[a].shapes[b].it !=
                        undefined
                      ) {
                        for (
                          let c = 0;
                          c <
                          json.assets[diff].layers[Layr].layers[a].shapes[b].it
                            .length;
                          c++
                        ) {
                          if (
                            json.assets[diff].layers[Layr].layers[a].shapes[b]
                              .it[c].ty === "fl"
                          ) {
                            for (let d = 0; d < DarkRgbConverted.length; d++) {
                              json.assets[diff].layers[Layr].layers[a].shapes[
                                b
                              ].it[c].c.k[d] = DarkRgbConverted[d];
                            }
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers[Layr].nm === "Mouth_Comp") {
                  if (props.Gender == "Male") {
                    for (
                      let a = 0;
                      a < json.assets[diff].layers[Layr].layers.length;
                      a++
                    ) {
                      for (
                        let b = 0;
                        b <
                        json.assets[diff].layers[Layr].layers[a].shapes.length;
                        b++
                      ) {
                        if (
                          json.assets[diff].layers[Layr].layers[a].shapes[
                            b
                          ].nm.split("_")[0] == "Changeable"
                        ) {
                          for (
                            let c = 0;
                            c <
                            json.assets[diff].layers[Layr].layers[a].shapes[b]
                              .it.length;
                            c++
                          ) {
                            if (
                              json.assets[diff].layers[Layr].layers[a].shapes[b]
                                .it[c].ty === "fl"
                            ) {
                              for (
                                let d = 0;
                                d < DarkRgbConverted.length;
                                d++
                              ) {
                                json.assets[diff].layers[Layr].layers[a].shapes[
                                  b
                                ].it[c].c.k[d] = DarkRgbConverted[d];
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }

                if (
                  json.assets[diff].layers.find(x => x.nm === "Neck_Comp") ||
                  json.assets[diff].layersfind(x => x.nm === "Ear_Comp")
                ) {
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm === "Neck_Comp" || x.nm == "Ear_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm === "Neck_Comp" || x.nm == "Ear_Comp").layers[a].shapes.length;
                      b++
                    ) {
                      if (
                        json.assets[diff].layers.find(x => x.nm === "Neck_Comp" || x.nm == "Ear_Comp").layers[a].shapes[
                          b
                        ].nm.split("_")[0] === "Changeable"
                      ) {
                        for (
                          let c = 0;
                          c <
                          json.assets[diff].layers.find(x => x.nm === "Neck_Comp" || x.nm == "Ear_Comp").layers[a].shapes[b].it
                            .length;
                          c++
                        ) {
                          if (
                            json.assets[diff].layers.find(x => x.nm === "Neck_Comp" || x.nm == "Ear_Comp").layers[a].shapes[b]
                              .it[c].ty === "fl"
                          ) {
                            for (let d = 0; d < rgbConverted.length; d++) {
                              json.assets[diff].layers.find(x => x.nm === "Neck_Comp" || x.nm == "Ear_Comp").layers[a].shapes[
                                b
                              ].it[c].c.k[d] = rgbConverted[d];
                            }
                          }
                        }
                      } else {
                        for (
                          let c = 0;
                          c <
                          json.assets[diff].layers.find(x => x.nm === "Neck_Comp" || x.nm == "Ear_Comp").layers[a].shapes[b].it
                            .length;
                          c++
                        ) {
                          if (
                            json.assets[diff].layers.find(x => x.nm === "Neck_Comp" || x.nm == "Ear_Comp").layers[a].shapes[b]
                              .it[c].ty === "fl"
                          ) {
                            for (let d = 0; d < LiteRgbConverted.length; d++) {
                              json.assets[diff].layers.find(x => x.nm === "Neck_Comp" || x.nm == "Ear_Comp").layers[a].shapes[
                                b
                              ].it[c].c.k[d] = LiteRgbConverted[d];
                            }
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm === "Eye_Comp")) {
                  if (props.Gender === "Male") {
                    for (
                      let a = 0;
                      a < json.assets[diff].layers.find(x => x.nm === "Eye_Comp").layers.length;
                      a++
                    ) {
                      if (
                        json.assets[diff].layers.find(x => x.nm === "Eye_Comp").layers[a].nm === "Skin"
                      ) {
                        for (
                          let b = 0;
                          b <
                          json.assets[diff].layers.find(x => x.nm === "Eye_Comp").layers[a].shapes
                            .length;
                          b++
                        ) {
                          for (
                            let c = 0;
                            c <
                            json.assets[diff].layers.find(x => x.nm === "Eye_Comp").layers[a].shapes[b]
                              .it.length;
                            c++
                          ) {
                            if (
                              json.assets[diff].layers.find(x => x.nm === "Eye_Comp").layers[a].shapes[b]
                                .it[c].ty === "fl"
                            ) {
                              for (let d = 0; d < rgbConverted.length; d++) {
                                json.assets[diff].layers.find(x => x.nm === "Eye_Comp").layers[a].shapes[
                                  b
                                ].it[c].c.k[d] = rgbConverted[d];
                              }
                            }
                          }
                        }
                      } else {
                        for (
                          let b = 0;
                          b <
                          json.assets[diff].layers.find(x => x.nm === "Eye_Comp").layers[a].shapes
                            .length;
                          b++
                        ) {
                          if (
                            json.assets[diff].layers.find(x => x.nm === "Eye_Comp").layers[a].shapes[b]
                              .nm === "Skin"
                          ) {
                            for (
                              let c = 0;
                              c <
                              json.assets[diff].layers.find(x => x.nm === "Eye_Comp").layers[a].shapes[b]
                                .it.length;
                              c++
                            ) {
                              if (
                                json.assets[diff].layers.find(x => x.nm === "Eye_Comp").layers[a].shapes[
                                  b
                                ].it[c].ty === "fl"
                              ) {
                                for (let d = 0; d < rgbConverted.length; d++) {
                                  json.assets[diff].layers.find(x => x.nm === "Eye_Comp").layers[
                                    a
                                  ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  } else if (props.Gender === "Female") {
                    // for (
                    //   let a = 0;
                    //   a < json.assets[diff].layers.find(x=>x.nm=== "Eye_Comp").layers.length;
                    //   a++
                    // ) {
                    //   for (
                    //     let b = 0;
                    //     b <
                    //     json.assets[diff].layers.find(x=>x.nm=== "Eye_Comp").layers[a].layers.length;
                    //     b++
                    //   ) {
                    //     if (
                    //       json.assets[diff].layers.find(x=>x.nm=== "Eye_Comp").layers[a].layers[b]
                    //         .nm === "EyeLesh"
                    //     ) {
                    //       for (
                    //         let c = 0;
                    //         c <
                    //         json.assets[diff].layers.find(x=>x.nm=== "Eye_Comp").layers[a].layers[b]
                    //           .shapes.length;
                    //         c++
                    //       ) {
                    //         for (
                    //           let d = 0;
                    //           d <
                    //           json.assets[diff].layers.find(x=>x.nm=== "Eye_Comp").layers[a].layers[b]
                    //             .shapes[c].it.length;
                    //           d++
                    //         ) {
                    //           if (
                    //             json.assets[diff].layers.find(x=>x.nm=== "Eye_Comp").layers[a].layers[
                    //               b
                    //             ].shapes[c].it[d].ty === "fl"
                    //           ) {
                    //             for (let e = 0; e < rgbConverted.length; e++) {
                    //               json.assets[diff].layers.find(x=>x.nm=== "Eye_Comp").layers[
                    //                 a
                    //               ].layers[b].shapes[c].it[d].c.k[e] =
                    //                 rgbConverted[e];
                    //             }
                    //           }
                    //         }
                    //       }
                    //     }
                    //   }
                    // }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "Face_Comp")) {
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "Face_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "Face_Comp").layers[a].shapes.length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "Face_Comp").layers[a].shapes[b].it
                          .length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "Face_Comp").layers[a].shapes[b].it[
                            c
                          ].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "Face_Comp").layers[a].shapes[
                              b
                            ].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "L_Arm_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "L_Arm_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "L_Arm_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "L_Arm_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "L_Arm_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "L_Arm_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "L_Arm_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "R_Arm_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "R_Arm_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "R_Arm_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "R_Arm_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "R_Arm_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "R_Arm_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "R_Arm_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "R_ForeArm_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "R_ForeArm_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "R_ForeArm_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "R_ForeArm_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "R_ForeArm_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "R_ForeArm_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "R_ForeArm_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "L_ForeArm_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "L_ForeArm_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "L_ForeArm_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "L_ForeArm_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "L_ForeArm_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "L_ForeArm_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "L_ForeArm_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "L_Hand_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "L_Hand_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "L_Hand_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "L_Hand_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "L_Hand_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "L_Hand_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "L_Hand_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "R_Hand_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "R_Hand_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "R_Hand_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "R_Hand_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "R_Hand_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "R_Hand_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "R_Hand_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "BaseBody_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "BaseBody_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "BaseBody_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "BaseBody_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "BaseBody_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "BaseBody_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "BaseBody_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "Neck_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "Neck_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "Neck_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "Neck_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "Neck_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "Neck_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "Neck_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "Right_Shoulder")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "Right_Shoulder").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "Right_Shoulder").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "Right_Shoulder").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "Right_Shoulder").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "Right_Shoulder").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "Right_Shoulder").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "Left_Shoulder")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "Left_Shoulder").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "Left_Shoulder").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "Left_Shoulder").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "Left_Shoulder").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "Left_Shoulder").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "Left_Shoulder").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "L_Wing_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "L_Wing_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "L_Wing_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "L_Wing_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "L_Wing_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "L_Wing_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "L_Wing_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "R_Wing_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "R_Wing_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "R_Wing_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "R_Wing_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "R_Wing_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "R_Wing_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "R_Wing_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "L_Thigh_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "L_Thigh_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "L_Thigh_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "L_Thigh_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "L_Thigh_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "L_Thigh_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "L_Thigh_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "R_Thigh_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "R_Thigh_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "R_Thigh_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "R_Thigh_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "R_Thigh_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "R_Thigh_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "R_Thigh_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "L_Calf_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "L_Calf_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "L_Calf_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "L_Calf_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "L_Calf_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "L_Calf_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "L_Calf_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "R_Calf_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "R_Calf_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "R_Calf_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "R_Calf_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "R_Calf_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "R_Calf_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "R_Calf_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (
                  json.assets[diff].layers.find(x => x.nm == "SideHair_Comp")
                ) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "SideHair_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "SideHair_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "SideHair_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "SideHair_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "SideHair_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {

                          for (let d = 0; d < ChrSettings.Hair.colorShades.Shades[0].length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "SideHair_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = ChrSettings.Hair.colorShades.Shades[0][d] / 25 / 10;
                          }
                        }
                      }
                    }
                  }
                }

                if (
                  json.assets[diff].layers.find(x => x.nm == "BackHair_Comp")
                ) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "BackHair_Comp").layers.indexOf(json.assets[diff].layers.find(x => x.nm == "BackHair_Comp").layers.find(x => x.nm == ChrSettings.Hair.data));
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "BackHair_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "BackHair_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "BackHair_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "BackHair_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < ChrSettings.Hair.colorShades.Shades[0].length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "BackHair_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = ChrSettings.Hair.colorShades.Shades[0][d] / 25 / 10;
                          }
                        }
                      }
                    }
                  }
                }

                if (
                  json.assets[diff].layers.find(x => x.nm == "FrontHair_Comp")
                ) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "FrontHair_Comp").layers.indexOf(json.assets[diff].layers.find(x => x.nm == "FrontHair_Comp").layers.find(x => x.nm == ChrSettings.Hair.data));
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "FrontHair_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "FrontHair_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "FrontHair_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "FrontHair_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < ChrSettings.Hair.colorShades.Shades[0].length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "FrontHair_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = ChrSettings.Hair.colorShades.Shades[0][d] / 25 / 10;
                          }
                        }
                      }
                    }
                  }
                }

                if (
                  json.assets[diff].layers.find(x => x.nm == "Beard_Comp")
                ) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "Beard_Comp").layers.indexOf(json.assets[diff].layers.find(x => x.nm == "Beard_Comp").layers.find(x => x.nm == ChrSettings.Hair.data));
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "Beard_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "Beard_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "Beard_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "Beard_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < ChrSettings.Hair.colorShades.Shades[0].length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "Beard_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = ChrSettings.Hair.colorShades.Shades[0][d] / 25 / 10;
                          }
                        }
                      }
                    }
                  }
                }


                if (json.assets[diff].layers.find(x => x.nm == "L_Foot_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "L_Foot_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "L_Foot_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "L_Foot_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "L_Foot_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "L_Foot_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "L_Foot_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "R_Foot_Comp")) {
                  var lastLayer =
                    json.assets[diff].layers.find(x => x.nm == "R_Foot_Comp").layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers.find(x => x.nm == "R_Foot_Comp").layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers.find(x => x.nm == "R_Foot_Comp").layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers.find(x => x.nm == "R_Foot_Comp").layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers.find(x => x.nm == "R_Foot_Comp").layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers.find(x => x.nm == "R_Foot_Comp").layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (json.assets[diff].layers.find(x => x.nm == "Eye_Comp")) {
                  if (props.Gender === "Male" || props.Gender === "Female") {
                    for (
                      let a = 0;
                      a < json.assets[diff].layers.length;
                      a++
                    ) {
                      if (json.assets[diff].layers.find(x => x.nm == "Eye_Comp").layers.find(x => x.nm == "Skin")) {
                        for (
                          let b = 0;
                          b < json.assets[diff].layers.find(x => x.nm == "Eye_Comp").layers.find(x => x.nm == "Skin").shapes.length;
                          b++
                        ) {
                          for (
                            let c = 0;
                            c <
                            json.assets[diff].layers.find(x => x.nm == "Eye_Comp").layers.find(x => x.nm == "Skin").shapes[b].it.length;
                            c++
                          ) {
                            if (
                              json.assets[diff].layers.find(x => x.nm == "Eye_Comp").layers.find(x => x.nm == "Skin").shapes[b].it[c]
                                .ty === "fl"
                            ) {
                              for (
                                let dr = 0;
                                dr < rgbConverted.length;
                                dr++
                              ) {
                                json.assets[diff].layers.find(x => x.nm == "Eye_Comp").layers.find(x => x.nm == "Skin").shapes[b].it[
                                  c
                                ].c.k[dr] = rgbConverted[dr];
                              }
                            }
                          }
                        }
                      } else {
                        for (
                          let b = 0;
                          b < json.assets[diff].layers.find(x => x.nm == "Eye_Comp").layers.find(x => x.nm == "Skin").shapes.length;
                          b++
                        ) {
                          if (
                            json.assets[diff].layers.find(x => x.nm == "Eye_Comp").layers.find(x => x.nm == "Skin").shapes[b].nm ===
                            "Skin"
                          ) {
                            for (
                              let c = 0;
                              c <
                              json.assets[diff].layers.find(x => x.nm == "Eye_Comp").layers.find(x => x.nm == "Skin").shapes[b].it
                                .length;
                              c++
                            ) {
                              if (
                                json.assets[diff].layers.find(x => x.nm == "Eye_Comp").layers.find(x => x.nm == "Skin").shapes[b].it[c]
                                  .ty === "fl"
                              ) {
                                for (
                                  let dr = 0;
                                  dr < rgbConverted.length;
                                  dr++
                                ) {
                                  json.assets[diff].layers.find(x => x.nm == "Eye_Comp").layers.find(x => x.nm == "Skin").shapes[b].it[
                                    c
                                  ].c.k[dr] = rgbConverted[dr];
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }



                if (
                  json.assets[diff].layers[Layr].nm === "L_Thigh_Comp" ||
                  json.assets[diff].layers[Layr].nm === "R_Thigh_Comp"
                ) {
                  var lastLayer =
                    json.assets[diff].layers[Layr].layers.length - 1;

                  for (
                    let a = 0;
                    a < json.assets[diff].layers[Layr].layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers[Layr].layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      if (
                        json.assets[diff].layers[Layr].layers[lastLayer].shapes[
                          b
                        ].nm === "N_Thigh"
                      ) {
                        for (
                          let c = 0;
                          c <
                          json.assets[diff].layers[Layr].layers[lastLayer]
                            .shapes[b].it.length;
                          c++
                        ) {
                          if (
                            json.assets[diff].layers[Layr].layers[lastLayer]
                              .shapes[b].it[c].ty === "fl"
                          ) {
                            for (let d = 0; d < rgbConverted.length; d++) {
                              json.assets[diff].layers[Layr].layers[
                                lastLayer
                              ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                            }
                          }
                        }
                      }
                    }
                    break;
                  }
                }

                if (
                  json.assets[diff].layers[Layr].nm === "L_Foot_Comp" ||
                  json.assets[diff].layers[Layr].nm === "R_Foot_Comp"
                ) {
                  if (props.Gender == "Female") {
                    for (
                      let a = 0;
                      a < json.assets[diff].layers[Layr].layers.length;
                      a++
                    ) {
                      for (
                        let b = 0;
                        b <
                        json.assets[diff].layers[Layr].layers[a].shapes.length;
                        b++
                      ) {
                        if (
                          json.assets[diff].layers[Layr].layers[a].shapes[b]
                            .nm === "Shoe_Skin"
                        ) {
                          for (
                            let c = 0;
                            c <
                            json.assets[diff].layers[Layr].layers[a].shapes[b]
                              .it.length;
                            c++
                          ) {
                            if (
                              json.assets[diff].layers[Layr].layers[a].shapes[b]
                                .it[c].ty === "fl"
                            ) {
                              for (let d = 0; d < rgbConverted.length; d++) {
                                json.assets[diff].layers[Layr].layers[a].shapes[
                                  b
                                ].it[c].c.k[d] = rgbConverted[d];
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  var LL = json.assets[diff].layers[Layr].layers.length - 1;

                  for (
                    let a = 0;
                    a < json.assets[diff].layers[Layr].layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers[Layr].layers[LL].shapes.length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers[Layr].layers[LL].shapes[b].it
                          .length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers[Layr].layers[LL].shapes[b]
                            .it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers[Layr].layers[LL].shapes[
                              b
                            ].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }

                if (
                  json.assets[diff].layers[Layr].nm !== "Nose_Comp" &&
                  json.assets[diff].layers[Layr].nm !== "Neck_Comp" &&
                  json.assets[diff].layers[Layr].nm !== "Eye_Comp" &&
                  json.assets[diff].layers[Layr].nm !== "Mouth_Comp" &&
                  json.assets[diff].layers[Layr].nm !== "L_Thigh_Comp" &&
                  json.assets[diff].layers[Layr].nm !== "R_Thigh_Comp" &&
                  json.assets[diff].layers[Layr].nm !== "Ear_Comp" &&
                  json.assets[diff].layers[Layr].nm !== "Face_Comp" &&
                  json.assets[diff].layers[Layr].nm !== "R_Foot_Comp" &&
                  json.assets[diff].layers[Layr].nm !== "L_Foot_Comp"
                ) {
                  var lastLayer =
                    json.assets[diff].layers[Layr].layers.length - 1;
                  for (
                    let a = 0;
                    a < json.assets[diff].layers[Layr].layers.length;
                    a++
                  ) {
                    for (
                      let b = 0;
                      b <
                      json.assets[diff].layers[Layr].layers[lastLayer].shapes
                        .length;
                      b++
                    ) {
                      for (
                        let c = 0;
                        c <
                        json.assets[diff].layers[Layr].layers[lastLayer].shapes[
                          b
                        ].it.length;
                        c++
                      ) {
                        if (
                          json.assets[diff].layers[Layr].layers[lastLayer]
                            .shapes[b].it[c].ty === "fl"
                        ) {
                          for (let d = 0; d < rgbConverted.length; d++) {
                            json.assets[diff].layers[Layr].layers[
                              lastLayer
                            ].shapes[b].it[c].c.k[d] = rgbConverted[d];
                          }
                        }
                      }
                    }
                  }
                }
                break;
              }
            }
          }
        }
      }
      resolve();
    });
  };

  async function ColorAndClotheClick(chrSet, ChrName) {
    props.setCharacterName(ChrName);
    var ChrSettings = JSON.parse(chrSet);
    var json = NewJson;

    for (let index = 0; index < ActivePartName.length; index++) {
      var NewName;

      var Name = ChrSettings[ActivePartName[index]].data;

      if (ChrSettings[ActivePartName[index]].data !== null) {
        NewName = ChrSettings[ActivePartName[index]].data.split("_")[0];
      }

      if (props.Gender === "Female") {
        for (let a = 0; a < FemaleBodyParts.length; a++) {
          if (FemaleBodyParts[a].name === ActivePartName[index]) {
            PartsName = FemaleBodyParts[a].parts;
          }
        }
      } else if (props.Gender === "Male") {
        for (let a = 0; a < MaleBodyParts.length; a++) {
          if (MaleBodyParts[a].name === ActivePartName[index]) {
            PartsName = MaleBodyParts[a].parts;
          }
        }
      }

      try {
        for (let b = 0; b < json.assets.length; b++) {
          if (json.assets[b].id === "comp_0") {
            for (let c = 0; c < json.assets[b].layers.length; c++) {
              for (let d = 0; d < PartsName.length; d++) {
                if (json.assets[b].layers[c].nm === PartsName[d]) {
                  for (
                    let e = 0;
                    e < json.assets[b].layers[c].layers.length;
                    e++
                  ) {
                    if (
                      json.assets[b].layers[c].layers[e].nm.split("_")[0] ===
                      ActivePartName[index]
                    ) {
                      //json.assets[b].layers[c].layers[e].hd = true;

                      if (json.assets[b].layers[c].layers[e].nm !== "Mouth_Static") {
                        json.assets[b].layers[c].layers[e].hd = true;
                      }

                      if (props.Gender == "Male") {
                        if (json.assets[b].layers.find(x => x.nm == "BackHair_Comp").layers.find(x => x.nm == ChrSettings.Hair.data))
                          json.assets[b].layers.find(x => x.nm == "BackHair_Comp").layers.find(x => x.nm == ChrSettings.Hair.data).hd = false;

                        if (json.assets[b].layers.find(x => x.nm == "SideHair_Comp").layers.find(x => x.nm == ChrSettings.Hair.data))
                          json.assets[b].layers.find(x => x.nm == "SideHair_Comp").layers.find(x => x.nm == ChrSettings.Hair.data).hd = false;


                        if (json.assets[b].layers[c].nm == "FrontHair_Comp") {
                          if (json.assets[b].layers[c].layers.find(x => x.hd == false)) {
                            json.assets[b].layers[c].layers.find(x => x.hd == false).hd = true;
                          }
                          json.assets[b].layers[c].layers.find(x => x.nm == "Hair_0").hd = true;

                          if (json.assets[b].layers.find(x => x.nm == "BackHair_Comp").layers.find(x => x.hd == false)) {
                            json.assets[b].layers.find(x => x.nm == "BackHair_Comp").layers.find(x => x.hd == false).hd = true;
                          }
                          if (json.assets[b].layers.find(x => x.nm == "SideHair_Comp").layers.find(x => x.hd == false)) {
                            json.assets[b].layers.find(x => x.nm == "SideHair_Comp").layers.find(x => x.hd == false).hd = true;
                          }

                        }
                      }

                      // if (
                      //   json.assets[b].layers[c].nm == "FrontHair_Comp" ||
                      //   json.assets[b].layers[c].nm == "SideHair_Comp"
                      //   ||
                      //   json.assets[b].layers[c].nm == "BackHair_Comp"
                      // ) {
                      //   json.assets[b].layers[c].nm.hd = true;
                      // }
                      // if(json.assets[b].layers[c].layers[e].nm == "Mouth_Talk")
                      // {
                      //   json.assets[b].layers[c].layers[e].hd = false;                         
                      // }        

                      if (ActivePartName[index] === "Eye") {
                        if (props.Gender === "Female") {
                          let check =
                            json.assets[b].layers[c].layers[e].nm.split(Name);
                          if (check.length != 1) {
                            json.assets[b].layers[c].layers[e].hd = false;

                            if (check[1].split("-")[1] === "EyeBall") {
                              for (
                                let Sn = 0;
                                Sn <
                                ChrSettings[ActivePartName[index]].colorShades
                                  .ShadeName.length;
                                Sn++
                              ) {
                                for (
                                  let es = 0;
                                  es <
                                  json.assets[b].layers[c].layers[e].shapes
                                    .length;
                                  es++
                                ) {
                                  if (
                                    json.assets[b].layers[c].layers[e].shapes[
                                      es
                                    ].nm ===
                                    ChrSettings[ActivePartName[index]]
                                      .colorShades.ShadeName[Sn]
                                  ) {
                                    for (
                                      let clrz = 0;
                                      clrz <
                                      json.assets[b].layers[c].layers[e].shapes[
                                        es
                                      ].it.length;
                                      clrz++
                                    ) {
                                      if (
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[es].it[clrz].ty === "fl"
                                      ) {
                                        for (let clra = 0; clra < 3; clra++) {
                                          json.assets[b].layers[c].layers[
                                            e
                                          ].shapes[es].it[clrz].c.k[clra] =
                                            ChrSettings[ActivePartName[index]]
                                              .colorShades.Shades[Sn][clra] /
                                            25 /
                                            10;
                                        }
                                        break;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        } else if (props.Gender === "Male") {
                          if (json.assets[b].layers[c].layers[e].nm === Name) {
                            json.assets[b].layers[c].layers[e].hd = false;
                            for (
                              let Sn = 0;
                              Sn <
                              ChrSettings[ActivePartName[index]].colorShades
                                .ShadeName.length;
                              Sn++
                            ) {
                              for (
                                let clry = 0;
                                clry <
                                json.assets[b].layers[c].layers[e].shapes
                                  .length;
                                clry++
                              ) {
                                if (
                                  json.assets[b].layers[c].layers[e].shapes[
                                    clry
                                  ].nm ===
                                  ChrSettings[ActivePartName[index]].colorShades
                                    .ShadeName[Sn]
                                ) {
                                  for (
                                    let clrz = 0;
                                    clrz <
                                    json.assets[b].layers[c].layers[e].shapes[
                                      clry
                                    ].it.length;
                                    clrz++
                                  ) {
                                    if (
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].it[clrz].ty === "fl"
                                    ) {
                                      for (let clra = 0; clra < 3; clra++) {
                                        json.assets[b].layers[c].layers[
                                          e
                                        ].shapes[clry].it[clrz].c.k[clra] =
                                          ChrSettings[ActivePartName[index]]
                                            .colorShades.Shades[Sn][clra] /
                                          25 /
                                          10;
                                      }
                                      break;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else if (ActivePartName[index] === "Mouth") {
                        let data =
                          json.assets[b].layers[c].layers[e].nm.split("-");
                        if (data.length == 1) {
                          if (data[0] == Name) {
                            json.assets[b].layers[c].layers[e].hd = false;
                          }
                        } else {
                          if (data[0] == Name) {
                            json.assets[b].layers[c].layers[e].hd = false;
                          }
                        }
                      } else {
                        if (json.assets[b].layers[c].layers[e].nm === Name) {
                          json.assets[b].layers[c].layers[e].hd = false;

                          if (
                            ChrSettings[ActivePartName[index]].colorShades
                              .ShadeName !== ""
                          ) {
                            if (ActivePartName[index] === "Face") {
                              let r = Math.round(
                                ChrSettings[ActivePartName[index]].colorShades
                                  .Shades[0][0]
                              );
                              let g = Math.round(
                                ChrSettings[ActivePartName[index]].colorShades
                                  .Shades[0][1]
                              );
                              let b = Math.round(
                                ChrSettings[ActivePartName[index]].colorShades
                                  .Shades[0][2]
                              );
                              let rbg = "rgb(" + r + "," + g + "," + b + ")";

                              await fullBodyColor(rbg, ChrSettings);
                            } else if (ActivePartName[index] === "Hair") {
                              for (
                                let Sn = 0;
                                Sn <
                                ChrSettings[ActivePartName[index]].colorShades
                                  .ShadeName.length;
                                Sn++
                              ) {
                                for (
                                  let clry = 0;
                                  clry <
                                  json.assets[b].layers[c].layers[e].shapes
                                    .length;
                                  clry++
                                ) {
                                  if (
                                    json.assets[b].layers[c].layers[e].shapes[
                                      clry
                                    ].nm ===
                                    ChrSettings[ActivePartName[index]]
                                      .colorShades.ShadeName[Sn]
                                  ) {
                                    for (
                                      let clrz = 0;
                                      clrz <
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].it.length;
                                      clrz++
                                    ) {
                                      if (
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].it[clrz].ty === "fl"
                                      ) {
                                        for (let clra = 0; clra < 3; clra++) {
                                          json.assets[b].layers[c].layers[
                                            e
                                          ].shapes[clry].it[clrz].c.k[clra] =
                                            ChrSettings[ActivePartName[index]]
                                              .colorShades.Shades[Sn][clra] /
                                            25 /
                                            10;
                                        }
                                        break;
                                      }
                                    }
                                  }
                                }
                              }

                              if (ChrSettings["Cap"].data !== null) {
                                let part = [
                                  "SideHair_Comp",
                                  "FrontHair_Comp",
                                  "BackHair_Comp",
                                ];

                                for (
                                  let c = 0;
                                  c < json.assets[b].layers.length;
                                  c++
                                ) {
                                  for (let d = 0; d < part.length; d++) {
                                    if (
                                      json.assets[b].layers[c].nm === part[d]
                                    ) {
                                      for (
                                        let e = 0;
                                        e <
                                        json.assets[b].layers[c].layers.length;
                                        e++
                                      ) {
                                        json.assets[b].layers[c].layers[
                                          e
                                        ].hd = true;

                                        if (
                                          json.assets[b].layers[c].layers[e]
                                            .nm ===
                                          ChrSettings["Hair"].data + "-Cap"
                                        ) {
                                          json.assets[b].layers[c].layers[
                                            e
                                          ].hd = false;

                                          for (
                                            let Sn = 0;
                                            Sn <
                                            ChrSettings[ActivePartName[index]]
                                              .colorShades.ShadeName.length;
                                            Sn++
                                          ) {
                                            for (
                                              let clry = 0;
                                              clry <
                                              json.assets[b].layers[c].layers[e]
                                                .shapes.length;
                                              clry++
                                            ) {
                                              if (
                                                json.assets[b].layers[c].layers[
                                                  e
                                                ].shapes[clry].nm ===
                                                ChrSettings[
                                                  ActivePartName[index]
                                                ].colorShades.ShadeName[Sn]
                                              ) {
                                                for (
                                                  let clrz = 0;
                                                  clrz <
                                                  json.assets[b].layers[c]
                                                    .layers[e].shapes[clry].it
                                                    .length;
                                                  clrz++
                                                ) {
                                                  if (
                                                    json.assets[b].layers[c]
                                                      .layers[e].shapes[clry]
                                                      .it[clrz].ty === "fl"
                                                  ) {
                                                    for (
                                                      let clra = 0;
                                                      clra < 3;
                                                      clra++
                                                    ) {
                                                      json.assets[b].layers[
                                                        c
                                                      ].layers[e].shapes[
                                                        clry
                                                      ].it[clrz].c.k[clra] =
                                                        ChrSettings[
                                                          ActivePartName[index]
                                                        ].colorShades.Shades[
                                                        Sn
                                                        ][clra] /
                                                        25 /
                                                        10;
                                                    }
                                                    break;
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }

                              if (props.Gender === "Male") {
                                for (
                                  let c2 = 0;
                                  c2 < json.assets[b].layers.length;
                                  c2++
                                ) {
                                  if (
                                    json.assets[b].layers[c2].nm ===
                                    "EyeBrow_Comp"
                                  ) {
                                    for (
                                      let e = 0;
                                      e <
                                      json.assets[b].layers[c2].layers.length;
                                      e++
                                    ) {
                                      for (
                                        let clry = 0;
                                        clry <
                                        json.assets[b].layers[c2].layers[e]
                                          .shapes.length;
                                        clry++
                                      ) {
                                        for (
                                          let clrz = 0;
                                          clrz <
                                          json.assets[b].layers[c2].layers[e]
                                            .shapes[clry].it.length;
                                          clrz++
                                        ) {
                                          if (
                                            json.assets[b].layers[c2].layers[e]
                                              .shapes[clry].it[clrz].ty === "fl"
                                          ) {
                                            for (
                                              let clra = 0;
                                              clra < 3;
                                              clra++
                                            ) {
                                              json.assets[b].layers[c2].layers[
                                                e
                                              ].shapes[clry].it[clrz].c.k[
                                                clra
                                              ] =
                                                ChrSettings[
                                                  ActivePartName[index]
                                                ].colorShades.Shades[0][clra] /
                                                255;
                                            }
                                            break;
                                          }
                                        }
                                      }
                                    }
                                    break;
                                  }
                                }
                                for (
                                  let c3 = 0;
                                  c3 < json.assets[b].layers.length;
                                  c3++
                                ) {
                                  if (
                                    json.assets[b].layers[c3].nm ===
                                    "Mouth_Comp"
                                  ) {
                                    for (
                                      let e = 0;
                                      e <
                                      json.assets[b].layers[c3].layers.length;
                                      e++
                                    ) {

                                      for (
                                        let clry = 0;
                                        clry <
                                        json.assets[b].layers[c3].layers.filter(x => x.nm != "Mouth_Static" && x.nm != "Mouth_Talk")[e].shapes.length;
                                        clry++
                                      ) {
                                        if (
                                          json.assets[b].layers[c3].layers.filter(x => x.nm != "Mouth_Static" && x.nm != "Mouth_Talk")[e]
                                            .shapes[clry].nm == "Hair"
                                        ) {
                                          for (
                                            let clrz = 0;
                                            clrz <
                                            json.assets[b].layers[c3].layers.filter(x => x.nm != "Mouth_Static" && x.nm != "Mouth_Talk")[e]
                                              .shapes[clry].it.length;
                                            clrz++
                                          ) {
                                            if (
                                              json.assets[b].layers[c3].layers.filter(x => x.nm != "Mouth_Static" && x.nm != "Mouth_Talk")[e]
                                                .shapes[clry].it[clrz].ty ===
                                              "fl"
                                            ) {
                                              for (
                                                let clra = 0;
                                                clra < 3;
                                                clra++
                                              ) {
                                                json.assets[b].layers[c3].layers.filter(x => x.nm != "Mouth_Static" && x.nm != "Mouth_Talk")[e].shapes[clry].it[
                                                  clrz
                                                ].c.k[clra] =
                                                  ChrSettings[
                                                    ActivePartName[index]
                                                  ].colorShades.Shades[0][
                                                  clra
                                                  ] / 255;
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                    break;
                                  }
                                }
                              } else {
                                for (
                                  let c2 = 0;
                                  c2 < json.assets[b].layers.length;
                                  c2++
                                ) {
                                  if (
                                    json.assets[b].layers[c2].nm ===
                                    "EyeBrow_Comp"
                                  ) {
                                    for (
                                      let e = 0;
                                      e <
                                      json.assets[b].layers[c2].layers.length;
                                      e++
                                    ) {
                                      for (
                                        let clry = 0;
                                        clry <
                                        json.assets[b].layers[c2].layers[e]
                                          .shapes.length;
                                        clry++
                                      ) {
                                        for (
                                          let clrz = 0;
                                          clrz <
                                          json.assets[b].layers[c2].layers[e]
                                            .shapes[clry].it.length;
                                          clrz++
                                        ) {
                                          if (
                                            json.assets[b].layers[c2].layers[e]
                                              .shapes[clry].it[clrz].ty === "fl"
                                          ) {
                                            for (
                                              let clra = 0;
                                              clra < 3;
                                              clra++
                                            ) {
                                              json.assets[b].layers[c2].layers[
                                                e
                                              ].shapes[clry].it[clrz].c.k[
                                                clra
                                              ] =
                                                ChrSettings[
                                                  ActivePartName[index]
                                                ].colorShades.Shades[0][clra] /
                                                25 /
                                                10;
                                            }
                                            break;
                                          }
                                        }
                                      }
                                    }
                                    break;
                                  }
                                }
                              }
                            } else {
                              for (
                                let Sn = 0;
                                Sn <
                                ChrSettings[ActivePartName[index]].colorShades
                                  .ShadeName.length;
                                Sn++
                              ) {
                                for (
                                  let clry = 0;
                                  clry <
                                  json.assets[b].layers[c].layers[e].shapes
                                    .length;
                                  clry++
                                ) {
                                  if (
                                    json.assets[b].layers[c].layers[e].shapes[
                                      clry
                                    ].nm ===
                                    ChrSettings[ActivePartName[index]]
                                      .colorShades.ShadeName[Sn]
                                  ) {
                                    for (
                                      let clrz = 0;
                                      clrz <
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].it.length;
                                      clrz++
                                    ) {
                                      if (
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].it[clrz].ty === "fl"
                                      ) {
                                        for (let clra = 0; clra < 3; clra++) {
                                          json.assets[b].layers[c].layers[
                                            e
                                          ].shapes[clry].it[clrz].c.k[clra] =
                                            ChrSettings[ActivePartName[index]]
                                              .colorShades.Shades[Sn][clra] /
                                            25 /
                                            10;
                                        }
                                        break;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    if (
                      PartsName[d].split("_Comp")[0] ==
                      json.assets[b].layers[c].layers[e].nm
                    ) {
                      if (
                        PartsName[d] != "L_Foot_Comp" &&
                        PartsName[d] != "R_Foot_Comp"
                      ) {
                        json.assets[b].layers[c].layers[e].hd = false;
                      }
                    } else if (
                      json.assets[b].layers[c].layers[e].nm == "BaseBody"
                    ) {
                      if (
                        PartsName[d] != "L_Foot_Comp" &&
                        PartsName[d] != "R_Foot_Comp"
                      ) {
                        json.assets[b].layers[c].layers[e].hd = false;
                      }
                    }
                  }
                  break;
                }
              }
            }
            break;
          }
        }
      } catch (error) { }


    }
    console.log(json);
    var currFrame = Play.currentFrame;
    Lottie.destroy("alex");
    const ctx = document.getElementsByClassName("ChrClass")[0].getContext("2d");

    get = Lottie.loadAnimation({
      name: "alex",
      renderer: "canvas",
      loop: true,
      autoplay: true,
      animationData: NewJson,
      rendererSettings: {
        context: ctx,
        scaleMode: "noScale",
        clearCanvas: true,
      },
    });
    get.goToAndPlay(currFrame, true, "alex");
    setPlay(get);
    setActiveParts(ChrSettings);
  }

  useEffect(() => {
    if (props.UploadData != null) {
      Uploader();
      // JsonChanger()
    }
  }, [props.UploadData]);

  const Uploader = () => {
    get.goToAndStop(1, true);
    var largeCanvas = document.getElementsByClassName("ChrClass")[0];
    var image = largeCanvas.toDataURL("image/png");
    const ctx = document
      .getElementsByClassName("character_canv")[0]
      .getContext("2d");
    let canvas = document.getElementsByClassName("character_canv")[0];
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const small = Lottie.loadAnimation({
      name: "smallAlex",
      renderer: "canvas",
      loop: true,
      autoplay: true,
      animationData: get.animationData,
      rendererSettings: {
        context: ctx,
        scaleMode: "noScale",
        clearCanvas: true,
      },
    });

    let count = 0;
    var smallImage;

    small.addEventListener("enterFrame", function () {
      if (count === 2) {
        smallImage = canvas.toDataURL("image/png");
        Lottie.destroy("smallAlex");
        start(image, smallImage);
      }
      count++;
    });
  };

  //MaleCharacter_Final_Wave.json

  const JsonChanger = async () => {
    const resp = await fetch(
      authenticationData.ApiBaseURL +
      "/assets/Animated_Character/" +
      props.Gender +
      "Character_Final_Satisfied.json"
    );
    const jsonData = await resp.json();

    let json = clone(jsonData);

    let rgbArray,
      rgbConverted = [],
      DarkRgbConverted = [],
      LiteRgbConverted = [],
      NoseShades = [],
      NeckShades = [];
    var NeckDiff = [15, 17, 16],
      NoseDiff = [40, 60, 80];
    var ReducerArray;

    if (props.Gender === "Female") {
      ReducerArray = FemaleReducerArray;
    } else if (props.Gender === "Male") {
      ReducerArray = MaleReducerArray;
    }

    for (let start = 0; start < json.assets.length; start++) {
      if (json.assets[start].id === "comp_0") {
        for (let c = 0; c < json.assets[start].layers.length; c++) {
          if (ReducerArray[json.assets[start].layers[c].nm] !== undefined) {
            let CompName = json.assets[start].layers[c].nm;
            let CompId = json.assets[start].layers[c].refId;

            for (let d = 1; d < json.assets.length; d++) {
              if (json.assets[d].id === CompId) {
                if (ReducerArray[CompName].data !== undefined) {
                  for (let f = 0; f < ReducerArray[CompName].data.length; f++) {
                    let PartName = ReducerArray[CompName].data[f];
                    if (ActiveParts[PartName] != undefined) {
                      for (let e = 0; e < json.assets[d].layers.length; e++) {
                        if (
                          json.assets[d].layers[e].nm.split("_")[0] == PartName
                        ) {
                          json.assets[d].layers[e].hd = true;

                          if (PartName === "Eye") {
                            if (ActiveParts[PartName].data !== null) {
                              if (props.Gender === "Female") {
                                let name = ActiveParts[PartName].data;
                                if (json.assets[d].layers[e].nm == name) {
                                  json.assets[d].layers[e].hd = false;

                                  for (let s = 1; s < json.assets.length; s++) {
                                    if (
                                      json.assets[s].id ===
                                      json.assets[d].layers[e].refId
                                    ) {
                                      for (
                                        let ind = 0;
                                        ind < json.assets[s].layers.length;
                                        ind++
                                      ) {
                                        if (
                                          json.assets[s].layers[ind].nm ===
                                          "EyeBall"
                                        ) {
                                          for (
                                            let Sn = 0;
                                            Sn <
                                            ActiveParts[PartName].colorShades
                                              .ShadeName.length;
                                            Sn++
                                          ) {
                                            for (
                                              let es = 0;
                                              es <
                                              json.assets[s].layers[ind].shapes
                                                .length;
                                              es++
                                            ) {
                                              if (
                                                json.assets[s].layers[ind]
                                                  .shapes[es].nm ===
                                                ActiveParts[PartName]
                                                  .colorShades.ShadeName[Sn]
                                              ) {
                                                for (
                                                  let clrz = 0;
                                                  clrz <
                                                  json.assets[s].layers[ind]
                                                    .shapes[es].it.length;
                                                  clrz++
                                                ) {
                                                  if (
                                                    json.assets[s].layers[ind]
                                                      .shapes[es].it[clrz]
                                                      .ty === "fl"
                                                  ) {
                                                    for (
                                                      let clra = 0;
                                                      clra < 3;
                                                      clra++
                                                    ) {
                                                      json.assets[s].layers[
                                                        ind
                                                      ].shapes[es].it[clrz].c.k[
                                                        clra
                                                      ] =
                                                        ActiveParts[PartName]
                                                          .colorShades.Shades[
                                                        Sn
                                                        ][clra] /
                                                        25 /
                                                        10;
                                                    }
                                                    break;
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              } else if (props.Gender === "Male") {
                                if (
                                  json.assets[d].layers[e].nm ==
                                  ActiveParts[PartName].data
                                ) {
                                  json.assets[d].layers[e].hd = false;

                                  for (
                                    let Sn = 0;
                                    Sn <
                                    ActiveParts[PartName].colorShades.ShadeName
                                      .length;
                                    Sn++
                                  ) {
                                    for (
                                      let clry = 0;
                                      clry <
                                      json.assets[d].layers[e].shapes.length;
                                      clry++
                                    ) {
                                      if (
                                        json.assets[d].layers[e].shapes[clry]
                                          .nm ===
                                        ActiveParts[PartName].colorShades
                                          .ShadeName[Sn]
                                      ) {
                                        for (
                                          let clrz = 0;
                                          clrz <
                                          json.assets[d].layers[e].shapes[clry]
                                            .it.length;
                                          clrz++
                                        ) {
                                          if (
                                            json.assets[d].layers[e].shapes[
                                              clry
                                            ].it[clrz].ty === "fl"
                                          ) {
                                            for (
                                              let clra = 0;
                                              clra < 3;
                                              clra++
                                            ) {
                                              json.assets[d].layers[e].shapes[
                                                clry
                                              ].it[clrz].c.k[clra] =
                                                ActiveParts[PartName]
                                                  .colorShades.Shades[Sn][
                                                clra
                                                ] /
                                                25 /
                                                10;
                                            }
                                            break;
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          } else if (PartName === "Mouth") {
                            if (ActiveParts[PartName].data !== null) {
                              let data = json.assets[d].layers[e].nm.split("-");
                              if (data.length == 1) {
                                if (data[0] == ActiveParts[PartName].data) {
                                  json.assets[d].layers[e].hd = false;
                                }
                              } else {
                                if (data[0] == ActiveParts[PartName].data) {
                                  json.assets[d].layers[e].hd = false;
                                }
                              }
                            }
                          } else {
                            if (ActiveParts[PartName].data !== null) {
                              if (
                                json.assets[d].layers[e].nm ==
                                ActiveParts[PartName].data
                              ) {
                                json.assets[d].layers[e].hd = false;

                                if (PartName === "Hair") {
                                  for (
                                    let Sn = 0;
                                    Sn <
                                    ActiveParts[PartName].colorShades.ShadeName
                                      .length;
                                    Sn++
                                  ) {
                                    for (
                                      let clry = 0;
                                      clry <
                                      json.assets[d].layers[e].shapes.length;
                                      clry++
                                    ) {
                                      if (
                                        json.assets[d].layers[e].shapes[clry]
                                          .nm ===
                                        ActiveParts[PartName].colorShades
                                          .ShadeName[Sn]
                                      ) {
                                        for (
                                          let clrz = 0;
                                          clrz <
                                          json.assets[d].layers[e].shapes[clry]
                                            .it.length;
                                          clrz++
                                        ) {
                                          if (
                                            json.assets[d].layers[e].shapes[
                                              clry
                                            ].it[clrz].ty === "fl"
                                          ) {
                                            for (
                                              let clra = 0;
                                              clra < 3;
                                              clra++
                                            ) {
                                              json.assets[d].layers[e].shapes[
                                                clry
                                              ].it[clrz].c.k[clra] =
                                                ActiveParts[PartName]
                                                  .colorShades.Shades[Sn][
                                                clra
                                                ] /
                                                25 /
                                                10;
                                            }
                                            break;
                                          }
                                        }
                                      }
                                    }
                                  }

                                  if (ActiveParts["Cap"].data !== null) {
                                    for (
                                      let cap = 0;
                                      cap < json.assets[d].layers.length;
                                      cap++
                                    ) {
                                      json.assets[d].layers[cap].hd = true;

                                      if (
                                        json.assets[d].layers[cap].nm ===
                                        ActiveParts["Hair"].data + "-Cap"
                                      ) {
                                        json.assets[d].layers[cap].hd = false;

                                        for (
                                          let Sn = 0;
                                          Sn <
                                          ActiveParts[PartName].colorShades
                                            .ShadeName.length;
                                          Sn++
                                        ) {
                                          for (
                                            let clry = 0;
                                            clry <
                                            json.assets[d].layers[cap].shapes
                                              .length;
                                            clry++
                                          ) {
                                            if (
                                              json.assets[d].layers[cap].shapes[
                                                clry
                                              ].nm ===
                                              ActiveParts[PartName].colorShades
                                                .ShadeName[Sn]
                                            ) {
                                              for (
                                                let clrz = 0;
                                                clrz <
                                                json.assets[d].layers[cap]
                                                  .shapes[clry].it.length;
                                                clrz++
                                              ) {
                                                if (
                                                  json.assets[d].layers[cap]
                                                    .shapes[clry].it[clrz]
                                                    .ty === "fl"
                                                ) {
                                                  for (
                                                    let clra = 0;
                                                    clra < 3;
                                                    clra++
                                                  ) {
                                                    json.assets[d].layers[
                                                      cap
                                                    ].shapes[clry].it[clrz].c.k[
                                                      clra
                                                    ] =
                                                      ActiveParts[PartName]
                                                        .colorShades.Shades[Sn][
                                                      clra
                                                      ] /
                                                      25 /
                                                      10;
                                                  }
                                                  break;
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                  for (let s = 1; s < json.assets.length; s++) {
                                    if (json.assets[s].id === "comp_0") {
                                      for (
                                        let i = 0;
                                        i < json.assets[s].layers.length;
                                        i++
                                      ) {
                                        if (
                                          json.assets[s].layers[i].nm ==
                                          "EyeBrow_Comp"
                                        ) {
                                          let EyeComp =
                                            json.assets[s].layers[i].refId;

                                          for (
                                            let As = 0;
                                            As < json.assets.length;
                                            As++
                                          ) {
                                            if (json.assets[As].id == EyeComp) {
                                              for (
                                                let e = 0;
                                                e <
                                                json.assets[As].layers.length;
                                                e++
                                              ) {
                                                for (
                                                  let clry = 0;
                                                  clry <
                                                  json.assets[As].layers[e]
                                                    .shapes.length;
                                                  clry++
                                                ) {
                                                  for (
                                                    let clrz = 0;
                                                    clrz <
                                                    json.assets[As].layers[e]
                                                      .shapes[clry].it.length;
                                                    clrz++
                                                  ) {
                                                    if (
                                                      json.assets[As].layers[e]
                                                        .shapes[clry].it[clrz]
                                                        .ty === "fl"
                                                    ) {
                                                      for (
                                                        let clra = 0;
                                                        clra < 3;
                                                        clra++
                                                      ) {
                                                        json.assets[As].layers[
                                                          e
                                                        ].shapes[clry].it[
                                                          clrz
                                                        ].c.k[clra] =
                                                          ActiveParts[PartName]
                                                            .colorShades
                                                            .Shades[0][clra] /
                                                          25 /
                                                          10;
                                                      }
                                                      break;
                                                    }
                                                  }
                                                }
                                              }
                                              break;
                                            }
                                          }
                                        }
                                      }
                                      break;
                                    }
                                  }
                                  for (let s = 1; s < json.assets.length; s++) {
                                    if (json.assets[s].id === "comp_0") {
                                      for (
                                        let i = 0;
                                        i < json.assets[s].layers.length;
                                        i++
                                      ) {
                                        if (
                                          json.assets[s].layers[i].nm ==
                                          "Mouth_Comp"
                                        ) {
                                          let MouthComp =
                                            json.assets[s].layers[i].refId;

                                          for (
                                            let As = 0;
                                            As < json.assets.length;
                                            As++
                                          ) {
                                            if (
                                              json.assets[As].id == MouthComp
                                            ) {
                                              for (
                                                let e = 0;
                                                e <
                                                json.assets[As].layers.length;
                                                e++
                                              ) {
                                                for (
                                                  let clry = 0;
                                                  clry <
                                                  json.assets[As].layers[e]
                                                    .shapes.length;
                                                  clry++
                                                ) {
                                                  if (
                                                    json.assets[As].layers[e]
                                                      .shapes[clry].nm == "Hair"
                                                  ) {
                                                    for (
                                                      let clrz = 0;
                                                      clrz <
                                                      json.assets[As].layers[e]
                                                        .shapes[clry].it.length;
                                                      clrz++
                                                    ) {
                                                      if (
                                                        json.assets[As].layers[
                                                          e
                                                        ].shapes[clry].it[clrz]
                                                          .ty === "fl"
                                                      ) {
                                                        for (
                                                          let clra = 0;
                                                          clra < 3;
                                                          clra++
                                                        ) {
                                                          json.assets[
                                                            As
                                                          ].layers[e].shapes[
                                                            clry
                                                          ].it[clrz].c.k[clra] =
                                                            ActiveParts[
                                                              PartName
                                                            ].colorShades
                                                              .Shades[0][clra] /
                                                            25 /
                                                            10;
                                                        }
                                                        break;
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                              break;
                                            }
                                          }
                                        }
                                      }
                                      break;
                                    }
                                  }
                                } else {
                                  for (
                                    let Sn = 0;
                                    Sn <
                                    ActiveParts[PartName].colorShades.ShadeName
                                      .length;
                                    Sn++
                                  ) {
                                    for (
                                      let clry = 0;
                                      clry <
                                      json.assets[d].layers[e].shapes.length;
                                      clry++
                                    ) {
                                      if (
                                        json.assets[d].layers[e].shapes[clry]
                                          .nm ===
                                        ActiveParts[PartName].colorShades
                                          .ShadeName[Sn]
                                      ) {
                                        for (
                                          let clrz = 0;
                                          clrz <
                                          json.assets[d].layers[e].shapes[clry]
                                            .it.length;
                                          clrz++
                                        ) {
                                          if (
                                            json.assets[d].layers[e].shapes[
                                              clry
                                            ].it[clrz].ty === "fl"
                                          ) {
                                            for (
                                              let clra = 0;
                                              clra < 3;
                                              clra++
                                            ) {
                                              json.assets[d].layers[e].shapes[
                                                clry
                                              ].it[clrz].c.k[clra] =
                                                ActiveParts[PartName]
                                                  .colorShades.Shades[Sn][
                                                clra
                                                ] /
                                                25 /
                                                10;
                                            }
                                            break;
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                          if (
                            CompName.split("_Comp")[0] ==
                            json.assets[d].layers[e].nm
                          ) {
                            if (
                              CompName != "L_Foot_Comp" &&
                              CompName != "R_Foot_Comp"
                            ) {
                              json.assets[d].layers[e].hd = false;
                            }
                          } else if (
                            json.assets[d].layers[e].nm == "BaseBody"
                          ) {
                            if (
                              CompName != "L_Foot_Comp" &&
                              CompName != "R_Foot_Comp"
                            ) {
                              json.assets[d].layers[e].hd = false;
                            }
                          }
                        }
                      }
                    }
                  }
                }
                break;
              }
            }
          }
        }
        break;
      }
    }

    if (ActiveParts["Face"].colorShades.Shades.length != 0) {
      let r = Math.round(ActiveParts["Face"].colorShades.Shades[0][0]);
      let g = Math.round(ActiveParts["Face"].colorShades.Shades[0][1]);
      let b = Math.round(ActiveParts["Face"].colorShades.Shades[0][2]);
      let rbg = "rgb(" + r + "," + g + "," + b + ")";

      let colors = rbg.split("(");
      let changeColor = colors[1].split(")");
      rgbArray = changeColor[0].split(",");

      for (var z = 0; z < rgbArray.length; z++) {
        //convert rbg into the json rgb
        rgbConverted.push(rgbArray[z] / 25 / 10);
      }
      for (let Ns = 0; Ns < rgbArray.length; Ns++) {
        NoseShades.push(rgbArray[Ns] - NoseDiff[Ns]);
      }
      for (let Neck = 0; Neck < rgbArray.length; Neck++) {
        NeckShades.push(rgbArray[Neck] - NeckDiff[Neck]);
      }
      for (var Dshd = 0; Dshd < NoseShades.length; Dshd++) {
        //convert rbg into the json rgb
        DarkRgbConverted.push(NoseShades[Dshd] / 25 / 10);
      }
      for (var Lshd = 0; Lshd < NeckShades.length; Lshd++) {
        //convert rbg into the json rgb
        LiteRgbConverted.push(NeckShades[Lshd] / 25 / 10);
      }
      for (let start = 1; start < json.assets.length; start++) {
        if (json.assets[start].id === "comp_0") {
          for (let c = 0; c < json.assets[start].layers.length; c++) {
            for (let x = 0; x < skinparts.length; x++) {
              let CompName = json.assets[start].layers[c].nm;
              let CompId = json.assets[start].layers[c].refId;

              if (skinparts[x] == CompName) {
                for (let d = 1; d < json.assets.length; d++) {
                  if (json.assets[d].id === CompId) {
                    for (let e = 0; e < json.assets[d].layers.length; e++) {
                      if (CompName === "Nose_Comp") {
                        for (
                          let b = 0;
                          b < json.assets[d].layers[e].shapes.length;
                          b++
                        ) {
                          if (
                            json.assets[d].layers[e].shapes[b].it != undefined
                          ) {
                            for (
                              let c = 0;
                              c < json.assets[d].layers[e].shapes[b].it.length;
                              c++
                            ) {
                              if (
                                json.assets[d].layers[e].shapes[b].it[c].ty ===
                                "fl"
                              ) {
                                for (
                                  let dr = 0;
                                  dr < DarkRgbConverted.length;
                                  dr++
                                ) {
                                  json.assets[d].layers[e].shapes[b].it[c].c.k[
                                    dr
                                  ] = DarkRgbConverted[dr];
                                }
                              }
                            }
                          }
                        }
                      }
                      if (CompName === "Mouth_Comp") {
                        if (props.Gender == "Male") {
                          for (
                            let b = 0;
                            b < json.assets[d].layers[e].shapes.length;
                            b++
                          ) {
                            if (
                              json.assets[d].layers[e].shapes[b].nm.split(
                                "_"
                              )[0] === "Changeable"
                            ) {
                              for (
                                let c = 0;
                                c <
                                json.assets[d].layers[e].shapes[b].it.length;
                                c++
                              ) {
                                if (
                                  json.assets[d].layers[e].shapes[b].it[c]
                                    .ty === "fl"
                                ) {
                                  for (
                                    let dr = 0;
                                    dr < DarkRgbConverted.length;
                                    dr++
                                  ) {
                                    json.assets[d].layers[e].shapes[b].it[
                                      c
                                    ].c.k[dr] = DarkRgbConverted[dr];
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                      if (CompName === "Neck_Comp" || CompName === "Ear_Comp") {
                        for (
                          let b = 0;
                          b < json.assets[d].layers[e].shapes.length;
                          b++
                        ) {
                          if (
                            json.assets[d].layers[e].shapes[b].nm.split(
                              "_"
                            )[0] === "Changeable"
                          ) {
                            for (
                              let c = 0;
                              c < json.assets[d].layers[e].shapes[b].it.length;
                              c++
                            ) {
                              if (
                                json.assets[d].layers[e].shapes[b].it[c].ty ===
                                "fl"
                              ) {
                                for (
                                  let dr = 0;
                                  dr < rgbConverted.length;
                                  dr++
                                ) {
                                  json.assets[d].layers[e].shapes[b].it[c].c.k[
                                    dr
                                  ] = rgbConverted[dr];
                                }
                              }
                            }
                          } else {
                            for (
                              let c = 0;
                              c < json.assets[d].layers[e].shapes[b].it.length;
                              c++
                            ) {
                              if (
                                json.assets[d].layers[e].shapes[b].it[c].ty ===
                                "fl"
                              ) {
                                for (
                                  let dr = 0;
                                  dr < LiteRgbConverted.length;
                                  dr++
                                ) {
                                  json.assets[d].layers[e].shapes[b].it[c].c.k[
                                    dr
                                  ] = LiteRgbConverted[dr];
                                }
                              }
                            }
                          }
                        }
                      }
                      if (CompName === "Eye_Comp") {
                        if (props.Gender === "Male" || props.Gender === "Female") {
                          for (
                            let a = 0;
                            a < json.assets[d].layers.length;
                            a++
                          ) {
                            if (json.assets[d].layers[e].nm === "Skin") {
                              for (
                                let b = 0;
                                b < json.assets[d].layers[e].shapes.length;
                                b++
                              ) {
                                for (
                                  let c = 0;
                                  c <
                                  json.assets[d].layers[e].shapes[b].it.length;
                                  c++
                                ) {
                                  if (
                                    json.assets[d].layers[e].shapes[b].it[c]
                                      .ty === "fl"
                                  ) {
                                    for (
                                      let dr = 0;
                                      dr < rgbConverted.length;
                                      dr++
                                    ) {
                                      json.assets[d].layers[e].shapes[b].it[
                                        c
                                      ].c.k[dr] = rgbConverted[dr];
                                    }
                                  }
                                }
                              }
                            } else {
                              for (
                                let b = 0;
                                b < json.assets[d].layers[e].shapes.length;
                                b++
                              ) {
                                if (
                                  json.assets[d].layers[e].shapes[b].nm ===
                                  "Skin"
                                ) {
                                  for (
                                    let c = 0;
                                    c <
                                    json.assets[d].layers[e].shapes[b].it
                                      .length;
                                    c++
                                  ) {
                                    if (
                                      json.assets[d].layers[e].shapes[b].it[c]
                                        .ty === "fl"
                                    ) {
                                      for (
                                        let dr = 0;
                                        dr < rgbConverted.length;
                                        dr++
                                      ) {
                                        json.assets[d].layers[e].shapes[b].it[
                                          c
                                        ].c.k[dr] = rgbConverted[dr];
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                        //else if (props.Gender === "Female") {
                        //   for (let s = 1; s < json.assets.length; s++) {
                        //     if (
                        //       json.assets[s].id ===
                        //       json.assets[d].layers[e].refId
                        //     ) {
                        //       for (
                        //         let ind = 0;
                        //         ind < json.assets[s].layers.length;
                        //         ind++
                        //       ) {
                        //         if (
                        //           json.assets[s].layers[ind].nm === "Skin"
                        //         ) {
                        //           for (
                        //             let es = 0;
                        //             es <
                        //             json.assets[s].layers[ind].shapes.length;
                        //             es++
                        //           ) {
                        //             for (
                        //               let clrz = 0;
                        //               clrz <
                        //               json.assets[s].layers[ind].shapes[es].it
                        //                 .length;
                        //               clrz++
                        //             ) {
                        //               if (
                        //                 json.assets[s].layers[ind].shapes[es]
                        //                   .it[clrz].ty === "fl"
                        //               ) {
                        //                 for (
                        //                   let dr = 0;
                        //                   dr < rgbConverted.length;
                        //                   dr++
                        //                 ) {
                        //                   json.assets[s].layers[ind].shapes[
                        //                     es
                        //                   ].it[clrz].c.k[dr] = rgbConverted[dr];
                        //                 }
                        //                 break;
                        //               }
                        //             }
                        //           }
                        //         }
                        //       }
                        //     }
                        //   }
                        // }
                      }
                      if (CompName === "Face_Comp") {
                        for (
                          let b = 0;
                          b < json.assets[d].layers[e].shapes.length;
                          b++
                        ) {
                          for (
                            let c = 0;
                            c < json.assets[d].layers[e].shapes[b].it.length;
                            c++
                          ) {
                            if (
                              json.assets[d].layers[e].shapes[b].it[c].ty ===
                              "fl"
                            ) {
                              for (let dr = 0; dr < rgbConverted.length; dr++) {
                                json.assets[d].layers[e].shapes[b].it[c].c.k[
                                  dr
                                ] = rgbConverted[dr];
                              }
                            }
                          }
                        }
                      }
                      if (
                        CompName === "L_Thigh_Comp" ||
                        CompName === "R_Thigh_Comp"
                      ) {
                        let lastLayer = json.assets[d].layers.length - 1;

                        for (
                          let b = 0;
                          b < json.assets[d].layers[lastLayer].shapes.length;
                          b++
                        ) {
                          if (
                            json.assets[d].layers[lastLayer].shapes[b].nm ===
                            "N_Thigh"
                          ) {
                            for (
                              let c = 0;
                              c <
                              json.assets[d].layers[lastLayer].shapes[b].it
                                .length;
                              c++
                            ) {
                              if (
                                json.assets[d].layers[lastLayer].shapes[b].it[c]
                                  .ty === "fl"
                              ) {
                                for (
                                  let dr = 0;
                                  dr < rgbConverted.length;
                                  dr++
                                ) {
                                  json.assets[d].layers[lastLayer].shapes[b].it[
                                    c
                                  ].c.k[dr] = rgbConverted[dr];
                                }
                              }
                            }
                          }
                        }
                      }
                      if (
                        CompName === "L_Foot_Comp" ||
                        CompName === "R_Foot_Comp"
                      ) {
                        if (props.Gender == "Female") {
                          for (
                            let b = 0;
                            b < json.assets[d].layers[e].shapes.length;
                            b++
                          ) {
                            if (
                              json.assets[d].layers[e].shapes[b].nm ===
                              "Shoe_Skin"
                            ) {
                              for (
                                let c = 0;
                                c <
                                json.assets[d].layers[e].shapes[b].it.length;
                                c++
                              ) {
                                if (
                                  json.assets[d].layers[e].shapes[b].it[c]
                                    .ty === "fl"
                                ) {
                                  for (
                                    let dr = 0;
                                    dr < rgbConverted.length;
                                    dr++
                                  ) {
                                    json.assets[d].layers[e].shapes[b].it[
                                      c
                                    ].c.k[dr] = rgbConverted[dr];
                                  }
                                }
                              }
                            }
                          }
                        }

                        let lastLayer = json.assets[d].layers.length - 1;

                        for (
                          let b = 0;
                          b < json.assets[d].layers[lastLayer].shapes.length;
                          b++
                        ) {
                          for (
                            let c = 0;
                            c <
                            json.assets[d].layers[lastLayer].shapes[b].it
                              .length;
                            c++
                          ) {
                            if (
                              json.assets[d].layers[lastLayer].shapes[b].it[c]
                                .ty === "fl"
                            ) {
                              for (let dr = 0; dr < rgbConverted.length; dr++) {
                                json.assets[d].layers[lastLayer].shapes[b].it[
                                  c
                                ].c.k[dr] = rgbConverted[dr];
                              }
                            }
                          }
                        }
                      }
                      if (
                        CompName !== "L_Foot_Comp" &&
                        CompName !== "R_Foot_Comp" &&
                        CompName !== "Nose_Comp" &&
                        CompName !== "Neck_Comp" &&
                        CompName !== "Eye_Comp" &&
                        CompName !== "Mouth_Comp" &&
                        CompName !== "L_Thigh_Comp" &&
                        CompName !== "R_Thigh_Comp" &&
                        CompName !== "Ear_Comp" &&
                        CompName !== "Face_Comp"
                      ) {
                        let lastLayer = json.assets[d].layers.length - 1;

                        for (
                          let b = 0;
                          b < json.assets[d].layers[lastLayer].shapes.length;
                          b++
                        ) {
                          for (
                            let c = 0;
                            c <
                            json.assets[d].layers[lastLayer].shapes[b].it
                              .length;
                            c++
                          ) {
                            if (
                              json.assets[d].layers[lastLayer].shapes[b].it[c]
                                .ty === "fl"
                            ) {
                              for (let dr = 0; dr < rgbConverted.length; dr++) {
                                json.assets[d].layers[lastLayer].shapes[b].it[
                                  c
                                ].c.k[dr] = rgbConverted[dr];
                              }
                            }
                          }
                        }
                      }
                    }
                    break;
                  }
                }
                break;
              }
            }
          }
          break;
        }
      }
    }

    for (let start = 0; start < json.assets.length; start++) {
      if (
        json.assets[start].id !== "comp_0" &&
        json.assets[start].id !== "image_0"
      ) {
        json.assets[start].layers = json.assets[start].layers.filter(
          (item) => item.hd == false || item.hd == undefined
        );
      }
    }

    for (let a = 0; a < json.assets.length; a++) {
      if (json.assets[a].id == "comp_0") {
        json.assets[a].layers = json.assets[a].layers.filter(function (
          value,
          index,
          arr
        ) {
          if (value.refId == undefined) {
            return value;
          } else {
            for (let b = 0; b < json.assets.length; b++) {
              if (json.assets[b].id == value.refId) {
                if (json.assets[b].layers.length != 0) {
                  return value;
                }
                break;
              }
            }
          }
        });
        break;
      }
    }

    json.assets = json.assets.filter(function (value, index, arr) {
      if (value.layers == undefined) {
        return value;
      } else if (value.layers.length != 0) {
        return value;
      }
    });

    const size = new TextEncoder().encode(JSON.stringify(json)).length;
    const kiloBytes = size / 1024;

    const ctx = MainCanvas.current.getContext("2d");
    Lottie.destroy("alex");
    ctx.clearRect(0, 0, MainCanvas.current.width, MainCanvas.current.height);
    get = Lottie.loadAnimation({
      name: "alex",
      renderer: "canvas",
      loop: true,
      autoplay: true,
      animationData: JSON.parse(JSON.stringify(json)),

      rendererSettings: {
        context: ctx,
        clearCanvas: true,
      },
    });
  };


  const showCreatedCharacter = async (GestureURL) => {
    //For Dance
    const resp = await fetch(GestureURL + props.arrayPreviewGestures[0].gesture + ".json");
    props.setcreatedCharacterURL(GestureURL);
    const jsonData = await resp.json();
    props.setcreatedCharacterPath(jsonData);
    props.setshowCreationPopup(true);
    props.setCharPopup(false);
    props.setGender('Empty');
    props.setTopActive('Gender');
    props.setreadjson(false);
    props.setcanvZoom({ width: '', height: '' });
    props.setUploadData(null);
  }

  const start = (large, small) => {
    let Selectparts = {
      Face: ActiveParts["Face"],
      Hair: ActiveParts["Hair"],
      Mouth: ActiveParts["Mouth"],
      OuterTop: ActiveParts["OuterTop"],
      LowerTop: ActiveParts["LowerTop"],
      MiddleTop: ActiveParts["MiddleTop"],
      Eye: ActiveParts["Eye"],
      EyeBrow: ActiveParts["EyeBrow"],
      Bottom: ActiveParts["Bottom"],
      Shoe: ActiveParts["Shoe"],
      Nose: ActiveParts["Nose"],
      Cap: ActiveParts["Cap"],
      Mask: ActiveParts["Mask"],
      Glasses: ActiveParts["Glasses"],
      EarWear: ActiveParts["EarWear"],
    };

    let obj = {
      gender: props.Gender,
      partsData: JSON.stringify(Selectparts),
      FileName: props.Gender + "Character_Final",
      keywords: "",
      svg: large + "small_Image" + small,
      //small_svg: smallImage,
      characteName: "",
    };

    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );

    props.setDeafultLoader({ played: true, stat: true ,Message:"HOLD ON... We are doing some magic and it will take upto 30 seconds. Please DON'T Refresh the page."});
    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Character/UploadCharacter",
        obj,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {

        console.log(UserData);
        var GestureURL = "";
        //3303//MaleCharacter_Final_Dance.json
        //props.setcreatedCharacterURL(GestureURL);

        if (response.data.status) {
          let Data = response.data.data;
          if (Data != undefined) {
            for (const itr of Data) {
              try {
                for (const it of JSON.parse(itr.svg)) {
                  if (it.name == "Default") {
                    itr.svg = it.largeImgPath;
                    break;
                  }
                }
              } catch (ex) { }
            }
          }


          if (response.data.type === "defaultModel") {
            let authData = JSON.parse(
              localStorage.getItem("animation_studio_2.0_access_token")
            );
            GestureURL = authenticationData.ApiBaseURL + "/CharacterUploads/UploadedGestures/" + authData.User_Id + "/" + response.data.data[response.data.data.length - 1].id + "/" + response.data.data[response.data.data.length - 1].gender + "Character_Final_";
            if (ActiveGender === "Male") {
              let DefChr = {
                Male: Data,
                Female: DefaultCharacter.Female,
              };
              setDefaultCharacter(DefChr);
            } else {
              let DefChr = {
                Male: DefaultCharacter.Male,
                Female: Data,
              };
              setDefaultCharacter(DefChr);
            }
            // Swal({
            //   title: "Excellent",
            //   text: "Admin your Character has been uploaded",
            //   icon: "success",
            //   backdrop: null,
            // });

            //just trying
            showCreatedCharacter(GestureURL);
            props.setDeafultLoader({ played: false, stat: false });
          } else {
            GestureURL = authenticationData.ApiBaseURL + "/CharacterUploads/UploadedGestures/" + authData.User_Id + "/" + response.data.data[response.data.data.length - 1].id + "/" + response.data.data[response.data.data.length - 1].gender + "Character_Final_";
            showCreatedCharacter(GestureURL);
            props.setDeafultLoader({ played: false, stat: false });

            // Swal({
            //   title: "Excellent",
            //   text: "Your Character Has Been Uploaded and Now avaialble in the Editor's Assets Section",
            //   icon: "success",
            //   backdrop: null,
            // });
          }
        } else {
          props.setDeafultLoader({ played: false, stat: false });
          //just for trying

          Swal({
            title: "Failed",
            text: "Unable to Upload Character. Please Try Again",
            icon: "error",
            backdrop: null,
          });
        }
      })
      .catch((excetion) => {
        props.setDeafultLoader({ played: false, stat: false });
        Swal({
          title: "Failed",
          text: "Unable to Upload Character. Please Try Again",
          icon: "error",
          backdrop: null,
        });
      });
  };

  // useEffect(async () => {
  //   if (props.Gender !== "Empty") {
  //       props.setDeafultLoader({played:true,stat:true});
  //     const resp = await fetch(
  //       authenticationData.ApiBaseURL +
  //         "/assets/Animated_Character/" +
  //         props.Gender +
  //         "Character_Final.json"
  //     );
  //     const jsonData = await resp.json();
  //     let data = clone(jsonData);
  //     setNewJson(data);
  //     setselection(true);
  //     props.setcanvZoom({ width: "540", height: "770" });
  //     props.setDeafultLoader({played:false,stat:false});
  //   }
  //   if (props.Gender === "Male") {
  //     skinparts = [
  //       "Neck_Comp",
  //       "R_Hand_Comp",
  //       "Ear_Comp",
  //       "L_Hand_Comp",
  //       "Face_Comp",
  //       "Torso_Comp",
  //       "L_Thigh_Comp",
  //       "R_Thigh_Comp",
  //       "L_Calf_Comp",
  //       "R_Calf_Comp",
  //       "BaseBody_Comp",
  //       "OuterBody_Comp",
  //       "MiddleBody_Comp",
  //       "L_Arm_Comp",
  //       "R_Arm_Comp",
  //       "L_ForeArm_Comp",
  //       "R_ForeArm_Comp",
  //       "L_Foot_Comp",
  //       "R_Foot_Comp",
  //       "Nose_Comp",
  //       "Eye_Comp",
  //       "Mouth_Comp",
  //       "Left_Shoulder",
  //       "Right_Shoulder",
  //       "L_Wing_Comp",
  //       "R_Wing_Comp",
  //     ];
  //   }
  //    else if (props.Gender === "Female") {
  //     skinparts = [
  //       "Neck_Comp",
  //       "R_Hand_Comp",
  //       "Ear_Comp",
  //       "L_Hand_Comp",
  //       "Face_Comp",
  //       "Torso_Comp",
  //       "L_Thigh_Comp",
  //       "R_Thigh_Comp",
  //       "L_Calf_Comp",
  //       "R_Calf_Comp",
  //       "BaseBody_Comp",
  //       "OuterBody_Comp",
  //       "MiddleBody_Comp",
  //       "L_Arm_Comp",
  //       "R_Arm_Comp",
  //       "L_ForeArm_Comp",
  //       "R_ForeArm_Comp",
  //       "L_Foot_Comp",
  //       "R_Foot_Comp",
  //       "Nose_Comp",
  //       "Eye_Comp",
  //       "Mouth_Comp",
  //       "Left_Shoulder",
  //       "Right_Shoulder",
  //       "L_Wing_Comp",
  //       "R_Wing_Comp",
  //     ];
  //   }

  //   // fs = require('fs');
  //   // files = fs.readdir('../../../public/images/testClothes/male/clothes');
  //   // var images = importAll(require.context('../../../public/images/testClothes/male/clothes', false, /\.(png|jpe?g|svg)$/));
  // }, [props.Gender]);


  const getCharacterData = async (ActiveGender) => {
    if (ActiveGender !== "Empty") {
      props.setDeafultLoader({ played: true, stat: true });
      const resp = await fetch(
        authenticationData.ApiBaseURL +
        "/assets/Animated_Character/" +
        ActiveGender +
        "Character_Final.json"
      );
      const jsonData = await resp.json();
      let data = clone(jsonData);
      setNewJson(data);
      setselection(true);
      props.setcanvZoom({ width: "540", height: "770" });
      props.setDeafultLoader({ played: false, stat: false });
    }
    if (ActiveGender === "Male") {
      skinparts = [
        "Neck_Comp",
        "R_Hand_Comp",
        "Ear_Comp",
        "L_Hand_Comp",
        "Face_Comp",
        "Torso_Comp",
        "L_Thigh_Comp",
        "R_Thigh_Comp",
        "L_Calf_Comp",
        "R_Calf_Comp",
        "BaseBody_Comp",
        "OuterBody_Comp",
        "MiddleBody_Comp",
        "L_Arm_Comp",
        "R_Arm_Comp",
        "L_ForeArm_Comp",
        "R_ForeArm_Comp",
        "L_Foot_Comp",
        "R_Foot_Comp",
        "Nose_Comp",
        "Eye_Comp",
        "Mouth_Comp",
        "Left_Shoulder",
        "Right_Shoulder",
        "L_Wing_Comp",
        "R_Wing_Comp",
      ];
    }
    else if (ActiveGender === "Female") {
      skinparts = [
        "Neck_Comp",
        "R_Hand_Comp",
        "Ear_Comp",
        "L_Hand_Comp",
        "Face_Comp",
        "Torso_Comp",
        "L_Thigh_Comp",
        "R_Thigh_Comp",
        "L_Calf_Comp",
        "R_Calf_Comp",
        "BaseBody_Comp",
        "OuterBody_Comp",
        "MiddleBody_Comp",
        "L_Arm_Comp",
        "R_Arm_Comp",
        "L_ForeArm_Comp",
        "R_ForeArm_Comp",
        "L_Foot_Comp",
        "R_Foot_Comp",
        "Nose_Comp",
        "Eye_Comp",
        "Mouth_Comp",
        "Left_Shoulder",
        "Right_Shoulder",
        "L_Wing_Comp",
        "R_Wing_Comp",
      ];
    }

  }

  const readJson = () => {
    if (ActiveParts["Face"].data === null) {
      var json = NewJson;
      var Aparts = clone(ActiveParts);

      for (let any = 0; any < ActivePartName.length; any++) {
        var NewName = ActivePartName[any];

        if (props.Gender === "Female") {
          for (let a = 0; a < FemaleBodyParts.length; a++) {
            if (FemaleBodyParts[a].name === NewName) {
              PartsName = FemaleBodyParts[a].parts;
            }
          }
        } else if (props.Gender === "Male") {
          for (let a = 0; a < MaleBodyParts.length; a++) {
            if (MaleBodyParts[a].name === NewName) {
              PartsName = MaleBodyParts[a].parts;
            }
          }
        }

        for (let b = 0; b < json.assets.length; b++) {
          if (json.assets[b].id === "comp_0") {
            for (let c = 0; c < json.assets[b].layers.length; c++) {
              for (let d = 0; d < PartsName.length; d++) {
                if (json.assets[b].layers[c].nm === PartsName[d]) {
                  for (
                    let e = 0;
                    e < json.assets[b].layers[c].layers.length;
                    e++
                  ) {
                    if (
                      json.assets[b].layers[c].layers[e].nm.split("_")[0] !==
                      "Face" &&
                      json.assets[b].layers[c].layers[e].nm.split("_")[0] !==
                      "Eye" &&
                      json.assets[b].layers[c].layers[e].nm.split("_")[0] !==
                      "Hair" &&
                      json.assets[b].layers[c].layers[e].nm.split("_")[0] !==
                      "Mouth"
                    ) {
                      if (
                        json.assets[b].layers[c].layers[e].nm.split("_")[0] ===
                        NewName
                      ) {
                        if (
                          json.assets[b].layers[c].layers[e].hd === false ||
                          json.assets[b].layers[c].layers[e].hd === undefined
                        ) {
                          Aparts[ActivePartName[any]].data =
                            json.assets[b].layers[c].layers[e].nm;

                          for (
                            let clry = 0;
                            clry <
                            json.assets[b].layers[c].layers[e].shapes.length;
                            clry++
                          ) {
                            if (
                              json.assets[b].layers[c].layers[e].shapes[
                                clry
                              ].nm.split("_")[0] === "Changeable"
                            ) {
                              for (
                                let clrz = 0;
                                clrz <
                                json.assets[b].layers[c].layers[e].shapes[clry]
                                  .it.length;
                                clrz++
                              ) {
                                if (
                                  json.assets[b].layers[c].layers[e].shapes[
                                    clry
                                  ].it[clrz].ty === "fl"
                                ) {
                                  if (
                                    Aparts[ActivePartName[any]].colorShades
                                      .ShadeName.length === 0
                                  ) {
                                    Aparts[
                                      ActivePartName[any]
                                    ].colorShades.ShadeName.push(
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].nm
                                    );
                                    let arr = [];

                                    for (let clra = 0; clra < 3; clra++) {
                                      arr.push(
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].it[clrz].c.k[clra] *
                                        25 *
                                        10
                                      );
                                    }
                                    Aparts[
                                      ActivePartName[any]
                                    ].colorShades.Shades.push(arr);
                                  } else {
                                    let nameCheck = false;
                                    for (
                                      let name = 0;
                                      name <
                                      Aparts[ActivePartName[any]].colorShades
                                        .ShadeName.length;
                                      name++
                                    ) {
                                      if (
                                        Aparts[ActivePartName[any]].colorShades
                                          .ShadeName[name] ===
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].nm
                                      ) {
                                        nameCheck = true;
                                      }
                                    }
                                    if (!nameCheck) {
                                      Aparts[
                                        ActivePartName[any]
                                      ].colorShades.ShadeName.push(
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].nm
                                      );
                                      let arr = [];
                                      for (let clra = 0; clra < 3; clra++) {
                                        arr.push(
                                          json.assets[b].layers[c].layers[e]
                                            .shapes[clry].it[clrz].c.k[clra] *
                                          25 *
                                          10
                                        );
                                      }
                                      Aparts[
                                        ActivePartName[any]
                                      ].colorShades.Shades.push(arr);
                                    }
                                  }
                                }
                              }
                            }
                          }
                          //break
                        }
                      }
                    } else if (
                      json.assets[b].layers[c].layers[e].nm.split("_")[0] ===
                      "Face"
                    ) {
                      if (
                        json.assets[b].layers[c].layers[e].hd === false ||
                        json.assets[b].layers[c].layers[e].hd === undefined
                      ) {
                        Aparts[ActivePartName[any]].data =
                          json.assets[b].layers[c].layers[e].nm;

                        for (
                          let clry = 0;
                          clry <
                          json.assets[b].layers[c].layers[e].shapes.length;
                          clry++
                        ) {
                          for (
                            let clrz = 0;
                            clrz <
                            json.assets[b].layers[c].layers[e].shapes[clry].it
                              .length;
                            clrz++
                          ) {
                            if (
                              json.assets[b].layers[c].layers[e].shapes[clry]
                                .it[clrz].ty === "fl"
                            ) {
                              if (
                                Aparts[ActivePartName[any]].colorShades
                                  .ShadeName.length === 0
                              ) {
                                Aparts[
                                  ActivePartName[any]
                                ].colorShades.ShadeName.push(
                                  json.assets[b].layers[c].layers[e].shapes[
                                    clry
                                  ].nm
                                );
                                let arr = [];

                                for (let clra = 0; clra < 3; clra++) {
                                  arr.push(
                                    json.assets[b].layers[c].layers[e].shapes[
                                      clry
                                    ].it[clrz].c.k[clra] *
                                    25 *
                                    10
                                  );
                                }
                                Aparts[
                                  ActivePartName[any]
                                ].colorShades.Shades.push(arr);
                              } else {
                                let nameCheck = false;
                                for (
                                  let name = 0;
                                  name <
                                  Aparts[ActivePartName[any]].colorShades
                                    .ShadeName.length;
                                  name++
                                ) {
                                  if (
                                    Aparts[ActivePartName[any]].colorShades
                                      .ShadeName[name] ===
                                    json.assets[b].layers[c].layers[e].shapes[
                                      clry
                                    ].nm
                                  ) {
                                    nameCheck = true;
                                  }
                                }
                                if (!nameCheck) {
                                  Aparts[
                                    ActivePartName[any]
                                  ].colorShades.ShadeName.push(
                                    json.assets[b].layers[c].layers[e].shapes[
                                      clry
                                    ].nm
                                  );
                                  let arr = [];
                                  for (let clra = 0; clra < 3; clra++) {
                                    arr.push(
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].it[clrz].c.k[clra] *
                                      25 *
                                      10
                                    );
                                  }
                                  Aparts[
                                    ActivePartName[any]
                                  ].colorShades.Shades.push(arr);
                                }
                              }
                            }
                          }
                        }
                      }
                    } else if (
                      json.assets[b].layers[c].layers[e].nm.split("_")[0] ===
                      "Eye"
                    ) {
                      if (props.Gender === "Male") {
                        if (
                          json.assets[b].layers[c].layers[e].nm.split(
                            "_"
                          )[0] === NewName
                        ) {
                          if (
                            json.assets[b].layers[c].layers[e].hd === false ||
                            json.assets[b].layers[c].layers[e].hd === undefined
                          ) {
                            Aparts[ActivePartName[any]].data =
                              json.assets[b].layers[c].layers[e].nm;
                            for (
                              let clry = 0;
                              clry <
                              json.assets[b].layers[c].layers[e].shapes.length;
                              clry++
                            ) {
                              if (
                                json.assets[b].layers[c].layers[e].shapes[
                                  clry
                                ].nm.split("_")[0] === "Changeable"
                              ) {
                                for (
                                  let clrz = 0;
                                  clrz <
                                  json.assets[b].layers[c].layers[e].shapes[
                                    clry
                                  ].it.length;
                                  clrz++
                                ) {
                                  if (
                                    json.assets[b].layers[c].layers[e].shapes[
                                      clry
                                    ].it[clrz].ty === "fl"
                                  ) {
                                    if (
                                      Aparts[ActivePartName[any]].colorShades
                                        .ShadeName.length === 0
                                    ) {
                                      Aparts[
                                        ActivePartName[any]
                                      ].colorShades.ShadeName.push(
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].nm
                                      );
                                      let arr = [];

                                      for (let clra = 0; clra < 3; clra++) {
                                        arr.push(
                                          json.assets[b].layers[c].layers[e]
                                            .shapes[clry].it[clrz].c.k[clra] *
                                          25 *
                                          10
                                        );
                                      }
                                      Aparts[
                                        ActivePartName[any]
                                      ].colorShades.Shades.push(arr);
                                    } else {
                                      let nameCheck = false;
                                      for (
                                        let name = 0;
                                        name <
                                        Aparts[ActivePartName[any]].colorShades
                                          .ShadeName.length;
                                        name++
                                      ) {
                                        if (
                                          Aparts[ActivePartName[any]]
                                            .colorShades.ShadeName[name] ===
                                          json.assets[b].layers[c].layers[e]
                                            .shapes[clry].nm
                                        ) {
                                          nameCheck = true;
                                        }
                                      }
                                      if (!nameCheck) {
                                        Aparts[
                                          ActivePartName[any]
                                        ].colorShades.ShadeName.push(
                                          json.assets[b].layers[c].layers[e]
                                            .shapes[clry].nm
                                        );
                                        let arr = [];
                                        for (let clra = 0; clra < 3; clra++) {
                                          arr.push(
                                            json.assets[b].layers[c].layers[e]
                                              .shapes[clry].it[clrz].c.k[clra] *
                                            25 *
                                            10
                                          );
                                        }
                                        Aparts[
                                          ActivePartName[any]
                                        ].colorShades.Shades.push(arr);
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else if (props.Gender === "Female") {
                        if (
                          json.assets[b].layers[c].layers[e].nm.split(
                            "_"
                          )[0] === NewName
                        ) {
                          if (
                            json.assets[b].layers[c].layers[e].hd === false ||
                            json.assets[b].layers[c].layers[e].hd === undefined
                          ) {
                            for (
                              let n = 0;
                              n <
                              json.assets[b].layers[c].layers[e].layers.length;
                              n++
                            ) {
                              if (
                                json.assets[b].layers[c].layers[e].layers[n]
                                  .nm === "EyeBall"
                              ) {
                                Aparts[ActivePartName[any]].data =
                                  json.assets[b].layers[c].layers[e].nm;

                                for (
                                  let clry = 0;
                                  clry <
                                  json.assets[b].layers[c].layers[e].layers[n]
                                    .shapes.length;
                                  clry++
                                ) {
                                  if (
                                    json.assets[b].layers[c].layers[e].layers[
                                      n
                                    ].shapes[clry].nm.split("_")[0] ===
                                    "Changeable"
                                  ) {
                                    for (
                                      let clrz = 0;
                                      clrz <
                                      json.assets[b].layers[c].layers[e].layers[
                                        n
                                      ].shapes[clry].it.length;
                                      clrz++
                                    ) {
                                      if (
                                        json.assets[b].layers[c].layers[e]
                                          .layers[n].shapes[clry].it[clrz]
                                          .ty === "fl"
                                      ) {
                                        if (
                                          Aparts[ActivePartName[any]]
                                            .colorShades.ShadeName.length === 0
                                        ) {
                                          Aparts[
                                            ActivePartName[any]
                                          ].colorShades.ShadeName.push(
                                            json.assets[b].layers[c].layers[e]
                                              .layers[n].shapes[clry].nm
                                          );
                                          let arr = [];

                                          for (let clra = 0; clra < 3; clra++) {
                                            arr.push(
                                              json.assets[b].layers[c].layers[e]
                                                .layers[n].shapes[clry].it[clrz]
                                                .c.k[clra] *
                                              25 *
                                              10
                                            );
                                          }
                                          Aparts[
                                            ActivePartName[any]
                                          ].colorShades.Shades.push(arr);
                                        } else {
                                          let nameCheck = false;

                                          for (
                                            let name = 0;
                                            name <
                                            Aparts[ActivePartName[any]]
                                              .colorShades.ShadeName.length;
                                            name++
                                          ) {
                                            if (
                                              Aparts[ActivePartName[any]]
                                                .colorShades.ShadeName[name] !==
                                              json.assets[b].layers[c].layers[e]
                                                .layers[n].shapes[clry].nm
                                            ) {
                                              nameCheck = true;
                                            }
                                          }
                                          if (!nameCheck) {
                                            Aparts[
                                              ActivePartName[any]
                                            ].colorShades.ShadeName.push(
                                              json.assets[b].layers[c].layers[e]
                                                .layers[n].shapes[clry].nm
                                            );
                                            let arr = [];

                                            for (
                                              let clra = 0;
                                              clra < 3;
                                              clra++
                                            ) {
                                              arr.push(
                                                json.assets[b].layers[c].layers[
                                                  e
                                                ].layers[n].shapes[clry].it[
                                                  clrz
                                                ].c.k[clra] *
                                                25 *
                                                10
                                              );
                                            }
                                            Aparts[
                                              ActivePartName[any]
                                            ].colorShades.Shades.push(arr);
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    } else if (
                      json.assets[b].layers[c].layers[e].nm.split("_")[0] ===
                      "Hair"
                    ) {
                      //let check = json.assets[b].layers[c].layers[e].nm.split('_')
                      if (json.assets[b].layers[c].layers[e].nm.split("-")[1]) {
                        if (
                          json.assets[b].layers[c].layers[e].nm.split(
                            "_"
                          )[0] === NewName
                        ) {
                          if (
                            json.assets[b].layers[c].layers[e].hd === false ||
                            json.assets[b].layers[c].layers[e].hd === undefined
                          ) {
                            Aparts[ActivePartName[any]].data =
                              json.assets[b].layers[c].layers[e].nm.split(
                                "-"
                              )[0];

                            for (
                              let clry = 0;
                              clry <
                              json.assets[b].layers[c].layers[e].shapes.length;
                              clry++
                            ) {
                              if (
                                json.assets[b].layers[c].layers[e].shapes[
                                  clry
                                ].nm.split("_")[0] === "Changeable"
                              ) {
                                for (
                                  let clrz = 0;
                                  clrz <
                                  json.assets[b].layers[c].layers[e].shapes[
                                    clry
                                  ].it.length;
                                  clrz++
                                ) {
                                  if (
                                    json.assets[b].layers[c].layers[e].shapes[
                                      clry
                                    ].it[clrz].ty === "fl"
                                  ) {
                                    if (
                                      Aparts[ActivePartName[any]].colorShades
                                        .ShadeName.length === 0
                                    ) {
                                      Aparts[
                                        ActivePartName[any]
                                      ].colorShades.ShadeName.push(
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].nm
                                      );
                                      let arr = [];

                                      for (let clra = 0; clra < 3; clra++) {
                                        arr.push(
                                          json.assets[b].layers[c].layers[e]
                                            .shapes[clry].it[clrz].c.k[clra] *
                                          25 *
                                          10
                                        );
                                      }
                                      Aparts[
                                        ActivePartName[any]
                                      ].colorShades.Shades.push(arr);
                                    } else {
                                      let nameCheck = false;
                                      for (
                                        let name = 0;
                                        name <
                                        Aparts[ActivePartName[any]].colorShades
                                          .ShadeName.length;
                                        name++
                                      ) {
                                        if (
                                          Aparts[ActivePartName[any]]
                                            .colorShades.ShadeName[name] ===
                                          json.assets[b].layers[c].layers[e]
                                            .shapes[clry].nm
                                        ) {
                                          nameCheck = true;
                                        }
                                      }
                                      if (!nameCheck) {
                                        Aparts[
                                          ActivePartName[any]
                                        ].colorShades.ShadeName.push(
                                          json.assets[b].layers[c].layers[e]
                                            .shapes[clry].nm
                                        );
                                        let arr = [];
                                        for (let clra = 0; clra < 3; clra++) {
                                          arr.push(
                                            json.assets[b].layers[c].layers[e]
                                              .shapes[clry].it[clrz].c.k[clra] *
                                            25 *
                                            10
                                          );
                                        }
                                        Aparts[
                                          ActivePartName[any]
                                        ].colorShades.Shades.push(arr);
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      } else {
                        if (
                          json.assets[b].layers[c].layers[e].nm.split(
                            "_"
                          )[0] === NewName
                        ) {
                          if (
                            json.assets[b].layers[c].layers[e].hd === false ||
                            json.assets[b].layers[c].layers[e].hd === undefined
                          ) {
                            Aparts[ActivePartName[any]].data =
                              json.assets[b].layers[c].layers[e].nm;

                            for (
                              let clry = 0;
                              clry <
                              json.assets[b].layers[c].layers[e].shapes.length;
                              clry++
                            ) {
                              if (
                                json.assets[b].layers[c].layers[e].shapes[
                                  clry
                                ].nm.split("_")[0] === "Changeable"
                              ) {
                                for (
                                  let clrz = 0;
                                  clrz <
                                  json.assets[b].layers[c].layers[e].shapes[
                                    clry
                                  ].it.length;
                                  clrz++
                                ) {
                                  if (
                                    json.assets[b].layers[c].layers[e].shapes[
                                      clry
                                    ].it[clrz].ty === "fl"
                                  ) {
                                    if (
                                      Aparts[ActivePartName[any]].colorShades
                                        .ShadeName.length === 0
                                    ) {
                                      Aparts[
                                        ActivePartName[any]
                                      ].colorShades.ShadeName.push(
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].nm
                                      );
                                      let arr = [];

                                      for (let clra = 0; clra < 3; clra++) {
                                        arr.push(
                                          json.assets[b].layers[c].layers[e]
                                            .shapes[clry].it[clrz].c.k[clra] *
                                          25 *
                                          10
                                        );
                                      }
                                      Aparts[
                                        ActivePartName[any]
                                      ].colorShades.Shades.push(arr);
                                    } else {
                                      let nameCheck = false;
                                      for (
                                        let name = 0;
                                        name <
                                        Aparts[ActivePartName[any]].colorShades
                                          .ShadeName.length;
                                        name++
                                      ) {
                                        if (
                                          Aparts[ActivePartName[any]]
                                            .colorShades.ShadeName[name] ===
                                          json.assets[b].layers[c].layers[e]
                                            .shapes[clry].nm
                                        ) {
                                          nameCheck = true;
                                        }
                                      }
                                      if (!nameCheck) {
                                        Aparts[
                                          ActivePartName[any]
                                        ].colorShades.ShadeName.push(
                                          json.assets[b].layers[c].layers[e]
                                            .shapes[clry].nm
                                        );
                                        let arr = [];
                                        for (let clra = 0; clra < 3; clra++) {
                                          arr.push(
                                            json.assets[b].layers[c].layers[e]
                                              .shapes[clry].it[clrz].c.k[clra] *
                                            25 *
                                            10
                                          );
                                        }
                                        Aparts[
                                          ActivePartName[any]
                                        ].colorShades.Shades.push(arr);
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    } else if (
                      json.assets[b].layers[c].layers[e].nm.split("_")[0] ===
                      "Mouth"
                    ) {
                      if (
                        (json.assets[b].layers[c].layers[e].hd === false ||
                          json.assets[b].layers[c].layers[e].hd === undefined) && json.assets[b].layers[c].layers[e].shapes != undefined
                      ) {
                        let data =
                          json.assets[b].layers[c].layers[e].nm.split("-");
                        if (data.length == 1) {
                          Aparts[ActivePartName[any]].data =
                            json.assets[b].layers[c].layers[e].nm;

                          for (
                            let clry = 0;
                            clry <
                            json.assets[b].layers[c].layers[e].shapes.length;
                            clry++
                          ) {
                            if (
                              json.assets[b].layers[c].layers[e].shapes[
                                clry
                              ].nm.split("_")[0] === "Changeable"
                            ) {
                              for (
                                let clrz = 0;
                                clrz <
                                json.assets[b].layers[c].layers[e].shapes[clry]
                                  .it.length;
                                clrz++
                              ) {
                                if (
                                  json.assets[b].layers[c].layers[e].shapes[
                                    clry
                                  ].it[clrz].ty === "fl"
                                ) {
                                  if (
                                    Aparts[ActivePartName[any]].colorShades
                                      .ShadeName.length === 0
                                  ) {
                                    Aparts[
                                      ActivePartName[any]
                                    ].colorShades.ShadeName.push(
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].nm
                                    );
                                    let arr = [];

                                    for (let clra = 0; clra < 3; clra++) {
                                      arr.push(
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].it[clrz].c.k[clra] *
                                        25 *
                                        10
                                      );
                                    }
                                    Aparts[
                                      ActivePartName[any]
                                    ].colorShades.Shades.push(arr);
                                  } else {
                                    let nameCheck = false;
                                    for (
                                      let name = 0;
                                      name <
                                      Aparts[ActivePartName[any]].colorShades
                                        .ShadeName.length;
                                      name++
                                    ) {
                                      if (
                                        Aparts[ActivePartName[any]].colorShades
                                          .ShadeName[name] ===
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].nm
                                      ) {
                                        nameCheck = true;
                                      }
                                    }
                                    if (!nameCheck) {
                                      Aparts[
                                        ActivePartName[any]
                                      ].colorShades.ShadeName.push(
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].nm
                                      );
                                      let arr = [];
                                      for (let clra = 0; clra < 3; clra++) {
                                        arr.push(
                                          json.assets[b].layers[c].layers[e]
                                            .shapes[clry].it[clrz].c.k[clra] *
                                          25 *
                                          10
                                        );
                                      }
                                      Aparts[
                                        ActivePartName[any]
                                      ].colorShades.Shades.push(arr);
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    setActiveParts(Aparts);
  };

  useEffect(() => {
    if (props.rjson) {
      readJson();
    }
  }, [props.rjson]);

  useEffect(() => {
    if (props.canvZoom.width !== "") {
      if (selection === true) {
        const ctx = document
          .getElementsByClassName("ChrClass")[0]
          .getContext("2d");
        let canvas = document.getElementsByClassName("ChrClass")[0];
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        get = Lottie.loadAnimation({
          name: "alex",
          renderer: "canvas",
          loop: true,
          autoplay: true,
          animationData: NewJson,
          rendererSettings: {
            context: ctx,
            scaleMode: "noScale",
            clearCanvas: true,
          },
        });
        setPlay(get);
        setselection(false);
      } else {
        var currFrame = 0;
        if (Play !== null) {
          Lottie.destroy("alex");
          currFrame = Play.currentFrame;
        }
        const ctx = MainCanvas.current.getContext("2d");

        ctx.clearRect(
          0,
          0,
          MainCanvas.current.width,
          MainCanvas.current.height
        );
        get = Lottie.loadAnimation({
          name: "alex",
          renderer: "canvas",
          loop: true,
          autoplay: true,
          animationData: Play.animationData,

          rendererSettings: {
            context: ctx,
            clearCanvas: true,
          },
        });
        get.goToAndPlay(currFrame, true, "alex");
        setPlay(get);
      }
    }
  }, [props.canvZoom]);

  const ActiveCap = (path) => {
    try {
      var pName = path.substring(path.lastIndexOf("/") + 1);
      pName = pName.split(".")[0];
      PartsName = [];
      var json = NewJson;
      var NewName = pName.split("_")[0];

      if (props.Gender === "Female") {
        for (let a = 0; a < FemaleBodyParts.length; a++) {
          if (FemaleBodyParts[a].name === NewName) {
            PartsName = FemaleBodyParts[a].parts;
          }
        }
      } else if (props.Gender === "Male") {
        for (let a = 0; a < MaleBodyParts.length; a++) {
          if (MaleBodyParts[a].name === NewName) {
            PartsName = MaleBodyParts[a].parts;
          }
        }
      }

      for (let b = 0; b < json.assets.length; b++) {
        if (json.assets[b].id === "comp_0") {
          for (let c = 0; c < json.assets[b].layers.length; c++) {
            for (let d = 0; d < PartsName.length; d++) {
              if (json.assets[b].layers[c].nm === PartsName[d]) {
                for (
                  let e = 0;
                  e < json.assets[b].layers[c].layers.length;
                  e++
                ) {
                  if (
                    json.assets[b].layers[c].layers[e].nm.split("_")[0] ===
                    NewName
                  ) {
                    json.assets[b].layers[c].layers[e].hd = true;

                    if (json.assets[b].layers[c].layers[e].nm === pName) {
                      json.assets[b].layers[c].layers[e].hd = false;

                      setActiveParts({
                        ...ActiveParts,
                        ...(ActiveParts["Cap"].data = pName),
                        ...(ActiveParts["Cap"].colorShades.ShadeName = []),
                        ...(ActiveParts["Cap"].colorShades.Shades = []),
                      });
                      if (ActiveParts["Hair"].data !== null) {
                        let part = [
                          "SideHair_Comp",
                          "FrontHair_Comp",
                          "BackHair_Comp",
                        ];

                        for (let c = 0; c < json.assets[b].layers.length; c++) {
                          for (let d = 0; d < part.length; d++) {
                            if (json.assets[b].layers[c].nm === part[d]) {
                              for (
                                let e = 0;
                                e < json.assets[b].layers[c].layers.length;
                                e++
                              ) {
                                json.assets[b].layers[c].layers[e].hd = true;

                                if (
                                  json.assets[b].layers[c].layers[e].nm ===
                                  ActiveParts["Hair"].data + "-Cap"
                                ) {
                                  json.assets[b].layers[c].layers[e].hd = false;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                break;
              }
            }
          }
          break;
        }
      }

      var currFrame = Play.currentFrame;
      Lottie.destroy("alex");

      const ctx = document
        .getElementsByClassName("ChrClass")[0]
        .getContext("2d");

      get = Lottie.loadAnimation({
        name: "alex",
        renderer: "canvas",
        loop: true,
        autoplay: true,
        animationData: NewJson,

        rendererSettings: {
          context: ctx,
          scaleMode: "noScale",
          clearCanvas: true,
          //className: 'CharCanv',
        },
      });

      get.goToAndPlay(currFrame, true, "alex");
      setPlay(get);
    } catch (ex) { }
  };

  const CapRemove = (NewName) => {
    var json = NewJson;
    PartsName = [];
    if (props.Gender === "Female") {
      for (let a = 0; a < FemaleBodyParts.length; a++) {
        if (FemaleBodyParts[a].name === NewName) {
          PartsName = FemaleBodyParts[a].parts;
        }
      }
    } else if (props.Gender === "Male") {
      for (let a = 0; a < MaleBodyParts.length; a++) {
        if (MaleBodyParts[a].name === NewName) {
          PartsName = MaleBodyParts[a].parts;
        }
      }
    }
    for (let b = 0; b < json.assets.length; b++) {
      if (json.assets[b].id === "comp_0") {
        for (let c = 0; c < json.assets[b].layers.length; c++) {
          for (let d = 0; d < PartsName.length; d++) {
            if (json.assets[b].layers[c].nm === PartsName[d]) {
              for (let e = 0; e < json.assets[b].layers[c].layers.length; e++) {
                if (
                  json.assets[b].layers[c].layers[e].nm.split("_")[0] ===
                  NewName
                ) {
                  if (
                    json.assets[b].layers[c].layers[e].hd === false ||
                    json.assets[b].layers[c].layers[e].hd === undefined
                  ) {
                    json.assets[b].layers[c].layers[e].hd = true;
                    setActiveParts({
                      ...ActiveParts,
                      ...(ActiveParts[NewName].data = null),
                      ...(ActiveParts[NewName].colorShades.ShadeName = []),
                      ...(ActiveParts[NewName].colorShades.Shades = []),
                    });
                  }
                }
              }
              if (ActiveParts["Hair"].data !== null) {
                let part = ["SideHair_Comp", "FrontHair_Comp", "BackHair_Comp"];

                for (let c = 0; c < json.assets[b].layers.length; c++) {
                  for (let d = 0; d < part.length; d++) {
                    if (json.assets[b].layers[c].nm === part[d]) {
                      for (
                        let e = 0;
                        e < json.assets[b].layers[c].layers.length;
                        e++
                      ) {
                        json.assets[b].layers[c].layers[e].hd = true;

                        if (
                          json.assets[b].layers[c].layers[e].nm ===
                          ActiveParts["Hair"].data
                        ) {
                          json.assets[b].layers[c].layers[e].hd = false;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    var currFrame = Play.currentFrame;

    Lottie.destroy("alex");

    const ctx = document.getElementsByClassName("ChrClass")[0].getContext("2d");
    get = Lottie.loadAnimation({
      name: "alex",
      renderer: "canvas",
      loop: true,
      autoplay: true,
      animationData: NewJson,

      rendererSettings: {
        context: ctx,
        scaleMode: "noScale",
        clearCanvas: true,
        //className: 'CharCanv',
      },
    });
    get.goToAndPlay(currFrame, true, "alex");

    setPlay(get);
  };

  const ActiveHair = (path) => {
    try {
      var pName = path.substring(path.lastIndexOf("/") + 1);
      pName = pName.split(".")[0];
      PartsName = [];
      var json = NewJson;
      var NewName = pName.split("_")[0];
      if (props.Gender === "Female") {
        for (let a = 0; a < FemaleBodyParts.length; a++) {
          if (FemaleBodyParts[a].name === NewName) {
            PartsName = FemaleBodyParts[a].parts;
          }
        }
      } else if (props.Gender === "Male") {
        for (let a = 0; a < MaleBodyParts.length; a++) {
          if (MaleBodyParts[a].name === NewName) {
            PartsName = MaleBodyParts[a].parts;
          }
        }
      }

      let arrayName = [];
      let arrayShade = [];

      for (let b = 0; b < json.assets.length; b++) {
        if (json.assets[b].id === "comp_0") {
          for (let c = 0; c < json.assets[b].layers.length; c++) {
            for (let d = 0; d < PartsName.length; d++) {
              if (json.assets[b].layers[c].nm === PartsName[d]) {
                for (
                  let e = 0;
                  e < json.assets[b].layers[c].layers.length;
                  e++
                ) {
                  if (
                    json.assets[b].layers[c].layers[e].nm.split("_")[0] ===
                    NewName
                  ) {
                    json.assets[b].layers[c].layers[e].hd = true;
                    if (ActiveParts["Cap"].data !== null) {
                      if (
                        json.assets[b].layers[c].layers[e].nm ===
                        pName + "-Cap"
                      ) {
                        json.assets[b].layers[c].layers[e].hd = false;
                      }
                      if (json.assets[b].layers[c].layers[e].nm === pName) {
                        //json.assets[b].layers[c].layers[e].hd = false

                        for (
                          let clry = 0;
                          clry <
                          json.assets[b].layers[c].layers[e].shapes.length;
                          clry++
                        ) {
                          if (
                            json.assets[b].layers[c].layers[e].shapes[
                              clry
                            ].nm.split("_")[0] === "Changeable"
                          ) {
                            for (
                              let clrz = 0;
                              clrz <
                              json.assets[b].layers[c].layers[e].shapes[clry].it
                                .length;
                              clrz++
                            ) {
                              if (
                                json.assets[b].layers[c].layers[e].shapes[clry]
                                  .it[clrz].ty === "fl"
                              ) {
                                if (arrayName.length === 0) {
                                  let arr = [];

                                  for (let clra = 0; clra < 3; clra++) {
                                    arr.push(
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].it[clrz].c.k[clra] *
                                      25 *
                                      10
                                    );
                                  }

                                  arrayName.push(
                                    json.assets[b].layers[c].layers[e].shapes[
                                      clry
                                    ].nm
                                  );
                                  arrayShade.push(arr);
                                } else {
                                  let nameCheck = false;
                                  for (
                                    let name = 0;
                                    name < arrayName.length;
                                    name++
                                  ) {
                                    if (
                                      arrayName[name] ===
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].nm
                                    ) {
                                      nameCheck = true;
                                    }
                                  }
                                  if (!nameCheck) {
                                    let arr = [];
                                    for (let clra = 0; clra < 3; clra++) {
                                      arr.push(
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].it[clrz].c.k[clra] *
                                        25 *
                                        10
                                      );
                                    }

                                    arrayName.push(
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].nm
                                    );
                                    arrayShade.push(arr);
                                  }
                                }
                              }
                            }
                          }
                        }
                        setActiveParts({
                          ...ActiveParts,
                          ...(ActiveParts[NewName].data = pName),
                          ...(ActiveParts[NewName].colorShades.ShadeName =
                            arrayName),
                          ...(ActiveParts[NewName].colorShades.Shades =
                            arrayShade),
                        });
                      }
                    } else {
                      if (json.assets[b].layers[c].layers[e].nm === pName) {
                        json.assets[b].layers[c].layers[e].hd = false;

                        for (
                          let clry = 0;
                          clry <
                          json.assets[b].layers[c].layers[e].shapes.length;
                          clry++
                        ) {
                          if (
                            json.assets[b].layers[c].layers[e].shapes[
                              clry
                            ].nm.split("_")[0] === "Changeable"
                          ) {
                            for (
                              let clrz = 0;
                              clrz <
                              json.assets[b].layers[c].layers[e].shapes[clry].it
                                .length;
                              clrz++
                            ) {
                              if (
                                json.assets[b].layers[c].layers[e].shapes[clry]
                                  .it[clrz].ty === "fl"
                              ) {
                                if (arrayName.length === 0) {
                                  let arr = [];

                                  for (let clra = 0; clra < 3; clra++) {
                                    arr.push(
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].it[clrz].c.k[clra] *
                                      25 *
                                      10
                                    );
                                  }

                                  arrayName.push(
                                    json.assets[b].layers[c].layers[e].shapes[
                                      clry
                                    ].nm
                                  );
                                  arrayShade.push(arr);
                                } else {
                                  let nameCheck = false;
                                  for (
                                    let name = 0;
                                    name < arrayName.length;
                                    name++
                                  ) {
                                    if (
                                      arrayName[name] ===
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].nm
                                    ) {
                                      nameCheck = true;
                                    }
                                  }
                                  if (!nameCheck) {
                                    let arr = [];
                                    for (let clra = 0; clra < 3; clra++) {
                                      arr.push(
                                        json.assets[b].layers[c].layers[e]
                                          .shapes[clry].it[clrz].c.k[clra] *
                                        25 *
                                        10
                                      );
                                    }
                                    arrayName.push(
                                      json.assets[b].layers[c].layers[e].shapes[
                                        clry
                                      ].nm
                                    );
                                    arrayShade.push(arr);
                                  }
                                }
                              }
                            }
                          }
                        }
                        setActiveParts({
                          ...ActiveParts,
                          ...(ActiveParts[NewName].data = pName),
                          ...(ActiveParts[NewName].colorShades.ShadeName =
                            arrayName),
                          ...(ActiveParts[NewName].colorShades.Shades =
                            arrayShade),
                        });
                      }
                    }
                  }
                }
                break;
              }
            }
          }
          break;
        }
      }
      let blackArray = [58 / 255, 58 / 255, 58 / 255];

      for (let b = 1; b < json.assets.length; b++) {
        if (json.assets[b].id === "comp_0") {
          for (let c = 0; c < json.assets[b].layers.length; c++) {
            if (json.assets[b].layers[c].layers != undefined) {
              for (let e = 0; e < json.assets[b].layers[c].layers.length; e++) {
                if (json.assets[b].layers[c].layers[e].nm === pName) {
                  for (
                    let clry = 0;
                    clry < json.assets[b].layers[c].layers[e].shapes.length;
                    clry++
                  ) {
                    if (
                      json.assets[b].layers[c].layers[e].shapes[clry].nm ===
                      arrayName[0]
                    ) {
                      for (
                        let clrz = 0;
                        clrz <
                        json.assets[b].layers[c].layers[e].shapes[clry].it
                          .length;
                        clrz++
                      ) {
                        if (
                          json.assets[b].layers[c].layers[e].shapes[clry].it[
                            clrz
                          ].ty === "fl"
                        ) {
                          for (let clra = 0; clra < blackArray.length; clra++) {
                            json.assets[b].layers[c].layers[e].shapes[clry].it[
                              clrz
                            ].c.k[clra] = blackArray[clra];
                          }
                        }
                      }
                    }
                  }
                }
                let varient = pName + "-Cap";

                if (json.assets[b].layers[c].layers[e].nm === varient) {
                  for (
                    let clry = 0;
                    clry < json.assets[b].layers[c].layers[e].shapes.length;
                    clry++
                  ) {
                    if (
                      json.assets[b].layers[c].layers[e].shapes[clry].nm ===
                      arrayName[0]
                    ) {
                      for (
                        let clrz = 0;
                        clrz <
                        json.assets[b].layers[c].layers[e].shapes[clry].it
                          .length;
                        clrz++
                      ) {
                        if (
                          json.assets[b].layers[c].layers[e].shapes[clry].it[
                            clrz
                          ].ty === "fl"
                        ) {
                          for (let clra = 0; clra < blackArray.length; clra++) {
                            json.assets[b].layers[c].layers[e].shapes[clry].it[
                              clrz
                            ].c.k[clra] = blackArray[clra];
                          }
                        }
                      }
                    }
                  }
                }
              }
              for (let c2 = 0; c2 < json.assets[b].layers.length; c2++) {
                if (json.assets[b].layers[c2].nm === "EyeBrow_Comp") {
                  for (
                    let e = 0;
                    e < json.assets[b].layers[c2].layers.length;
                    e++
                  ) {
                    for (
                      let clry = 0;
                      clry < json.assets[b].layers[c2].layers[e].shapes.length;
                      clry++
                    ) {
                      for (
                        let clrz = 0;
                        clrz <
                        json.assets[b].layers[c2].layers[e].shapes[clry].it
                          .length;
                        clrz++
                      ) {
                        if (
                          json.assets[b].layers[c2].layers[e].shapes[clry].it[
                            clrz
                          ].ty === "fl"
                        ) {
                          for (let clra = 0; clra < blackArray.length; clra++) {
                            json.assets[b].layers[c2].layers[e].shapes[clry].it[
                              clrz
                            ].c.k[clra] = blackArray[clra];
                          }
                        }
                      }
                    }
                  }
                  break;
                }
              }
              for (let c2 = 0; c2 < json.assets[b].layers.length; c2++) {
                if (json.assets[b].layers[c2].nm === "Mouth_Comp") {
                  for (
                    let e = 0;
                    e < json.assets[b].layers[c2].layers.length;
                    e++
                  ) {
                    for (
                      let clry = 0;
                      clry < json.assets[b].layers[c2].layers[e].shapes.length;
                      clry++
                    ) {
                      if (
                        json.assets[b].layers[c2].layers[e].shapes[clry].nm ==
                        "Hair"
                      ) {
                        for (
                          let clrz = 0;
                          clrz <
                          json.assets[b].layers[c2].layers[e].shapes[clry].it
                            .length;
                          clrz++
                        ) {
                          if (
                            json.assets[b].layers[c2].layers[e].shapes[clry].it[
                              clrz
                            ].ty === "fl"
                          ) {
                            for (
                              let clra = 0;
                              clra < blackArray.length;
                              clra++
                            ) {
                              json.assets[b].layers[c2].layers[e].shapes[
                                clry
                              ].it[clrz].c.k[clra] = blackArray[clra];
                            }
                          }
                        }
                      }
                    }
                  }
                  break;
                }
              }
            }
          }
          break;
        }
      }
      var currFrame = Play.currentFrame;
      Lottie.destroy("alex");
      const ctx = document
        .getElementsByClassName("ChrClass")[0]
        .getContext("2d");

      get = Lottie.loadAnimation({
        name: "alex",
        renderer: "canvas",
        loop: true,
        autoplay: true,
        animationData: NewJson,

        rendererSettings: {
          context: ctx,
          scaleMode: "noScale",
          clearCanvas: true,
          //className: 'CharCanv',
        },
      });

      get.goToAndPlay(currFrame, true, "alex");
      setPlay(get);
    } catch (ex) { }
  };

  return (
    <div key={"popRightArea1"} className="chrpopRightPanel">
      <div className="chrpopRightPanelInner">
        {" "}
        {props.TopActive !== "Gender" && (
          <>
            {" "}
            <div className="ChrRightPanelStart">
              {" "}
              <div className="ChrRi8Panel ">
                <div className="ChrRi8PanelInner">
                  {props.ActiveLeftBar.char && (
                    <>
                      {props.charActive === "Body" && (
                        <>
                          <div style={{ marginLeft: "19px" }}>Bodies</div>

                          <div className="characterEditorInner">
                            <div className="characterEditorLeft">
                              <div className="charEditorScroll style-1">
                                <div className="editScrollOptions">
                                  {ActiveGender === "Male" &&
                                    DefaultCharacter.Male.map((lmc, index) => (
                                      <div
                                        className="CharacterEditorOptions_parent"
                                        key={"allDefaultCharacters" + index}
                                      >
                                        <img
                                          className="CharacterEditorOptions_Child"
                                          src={
                                            authenticationData.ApiBaseURL +
                                            "/" +
                                            lmc.svg
                                          }
                                          onClick={() => {
                                            ColorAndClotheClick(
                                              lmc.partsData,
                                              lmc.characterName
                                            );
                                          }}
                                        />
                                      </div>
                                    ))}

                                  {ActiveGender !== "Male" &&
                                    DefaultCharacter.Female.map(
                                      (lmc, index) => (
                                        <div
                                          className="CharacterEditorOptions_parent"
                                          key={"allDefaultCharacters" + index}
                                        >
                                          <img
                                            className="CharacterEditorOptions_Child"
                                            src={
                                              authenticationData.ApiBaseURL +
                                              "/" +
                                              lmc.svg
                                            }
                                            onClick={() => {
                                              ColorAndClotheClick(
                                                lmc.partsData,
                                                lmc.characterName
                                              );
                                            }}
                                          />
                                        </div>
                                      )
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}

                  {props.ActiveLeftBar.face && (
                    <>
                      {" "}
                      {props.TopActive === "Head" && (
                        <>
                          <div style={{ marginLeft: "19px" }}>Head</div>

                          <div className="characterEditorInner">
                            <div className="characterEditorLeft">
                              <div className="charEditorScroll style-1">
                                <div className="editScrollOptions">
                                  {AssetData.head.map((lmc, index) => (
                                    <div
                                      key={"head" + index}
                                      className={
                                        "CharacterEditorOptions" +
                                        (ActiveParts.Face.data === lmc.name
                                          ? " CharOptionsActive"
                                          : "")
                                      }
                                      onClick={() => ClotheClick(lmc.path)}
                                    >
                                      <img
                                        key={index}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                        src={lmc.path}
                                        alt=""
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {props.TopActive === "Hair" && (
                        <>
                          <div style={{ marginLeft: "19px" }}>Hair</div>

                          <div className="characterEditorInner">
                            <div className="characterEditorLeft">
                              <div className="charEditorScroll style-1">
                                <div className="editScrollOptions">
                                  <div
                                    className={
                                      "CharacterEditorOptions" +
                                      (ActiveParts.Hair.data === null ||
                                        ActiveParts.Hair.data === "empty"
                                        ? " CharOptionsActive"
                                        : "")
                                    }
                                    onClick={() => RemoveAsset("Hair")}
                                  >
                                    <img
                                      className="emptyCharacter"
                                      src={"images/CharacterAssets/Empty_.svg"}
                                      alt=""
                                    />
                                  </div>

                                  {AssetData.hair.map((lmc, index) => (
                                    <div
                                      key={"hair" + index}
                                      className={
                                        "CharacterEditorOptions" +
                                        (ActiveParts.Hair.data === lmc.name
                                          ? " CharOptionsActive"
                                          : "")
                                      }
                                      onClick={() => ActiveHair(lmc.path)}
                                    >
                                      <img
                                        key={index}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                        src={lmc.path}
                                        alt=""
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {props.TopActive === "Mouth" && (
                        <>
                          <div style={{ marginLeft: "19px" }}>Mouth</div>

                          <div className="characterEditorInner">
                            <div className="characterEditorLeft">
                              <div className="charEditorScroll style-1">
                                <div className="editScrollOptions">
                                  <div
                                    className={
                                      "CharacterEditorOptions" +
                                      (ActiveParts.Mouth.data === null ||
                                        ActiveParts.Mouth.data === "empty"
                                        ? " CharOptionsActive"
                                        : "")
                                    }
                                    onClick={() => RemoveAsset("Mouth")}
                                  >
                                    <img
                                      className="emptyCharacter"
                                      src={"images/CharacterAssets/Empty_.svg"}
                                      alt=""
                                    />
                                  </div>
                                  {AssetData.Mouth.map((lmc, index) => (
                                    <div
                                      key={"Mouth" + index}
                                      className={
                                        "CharacterEditorOptions" +
                                        (ActiveParts.Mouth.data === lmc.name
                                          ? " CharOptionsActive"
                                          : "")
                                      }
                                      onClick={() => ClotheClick(lmc.path)}
                                    >
                                      <img
                                        key={index}
                                        className="charpopMouth"
                                        src={lmc.path}
                                        alt=""
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {props.TopActive === "Nose" && (
                        <>
                          <div style={{ marginLeft: "19px" }}>Nose</div>

                          <div className="characterEditorInner">
                            <div className="characterEditorLeft">
                              <div className="charEditorScroll style-1">
                                <div className="editScrollOptions">
                                  <div
                                    className={
                                      "CharacterEditorOptions" +
                                      (ActiveParts.Nose.data === null ||
                                        ActiveParts.Nose.data === "empty"
                                        ? " CharOptionsActive"
                                        : "")
                                    }
                                    onClick={() => RemoveAsset("Nose")}
                                  >
                                    <img
                                      className="emptyCharacter"
                                      src={"images/CharacterAssets/Empty_.svg"}
                                      alt=""
                                    />
                                  </div>

                                  {AssetData.Nose.map((lmc, index) => (
                                    <div
                                      key={"Nose" + index}
                                      className={
                                        "CharacterEditorOptions" +
                                        (ActiveParts.Nose.data === lmc.name
                                          ? " CharOptionsActive"
                                          : "")
                                      }
                                      onClick={() => ClotheClick(lmc.path)}
                                    >
                                      <img
                                        key={index}
                                        className="charpopMouth"
                                        src={lmc.path}
                                        alt=""
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {props.TopActive === "Eyes" && (
                        <>
                          <div className="characterEditorInner">
                            <div className="characterEditorLeft">
                              <div className="charEditorScroll style-1">
                                <div>
                                  <div style={{ marginLeft: "19px" }}>Eyes</div>
                                  <div className="editScrollOptions">
                                    <div
                                      style={{ height: "186px" }}
                                      className={
                                        "CharacterEditorOptions" +
                                        (ActiveParts.Eye.data === null ||
                                          ActiveParts.Eye.data === "empty"
                                          ? " CharOptionsActive"
                                          : "")
                                      }
                                      onClick={() => RemoveAsset("Eye")}
                                    >
                                      <img
                                        className="emptyCharacter"
                                        src={
                                          "images/CharacterAssets/Empty_.svg"
                                        }
                                        alt=""
                                      />
                                    </div>

                                    {AssetData.Eyes.eye.map((lmc, index) => (
                                      <div
                                        key={"Eyes.eye" + index}
                                        className={
                                          "CharacterEditorOptions" +
                                          (ActiveParts.Eye.data === lmc.name
                                            ? " CharOptionsActive"
                                            : "")
                                        }
                                        onClick={() => ClotheClick(lmc.path)}
                                      >
                                        <div style={{ height: "186px" }}>
                                          <img
                                            key={index}
                                            className="charpopeyes"
                                            src={lmc.path}
                                            alt=""
                                          />
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                <div>
                                  <div style={{ marginLeft: "19px" }}>
                                    EyeBrows
                                  </div>

                                  <div className="editScrollOptions">
                                    <div
                                      style={{ height: "186px" }}
                                      className={
                                        "CharacterEditorOptions" +
                                        (ActiveParts.EyeBrow.data === null ||
                                          ActiveParts.EyeBrow.data === "empty"
                                          ? " CharOptionsActive"
                                          : "")
                                      }
                                      onClick={() => RemoveAsset("EyeBrow")}
                                    >
                                      <img
                                        className="emptyCharacter"
                                        src={
                                          "images/CharacterAssets/Empty_.svg"
                                        }
                                        alt=""
                                      />
                                    </div>

                                    {AssetData.Eyes.EyeBrows.map(
                                      (lmc, index) => (
                                        <div
                                          key={"Eyes.EyeBrows" + index}
                                          className={
                                            "CharacterEditorOptions" +
                                            (ActiveParts.EyeBrow.data ===
                                              lmc.name
                                              ? " CharOptionsActive"
                                              : "")
                                          }
                                          onClick={() => ClotheClick(lmc.path)}
                                        >
                                          <div style={{ height: "186px" }}>
                                            <img
                                              key={index}
                                              className="charpopeyes"
                                              src={lmc.path}
                                              alt=""
                                            />
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}

                  {props.ActiveLeftBar.clothes && (
                    <>
                      {props.TopActive === "Shirts" && (
                        <>
                          <div style={{ marginLeft: "19px" }}>Shirts</div>

                          <div className="characterEditorInner">
                            <div className="characterEditorLeft">
                              <div className="charEditorScroll style-1">
                                <div className="editScrollOptions">
                                  <div
                                    className={
                                      "CharacterEditorOptions" +
                                      (ActiveParts.LowerTop.data === null ||
                                        ActiveParts.LowerTop.data === "empty"
                                        ? " CharOptionsActive"
                                        : "")
                                    }
                                    onClick={() => RemoveAsset("LowerTop")}
                                  >
                                    <img
                                      className="emptyCharacter"
                                      src={"images/CharacterAssets/Empty_.svg"}
                                      alt=""
                                    />
                                  </div>

                                  {AssetData.Shirts.Shirt.map((lmc, index) => (
                                    <div
                                      key={"Shirts.Shirt" + index}
                                      className={
                                        "CharacterEditorOptions" +
                                        (ActiveParts.LowerTop.data === lmc.name
                                          ? " CharOptionsActive"
                                          : "")
                                      }
                                      onClick={() => ClotheClick(lmc.path)}
                                    >
                                      <img
                                        key={index}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                        src={lmc.path}
                                        alt=""
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      {props.TopActive === "Sweaters" && (
                        <>
                          <div style={{ marginLeft: "19px" }}>Sweaters</div>

                          <div className="characterEditorInner">
                            <div className="characterEditorLeft">
                              <div className="charEditorScroll style-1">
                                <div className="editScrollOptions">
                                  <div
                                    className={
                                      "CharacterEditorOptions" +
                                      (ActiveParts.MiddleTop.data === null ||
                                        ActiveParts.MiddleTop.data === "empty"
                                        ? " CharOptionsActive"
                                        : "")
                                    }
                                    onClick={() => RemoveAsset("MiddleTop")}
                                  >
                                    <img
                                      className="emptyCharacter"
                                      src={"images/CharacterAssets/Empty_.svg"}
                                      alt=""
                                    />
                                  </div>

                                  {AssetData.Shirts.Sweaters.map(
                                    (lmc, index) => (
                                      <div
                                        key={"Shirts.Sweaters" + index}
                                        className={
                                          "CharacterEditorOptions" +
                                          (ActiveParts.MiddleTop.data ===
                                            lmc.name
                                            ? " CharOptionsActive"
                                            : "")
                                        }
                                        onClick={() => ClotheClick(lmc.path)}
                                      >
                                        <img
                                          key={index}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                          }}
                                          src={lmc.path}
                                          alt=""
                                        />
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      {props.TopActive === "Jackets" && (
                        <>
                          <div style={{ marginLeft: "19px" }}>Jackets</div>

                          <div className="characterEditorInner">
                            <div className="characterEditorLeft">
                              <div className="charEditorScroll style-1">
                                <div className="editScrollOptions">
                                  <div
                                    className={
                                      "CharacterEditorOptions" +
                                      (ActiveParts.OuterTop.data === null ||
                                        ActiveParts.OuterTop.data === "empty"
                                        ? " CharOptionsActive"
                                        : "")
                                    }
                                    onClick={() => RemoveAsset("OuterTop")}
                                  >
                                    <img
                                      className="emptyCharacter"
                                      src={"images/CharacterAssets/Empty_.svg"}
                                      alt=""
                                    />
                                  </div>

                                  {AssetData.Shirts.Jackets.map(
                                    (lmc, index) => (
                                      <div
                                        key={"Shirts.Jackets" + index}
                                        className={
                                          "CharacterEditorOptions" +
                                          (ActiveParts.OuterTop.data ===
                                            lmc.name
                                            ? " CharOptionsActive"
                                            : "")
                                        }
                                        onClick={() => ClotheClick(lmc.path)}
                                      >
                                        <img
                                          key={index}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                          }}
                                          src={lmc.path}
                                          alt=""
                                        />
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      {props.TopActive === "Bottoms" && (
                        <>
                          <div style={{ marginLeft: "19px" }}>Bottoms</div>

                          <div className="characterEditorInner">
                            <div className="characterEditorLeft">
                              <div className="charEditorScroll style-1">
                                <div className="editScrollOptions">
                                  <div
                                    className={
                                      "CharacterEditorOptions" +
                                      (ActiveParts.Bottom.data === null ||
                                        ActiveParts.Bottom.data === "empty"
                                        ? " CharOptionsActive"
                                        : "")
                                    }
                                    onClick={() => RemoveAsset("Bottom")}
                                  >
                                    <img
                                      className="emptyCharacter"
                                      src={"images/CharacterAssets/Empty_.svg"}
                                      alt=""
                                    />
                                  </div>

                                  {AssetData.Bottoms.map((lmc, index) => (
                                    <div
                                      key={"Bottoms" + index}
                                      className={
                                        "CharacterEditorOptions" +
                                        (ActiveParts.Bottom.data === lmc.name
                                          ? " CharOptionsActive"
                                          : "")
                                      }
                                      onClick={() => ClotheClick(lmc.path)}
                                    >
                                      <img
                                        key={index}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                        src={lmc.path}
                                        alt=""
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      {props.TopActive === "Shoes" && (
                        <>
                          <div style={{ marginLeft: "19px" }}>Gender</div>

                          <div className="characterEditorInner">
                            <div className="characterEditorLeft">
                              <div className="charEditorScroll style-1">
                                <div className="editScrollOptions">
                                  <div
                                    className={
                                      "CharacterEditorOptions" +
                                      (ActiveParts.Shoe.data === null ||
                                        ActiveParts.Shoe.data === "empty"
                                        ? " CharOptionsActive"
                                        : "")
                                    }
                                    onClick={() => RemoveAsset("Shoe")}
                                  >
                                    <img
                                      className="emptyCharacter"
                                      src={"images/CharacterAssets/Empty_.svg"}
                                      alt=""
                                    />
                                  </div>

                                  {AssetData.Shoes.map((lmc, index) => (
                                    <div
                                      key={"Shoes" + index}
                                      className={
                                        "CharacterEditorOptions" +
                                        (ActiveParts.Shoe.data === lmc.name
                                          ? " CharOptionsActive"
                                          : "")
                                      }
                                      onClick={() => ClotheClick(lmc.path)}
                                    >
                                      <img
                                        key={index}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                        src={lmc.path}
                                        alt=""
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      {props.TopActive === "Other" && (
                        <>
                          <div style={{ marginLeft: "19px" }}>Others</div>

                          <div className="characterEditorInner">
                            <div className="characterEditorLeft">
                              <div className="charEditorScroll style-1">
                                {" "}
                                <div>
                                  <div style={{ marginLeft: "19px" }}>
                                    Head Wears
                                  </div>

                                  <div className="editScrollOptions">
                                    <div
                                      className={
                                        "CharacterEditorOptions" +
                                        (ActiveParts.Cap.data === null ||
                                          ActiveParts.Cap.data === "empty"
                                          ? " CharOptionsActive"
                                          : "")
                                      }
                                      onClick={() => CapRemove("Cap")}
                                    >
                                      <img
                                        className="emptyCharacter"
                                        src={
                                          "images/CharacterAssets/Empty_.svg"
                                        }
                                        alt=""
                                      />
                                    </div>
                                    {AssetData.Cap.map((lmc, index) => (
                                      <div
                                        key={"Cap" + index}
                                        className={
                                          "CharacterEditorOptions" +
                                          (ActiveParts.Cap.data === lmc.name
                                            ? " CharOptionsActive"
                                            : "")
                                        }
                                        onClick={() => ActiveCap(lmc.path)}
                                      >
                                        <img
                                          key={index}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                          }}
                                          src={lmc.path}
                                          alt=""
                                        />
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                <div>
                                  <div style={{ marginLeft: "19px" }}>
                                    Eye Wears
                                  </div>
                                  <div className="editScrollOptions">
                                    <div
                                      className={
                                        "CharacterEditorOptions" +
                                        (ActiveParts.Glasses.data === null ||
                                          ActiveParts.Glasses.data === "empty"
                                          ? " CharOptionsActive"
                                          : "")
                                      }
                                      onClick={() => RemoveAsset("Glasses")}
                                    >
                                      <img
                                        className="emptyCharacter"
                                        src={
                                          "images/CharacterAssets/Empty_.svg"
                                        }
                                        alt=""
                                      />
                                    </div>
                                    {AssetData.Glasses.map((lmc, index) => (
                                      <div
                                        key={"Glasses" + index}
                                        className={
                                          "CharacterEditorOptions" +
                                          (ActiveParts.Glasses.data === lmc.name
                                            ? " CharOptionsActive"
                                            : "")
                                        }
                                        onClick={() => ClotheClick(lmc.path)}
                                      >
                                        <img
                                          key={index}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                          }}
                                          src={lmc.path}
                                          alt=""
                                        />
                                      </div>
                                    ))}
                                  </div>{" "}
                                </div>
                                <div>
                                  <div style={{ marginLeft: "19px" }}>
                                    Face Wears
                                  </div>

                                  <div className="editScrollOptions">
                                    <div
                                      className={
                                        "CharacterEditorOptions" +
                                        (ActiveParts.Mask.data === null ||
                                          ActiveParts.Mask.data === "empty"
                                          ? " CharOptionsActive"
                                          : "")
                                      }
                                      onClick={() => RemoveAsset("Mask")}
                                    >
                                      <img
                                        className="emptyCharacter"
                                        src={
                                          "images/CharacterAssets/Empty_.svg"
                                        }
                                        alt=""
                                      />
                                    </div>
                                    {AssetData.Mask.map((lmc, index) => (
                                      <div
                                        key={"Mask" + index}
                                        className={
                                          "CharacterEditorOptions" +
                                          (ActiveParts.Mask.data === lmc.name
                                            ? " CharOptionsActive"
                                            : "")
                                        }
                                        onClick={() => ClotheClick(lmc.path)}
                                      >
                                        <img
                                          key={index}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                          }}
                                          src={lmc.path}
                                          alt=""
                                        />
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                <div>
                                  <div style={{ marginLeft: "19px" }}>
                                    Ear Wears
                                  </div>

                                  <div className="editScrollOptions">
                                    <div
                                      className={
                                        "CharacterEditorOptions" +
                                        (ActiveParts.EarWear.data === null ||
                                          ActiveParts.EarWear.data === "empty"
                                          ? " CharOptionsActive"
                                          : "")
                                      }
                                      onClick={() => RemoveAsset("EarWear")}
                                    >
                                      <img
                                        className="emptyCharacter"
                                        src={
                                          "images/CharacterAssets/Empty_.svg"
                                        }
                                        alt=""
                                      />
                                    </div>
                                    {AssetData.EarWear.map((lmc, index) => (
                                      <div
                                        key={"EarWear" + index}
                                        className={
                                          "CharacterEditorOptions" +
                                          (ActiveParts.EarWear.data === lmc.name
                                            ? " CharOptionsActive"
                                            : "")
                                        }
                                        onClick={() => ClotheClick(lmc.path)}
                                      >
                                        <img
                                          key={index}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                          }}
                                          src={lmc.path}
                                          alt=""
                                        />
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="ChrRi8Panel ">
                {" "}
                <div className="ChrRi8PanelInner2">
                  {" "}
                  <div className="characterEditorLeft">
                    {" "}
                    <div className="characterEditor">
                      {" "}
                      <div className="charEditorPreview">
                        <div
                          className={
                            props.canvZoom.width === "1000"
                              ? "chareditStart2"
                              : "chareditStart"
                          }
                        >
                          {props.canvZoom.width === "1000" && (
                            <canvas
                              ref={MainCanvas}
                              width={1000}
                              height={1262}
                              className={"ChrClass " + " chareditCanv"}
                            />
                          )}
                          {props.canvZoom.width !== "1000" && (
                            <>
                              <canvas
                                ref={MainCanvas}
                                width={1000}
                                height={1262}
                                className={"ChrClass " + "chareditCanv2"}
                              />
                            </>
                          )}
                          <canvas
                            width={100}
                            height={100}
                            className="character_canv"
                            style={{ display: "block", opacity: "0" }}
                          />
                        </div>

                        {props.TopActive === "Shirts" && (
                          <PopColorPicker
                            setActiveParts={setActiveParts}
                            canvZoom={props.canvZoom}
                            Play={Play}
                            setPlay={setPlay}
                            setNewJson={setNewJson}
                            get={get}
                            colorChange={props.colorChange}
                            setcolorChange={props.setcolorChange}
                            ActiveLeftBar={props.ActiveLeftBar}
                            CharacterJson={NewJson}
                            setActiveLeftBar={props.setActiveLeftBar}
                            keys={"PopColorPicker-1"}
                            colorPickers={ActiveParts.LowerTop}
                            ActiveParts={ActiveParts}
                            TopActive={props.TopActive}
                            Gender={props.Gender}
                          />
                        )}

                        {props.TopActive === "Sweaters" && (
                          <PopColorPicker
                            setActiveParts={setActiveParts}
                            canvZoom={props.canvZoom}
                            Play={Play}
                            setPlay={setPlay}
                            setNewJson={setNewJson}
                            get={get}
                            setActiveLeftBar={props.setActiveLeftBar}
                            keys={"PopColorPicker-2"}
                            CharacterJson={NewJson}
                            colorPickers={ActiveParts.MiddleTop}
                            ActiveParts={ActiveParts}
                            TopActive={props.TopActive}
                            Gender={props.Gender}
                            colorChange={props.colorChange}
                            setcolorChange={props.setcolorChange}
                            ActiveLeftBar={props.ActiveLeftBar}
                          />
                        )}
                        {props.TopActive === "Jackets" && (
                          <PopColorPicker
                            setActiveParts={setActiveParts}
                            canvZoom={props.canvZoom}
                            Play={Play}
                            setPlay={setPlay}
                            setNewJson={setNewJson}
                            get={get}
                            colorChange={props.colorChange}
                            setcolorChange={props.setcolorChange}
                            ActiveLeftBar={props.ActiveLeftBar}
                            setActiveLeftBar={props.setActiveLeftBar}
                            keys={"PopColorPicker-3"}
                            CharacterJson={NewJson}
                            colorPickers={ActiveParts.OuterTop}
                            ActiveParts={ActiveParts}
                            TopActive={props.TopActive}
                            Gender={props.Gender}
                          />
                        )}
                        {props.TopActive === "Bottoms" && (
                          <PopColorPicker
                            setActiveParts={setActiveParts}
                            canvZoom={props.canvZoom}
                            Play={Play}
                            setPlay={setPlay}
                            setNewJson={setNewJson}
                            get={get}
                            colorChange={props.colorChange}
                            setcolorChange={props.setcolorChange}
                            ActiveLeftBar={props.ActiveLeftBar}
                            setActiveLeftBar={props.setActiveLeftBar}
                            keys={"PopColorPicker-4"}
                            CharacterJson={NewJson}
                            colorPickers={ActiveParts.Bottom}
                            ActiveParts={ActiveParts}
                            TopActive={props.TopActive}
                            Gender={props.Gender}
                          />
                        )}
                        {props.TopActive === "Head" && (
                          <PopColorPicker
                            setActiveParts={setActiveParts}
                            canvZoom={props.canvZoom}
                            Play={Play}
                            setPlay={setPlay}
                            setNewJson={setNewJson}
                            get={get}
                            colorChange={props.colorChange}
                            setcolorChange={props.setcolorChange}
                            ActiveLeftBar={props.ActiveLeftBar}
                            setActiveLeftBar={props.setActiveLeftBar}
                            keys={"PopColorPicker-5"}
                            CharacterJson={NewJson}
                            colorPickers={ActiveParts.Face}
                            ActiveParts={ActiveParts}
                            TopActive={props.TopActive}
                            Gender={props.Gender}
                          />
                        )}

                        {props.TopActive === "Hair" && (
                          <PopColorPicker
                            setActiveParts={setActiveParts}
                            canvZoom={props.canvZoom}
                            Play={Play}
                            setPlay={setPlay}
                            setNewJson={setNewJson}
                            get={get}
                            colorChange={props.colorChange}
                            setcolorChange={props.setcolorChange}
                            ActiveLeftBar={props.ActiveLeftBar}
                            setActiveLeftBar={props.setActiveLeftBar}
                            keys={"PopColorPicker-6"}
                            CharacterJson={NewJson}
                            colorPickers={ActiveParts.Hair}
                            ActiveParts={ActiveParts}
                            TopActive={props.TopActive}
                            Gender={props.Gender}
                          />
                        )}

                        {props.TopActive === "Eyes" && (
                          <PopColorPicker
                            setActiveParts={setActiveParts}
                            canvZoom={props.canvZoom}
                            Play={Play}
                            setPlay={setPlay}
                            setNewJson={setNewJson}
                            get={get}
                            colorChange={props.colorChange}
                            setcolorChange={props.setcolorChange}
                            ActiveLeftBar={props.ActiveLeftBar}
                            setActiveLeftBar={props.setActiveLeftBar}
                            keys={"PopColorPicker-7"}
                            CharacterJson={NewJson}
                            colorPickers={ActiveParts.Eye}
                            ActiveParts={ActiveParts}
                            TopActive={props.TopActive}
                            Gender={props.Gender}
                          />
                        )}
                        <div className="uploadChar" onClick={() => { props.PopOptionsfun("face") }}>
                          <button className="UploadBtn" >
                            <span style={{ padding: '7px' }}>
                              Next
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {props.TopActive === "Gender" && (
          <>
            <div className="GenderSelection">
              <div className="GenderCenterlize">
                <div className="GenderTag">Select Character Gender</div>

                <div className="GenderSelectionParent">
                  {GenderSelection.map((lmc, index) => {
                    if (lmc.id === 1 || lmc.id === 2) {
                      lmc.display = "block";
                    } else {
                      lmc.display = "none";
                    }
                    return (
                      <GenderSelect
                        key={GenderSelection[index].id.toString()}
                        ids={GenderSelection.id}
                        names={lmc.name}
                        blackSvg={lmc.BandW_Svg}
                        status={lmc.status}
                        ColorSvg={lmc.ColorSvg}
                        setActiveGender={setActiveGender}
                        SelectedGender={SelectedGender}
                        setSelectedGender={setSelectedGender}
                        display={lmc.display}
                      />
                    );
                  })}
                </div>

                <div className="genderButtonUpper">
                  <div
                    className="genderButton"
                    onClick={() => {
                      if (ActiveGender !== "") {
                        props.setGender(ActiveGender);

                        props.setcharActive("Body");
                        props.setTopActive("Body");
                        getAssets(ActiveGender);
                        props.setCharacterName("Default");
                        props.setreadjson(false);
                        setActiveParts(ObjectHere);
                        getCharacterData(ActiveGender);
                      }
                    }}
                  >
                    <span
                      style={{
                        color: "#fff",
                        position: "relative",
                        right: "3px",
                      }}
                    >
                      Proceed
                    </span>

                    <span
                      className="material-icons-outlined"
                      style={{
                        position: "absolute",
                        right: "5px",
                        color: "#fff",
                      }}
                    >
                      navigate_next
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PopRightArea;
